import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import './../styles/Home.css'; // Tell webpack that Button.js uses these styles
import './../index.css';
import React, {Component, Fragment, useRef, useLayoutEffect} from 'react';


import blenderCommissionPublicKey from '../blenderData/blenderCommissionPublicKey.js';
import blenderTransfersToPublicKey from '../blenderData/blenderTransfersToPublicKey.js';
import { Chart } from 'react-google-charts';
import {isMobile} from 'react-device-detect';

import {
  LineChart,
  Bar,
  XAxis,
  YAxis,
  Line,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts";
import { Mosaic, OrbitProgress, ThreeDot } from "react-loading-indicators";

import awsconfig from '../aws-exports.js';
import { navigationHandler, routeProps } from '../utilities/navigator.js';
import LoadingIcons from 'react-loading-icons'
import blenderPrivateKey  from '../blenderData/generalPrivateKey.js';
import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms,  LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations.js';
import { Link, useParams } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css'
import { 
  Button, 
  ButtonContent,
  ButtonGroup,
  Modal, 
  Header, 
  Image, 
  Container,
  ListList,
  ListItem,
  ListIcon,
  Icon,
  Input,
  ListHeader,
  ListDescription,
  ListContent,
  List,
  FormField, 
  Form, 
  Radio,
} from 'semantic-ui-react';
import { ethers } from 'ethers';
import axios from 'axios';


import CampaignContract_latest from '../ethereum/build/latest/Campaign.json';
import CampaignFactoryContract_latest from '../ethereum/build/latest/CampaignFactory.json';
import BorrowingAccountMobileRender from './borrowingAccount/BorrowingAccountMobileRender.jsx';
import BorrowingAccountDesktopRender from './borrowingAccount/BorrowingAccountDesktopRender.jsx';

var primaryLanguage;

const Web3 = require('web3');
const CryptoJS = require("crypto-js");

var AWS = require('aws-sdk');

var mimemessage = require('mimemessage');


AWS.config.update({region:'us-east-1'});

const secretName = "PrivateBlenderKeys"
const region = 'us-east-1'

Amplify.configure(awsconfig);
Auth.configure(awsconfig);

var contractAddress;

var cognitoID;

var web3;
var highRateWeb3;

let client;

var campaign;
var publicKey;
var rand1;
var that; 
var blenderPercentCharge = 0.0500;

// Use the current Gnosis wallet balance and the transaction gas reserve.
// Platform commissions deducted within a contract transaction are not debited twice.
function spendableWalletUSD(balanceWei, gasPriceWei, gasLimit) {
  try {
    const wallet = ethers.BigNumber.from(String(balanceWei));
    const networkCost = ethers.BigNumber.from(String(gasPriceWei)).mul(String(gasLimit));
    const available = wallet.gt(networkCost) ? wallet.sub(networkCost) : ethers.constants.Zero;
    return Math.floor(Number(ethers.utils.formatEther(available)) * 100) / 100;
  } catch (error) {
    return 0;
  }
}


let primaryDisplayCurrency;
let secondaryDisplayCurrency;
let primaryDisplayPrice;
let secondaryDisplayPrice;
let forexJSON;

var contributeSignatureNeeded;

var thisDeploymentAddress;

var value;
var valueDelta;
let proposeGasPrice;
var displayValue;

var borrowerStatsArray = [];
var accountStatsArray = [];

var _payableValue
var _approversCt
var _web3Balance
var _targetValue
var _minLoan
var _blockchainBalance
var _totalWithdrawn
var _userContributed
var _userFinalized
var _totalPaid 
var _totalContributedWei
var _totalContributed 
var _approversLoanTotal 
var _borrowerInterestPaid 

var noDailyDataPointsFoundBool

var transactionValue;
var requests = []
var wishlist;
var wishlistIcon;

var contractReceipts;

var corporateBackedUsernamesArray

var emailAddress
var _txnSectionHelpText
var _approversLoanTotal
var _availableCreditReadyWithdraw
var _minLoan;
var _totalContributed;
var _balance;
var _dateCreated;
var _riskCoverage;
var _intRate;
var _offeredLenderCommissionUSD_adjusted
var managerDisplay;
var _openValue;
var _blenderScore;
var _fico;
var _totalLending;
var _totalBorrowing;
var _lentTotal;
var _borrowingRec;
var _loanRate;
var _withdrawalRate;
var _lendingRate;
var _repayRate;
var _joinDate;
var _repaymentTotal;
var _lenders;
var _currentUserContribution;

var _managerLCase
var _lookupKey
let _values = [
  { availableCredit: 0, name: 0 },
  { availableCredit: 0, name: 0 },
  { availableCredit: 0, name: 0 },
]

let _valuesONLY = ''
var dataIndexDayMap = {};
var _userAvgRating;
var _totalContributedWei;
var _totalWithdrawn;
var _userContributed;
var _userFinalized;
var _userInterestEarned;
var _approverReceivedRepaymentSum;
var _borrowerInterestPaid;
var _totalPaid;
var _reclaimableValue;
var _exitReclaimableValueWei;
var _safeReclaimableValueWei;
var _weiCompoundedBalance;
var _compoundedBalance;
var _canDeleteCreditLineBool;
var _compoundedBalanceWEI;
var netDebt;

var squareCustomerID;
var actionText;
var costText;
var buttonText;
var interactionHeader;
var actionButton;
var actionType;
let actionTypeStakingBool;
var contractAddress
var contractBalance;
var lenderCount;
var intRate;
var openValue;
var minLoan;
var totalPaid;
var totalWithdrawn;
var totalValue;
var availableCreditRatio;
var userRiskValue;
var riskCoveragePercentage;
var targetValue;
var blenderScore;
var fico;
var totalLending;
var totalBorrowing;
var repaidRec;
var borrowingRec;
var loanRate;
var withdrawalRate;
var lendingRate;
var repayRate;
var currentUser;
var managerUsername;
var userContributed;
var userFinalized;
var userInterestEarned;
var borrowerInterestPaid;
var openContracts;

let mediaMapArrayUserMap = {}

var tooltipInterval;
var formattedValueTooltipString
var maxDayValue
var minDayValue
var blacklisted;
var web3BalancePre;
var web3BalancePost;
var loanTarget;
var minimumContribution;
var interestRate;
var finalRequestsSum;
var repaymentSum;
var approverCheck;
var totalContributed;
var availableCredit;
var availableCredit_unadjusted;
var totalCreditMax;
var creditUtilizationPerc;
var approversCount;
var requestsCt;
var receiptsCt;
var approversList;
var approverReceivedRepaymentSum;
var manager;
var currentUserLoanTotal;
var userLiquidValuePre;
var userLiquidValue;
var userFinalizedRequestLoanSum;
var reclaimableValue;
var compoundedInterestPaid;
var compoundInterestReceived;
var insuranceTotal;
var imaginaryInsuranceTotal;
var conversionRateGlobal; 
var deploymentAddress;
var buttonColorFlashIntervalDefault;
var buttonColorFlashIntervalSecondary;
var contractStructureType;
var settlementDateFormatted;
var closureDateFormatted;
var offeredLenderCommissionUSD;
var isCorporateBondBool = false

let mediaArray;
let mediaArrayMap;
let firstName;
let lastName;
let phoneNumber;
let dob;
let ipAddress;
let streetAddress;
let fullAddress;

let loadingTextInterval;
let loadingTextIntervalCt = 0;



let thisContract_CampaignContract
let thisContract_CampaignFactoryContract














let monthLengtheningEnum = {
    JAN: 'January',
    FEB: 'February',
    MAR: 'March',
    APR: 'April',
    MAY: 'May',
    JUN: 'June',
    JUL: 'July',
    AUG: 'August',
    SEP: 'September',
    OCT: 'October',
    NOV: 'November',
    DEC: 'December',
}



// Read the collateral-backed credit enforced by Campaign.createRequest.
// A failed read is unknown, never a substitute liquidity-based balance.
async function readOnChainAvailableCredit(campaign) {
  try {
    const creditABI = [{
      constant: true,
      inputs: [],
      name: 'availableCredit',
      outputs: [{name: '', type: 'uint256'}],
      payable: false,
      stateMutability: 'view',
      type: 'function'
    }];
    const creditContract = new web3.eth.Contract(creditABI, campaign.options.address);
    const wei = await creditContract.methods.availableCredit().call();
    return (Number(wei) / 1e18).toFixed(2);
  } catch (error) {
    console.warn('On-chain available credit read failed:', error?.message || error);
    return '';
  }
}

class BorrowingAccountComponent extends Component {

  constructor() {
      super()


      this.state = {
        uniqueValue: 1,
        contractAction: '-',
        requests: [],
        confirmActionPopUp: false,     
        showOverlay: false,   
        password: null,
        signInPressedBool: false,
        showPasswordOverlay: false,
        expandTxnAreaBool: false,
        rescindDepleteWarningOverlay: false,
        verifyIDOverlay: false,
        forceVerifyIDOverlay: false,
        rescindExitWarningOverlay: false,
        insufficientRescindWarningOverlay: false,
        confirmDeleteCreditLineOverlay: false,
        webViewOverlay: false,
        warningCannotDeleteCreditLineOverlay: false,
        imaginaryCollateralAlertOverlay: false,
        liquidRealCollateralAlertOverlay: false,
        statExplanationOverlay: false, 
        ActivityIndicator: true,
        generalNoticeOverlay: false,
        
        showPageLoader: true,
        wishlistIcon: 'ios-radio-button-on',
        star1: 'md-star-outline',
        star2: 'md-star-outline',
        star3: 'md-star-outline',
        star4: 'md-star-outline',
        star5: 'md-star-outline',
        submitButtonText: 'Submit',
        disableWhileTxn: false,
        approverCheck: false,
        reclaimMoreInfo: null,
        isManager: false,
        moneyTransactionPreset: null,
        managerUsername: '',
        currentUser: '',
        lenderCountColor: 'rgba(60, 55, 66, .95)',
        postRescindApproverStatus: null,
        transactionKiosk: null,
        blacklisted: false,
        addWhitelist: null,
        whitelistCt: 0,
        primaryDisplayPrice: 0,
        secondaryDisplayPrice: 0,
        primaryDisplayCurrency: ' ',
        secondaryDisplayCurrency: ' ',
        initialTooltipIndex: 90, 
        forexJSON: null,
        _values: [
          { availableCredit: 0, name: 0 },
          { availableCredit: 0, name: 0 },
          { availableCredit: 0, name: 0 },
        ],
        maxDayValue: 500,
        minDayValue: 0,
        dataIndexDayMap: {},
        formattedValueTooltipString: '                          ',
        lenderCount: null,
        intRate: null,
        openValue: null,
        minLoan: null,
        totalValue: null,
        userContributed: null,
        userFinalized: null,
        userInterestEarned: null,
        borrowerInterestPaid: null,
        availableCreditRatio: null,
        availableCredit: null,
        riskCoveragePercentage: null,
        userRiskValue: null,
        targetValue: null,
        totalPaid: null,
        totalWithdrawn: null,
        blenderScore: null,
        fico: null,
        totalLending: null,
        totalBorrowing: null,
        repaidRec: null,
        borrowingRec: null,
        loanRate: null,
        withdrawalRate: null,
        lendingRate: null,
        repayRate: null,
        managerHeader: null,
        contractReceipts: [],

        actionInitButtonBackgroundColor: 'rgba(0, 158, 129, 1)',
        confirmButtonBackgroundColor: 'rgba(0, 158, 129, 1)',
        confirmSignatureButton: 'rgba(0, 158, 129, 1)',
  
        flashButtonBackgroundColor1: 'rgba(0, 158, 129, 1)',
        flashButtonBackgroundColor2: 'rgba(0, 158, 129, 1)',
        flashButtonBackgroundColor3: 'rgba(0, 158, 129, 1)',
  
        flashButtonTextColor1: 'rgba(240, 230, 244, 0.7)',
        flashButtonTextColor2: 'rgba(240, 230, 244, 0.7)',
        flashButtonTextColor3: 'rgba(240, 230, 244, 0.7)',
        
        flashButtonBorderTopWidth1: 0.3, 
        flashButtonBorderTopWidth2: 0.3, 
        flashButtonBorderTopWidth3: 0.3, 
  
        flashButtonBorderBottomWidth1: 2, 
        flashButtonBorderBottomWidth2: 2, 
        flashButtonBorderBottomWidth3: 2, 
  
        signatureJPG_Base64: null,
        alreadyVerified: true,
        successOverlay: false,
        successSubscriberSavingsOverlay: false,
        redirectingOverlay: false,
        helpGuideOverlay: false,
        settingsOverlay: false,
        helpCompleteOverlay: false,
        txnSectionHelpText: '',
        isCorporateBondBool: false,
        expandStatWindow: 515,
        borrowerStatsArray: [],
        accountStatsArray: [],
        dataIndexDayMap: {},
        _safeReclaimableValueWei: 0,
        _exitReclaimableValueWei: 0,
        contractTypeDescription1: '',
        contractTypeDescription2: '',
        headerColor: 'rgba(256, 256, 256, 1)',
        headerTextColor: 'rgba(26, 4, 60, .95)',
        inWishlistBool: false,
        refreshingIconBool: false,
        showPass: true,
        press: false,
        freezeButtonsNoVerify: true,
        managerFullName: null,
        thirtyDaysAgoDate: '',
        chartDayRange: 90,
        timePeriodString: '90 Día',
        disableChangeChartDayRange: false,
        whitelistExistsBool: false,
        contributeSignatureNeeded: true,
        fundWalletPromptOverlay: false,
        socialOverlay: false,
        moneyTransferOverlay: false,
        statDesc: null,
        statName: null,
        statValue: null,
        statColor: null,
        webViewPreviewURL: '',
        statExplanationOverlay: false,
        collateralIncreaseOverlay: false,
        collateralToAddUSD: null,
        collateralAssistanceRequestedUSD: null,
        allZeroDayValuesBool: true,
        collateralRequestOverlay: false,
        renameCreditLineOverlay: false,
        isVerifiedRegistryAcceptedBool: false,
        pendingCollateralRequestStillWaitingOverlay: false,
        deniedCollateralRequestStillWaitingOverlay: false,
        successfulCollateralRequestOverlay: false,
        allowsVerifiedRegistryCollateralInsurance: false,
        actionButton,
        noDebtToRepayOverlay: false,
        closeContractBoolOverlay: false,
        closeContractBool: false,
        _canDeleteCreditLineBool: false,
        _compoundedBalance: 0,
        stakerCollateralIncreaseOverlay: false,
        stakeSignatureNeeded: false,
        actionTypeStakingBool: false,
        isImaginaryCollateralBool: false,
        passwordIsHiddenBool: true,
  
        socialOverlayData_username: '',
        socialOverlayData_fullName: '',
        socialOverlayData_imageURI: null,
        socialOverlayData_bioString: '',
        socialOverlayData_contractAddress: null,
        mediaMapArrayUserMap: {},
        mediaMapArray: [],
        commentViewerMediaFileName: null,
        commentIsWritingMediaFileName: null,
        fullScreenViewerURI: null,
        commentInitMediaFileName: null,
        newCommentStringInput: null,
        commentReplyID: null,
        socialOverlayData_weblink1: null,
        socialOverlayData_weblink2: null,
        socialOverlayData_weblink3: null,
        newContractNameText: null, 
        webViewURI: null,
        doResetTooltipBool: true,
        x: 0,
        y: 0,
        
        likedMediaItemMap: {},     
        selectedLanguage: null,
  
  
        isSubscribedCurrentBool: false,
  
        uniqueCommissionIntegerPCT: 1000,
  
        contributeCommissionIntegerPCT: 1000,
        repayCommissionIntegerPCT: 1000,
        rescindCommissionIntegerPCT: 1000,
        withdrawCommissionIntegerPCT: 1000,
        
        managerDisplayName: '',
        loadingTextFlashingBool: false,
  
        subscriptionSavingUSD: null,
        generalNoticeTimedOverlay: false,
        generalNoticeOverlay: false,
        generalNoticeTwoOptionOverlay: false,
        currentUserProfilePicture: null,
        pendingTransactionLoaderOverlay: false,

        _targetValue: null,
        // Display-only amounts for the selected credit line, from one on-chain summary.
        displayCreditLimitUSD: null,
        displayAvailableCreditUSD: null,
        realCollateralWei: null,
        availableCredit: null,
        _intRate: null,
        selectedLanguage: null,
        mode_light_dark: null,
        currentUser: null,
        errorTags: null,
        transactionConfirmationMessage: '',
        moneyTransactionLiveValue: '',
        availableRewards: '0',

        walletBalanceWeiUSD: null,
      }

      that = this

      
      

      web3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosischain.com/"));
      highRateWeb3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosis.gateway.fm"));

      trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
        currentUser = res.username
        cognitoID = res.signInUserSession.idToken.jwtToken

      })
  }

  changeChartDayRange(){
    _values = [
      { availableCredit: 0, name: 0 },
      { availableCredit: 0, name: 0 },
      { availableCredit: 0, name: 0 },
    ];

    const { chartDayRange } = that.state

    that.setState({
      disableChangeChartDayRange: true,
    })

    function updateDayRangeStartText(chartDayRange){
      var today = new Date()
      var priorDate = new Date().setDate(today.getDate()-chartDayRange)
      var formattedPriorDate = new Date(priorDate)
      formattedPriorDate = String(formattedPriorDate)
      formattedPriorDate = formattedPriorDate.substr(4, 11);
      formattedPriorDate = formattedPriorDate.substr(0,6).concat(', ').concat(formattedPriorDate.substr(7,5))

      that.loadPage(1, true, false)

      that.setState({
        thirtyDaysAgoDate: formattedPriorDate,
      })
    }

    let newChartDayRange

    switch(chartDayRange) {
      case 30:
          newChartDayRange = 90
          that.setState({
            chartDayRange: newChartDayRange,
            timePeriodString: that.state.selectedLanguage == 'spanish' ? '90-Día' : '90-Day' ,
          }, () => {
            updateDayRangeStartText(newChartDayRange)
          })
          break;
      case 90:
          newChartDayRange = 180
          that.setState({
            chartDayRange: newChartDayRange,
            timePeriodString: that.state.selectedLanguage == 'spanish' ? '6-Mes' : '6-Month' ,

          }, () => {
            updateDayRangeStartText(newChartDayRange)
          })
          break;
      case 180:
          newChartDayRange = 365
          that.setState({
            chartDayRange: newChartDayRange,
            timePeriodString: that.state.selectedLanguage == 'spanish' ? '1-Año' : '1-Year' ,
          }, () => {
            updateDayRangeStartText(newChartDayRange)
          })
          break;
      case 365:
          newChartDayRange = 365*3
          that.setState({
            chartDayRange: newChartDayRange,
            timePeriodString: that.state.selectedLanguage == 'spanish' ? '3-Año' : '3-Year',
           }, () => {
            updateDayRangeStartText(newChartDayRange)
          })
          break;
      case 365*3:
          newChartDayRange = 30
          that.setState({
            chartDayRange: newChartDayRange,
            timePeriodString: that.state.selectedLanguage == 'spanish' ? '30-Día' : '30-Day' ,
          }, () => {
            updateDayRangeStartText(newChartDayRange)
          })
          break;
      default:
          break;
    }

  } 

  componentDidMount() {

    if(isMobile){
      // window.open("https://lenderblockcorp.com/blenderplatform","_self")
    }
  
    const { navigation } = that.props;

    contractAddress = that.props.contractAddress
    this._creditDisplayMounted = true;

    that.setState({
      selectedLanguage: localStorage.getItem('primaryLanguage'),
      mode_light_dark: localStorage.getItem('mode_light_dark'), 
      managerDisplayName: '',
      errorTags: null,
      pendingTransactionLoaderOverlay: false,
    })

      
      loadingTextInterval = setInterval(() => {
        loadingTextIntervalCt += 1;
        if(loadingTextIntervalCt % 5 == 0){
          that.setState({
            loadingTextFlashingBool: false
          })
        } else {
          that.setState({
            loadingTextFlashingBool: true
          })
        }
      }, 2000)


      if(tooltipInterval){
        clearInterval(tooltipInterval);
      }
      tooltipInterval = setInterval(() => {
        that.setState({
          formattedValueTooltipString
        })
      }, 100)
      trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
        currentUser = res.username

        cognitoID = res.signInUserSession.idToken.jwtToken
          that.setState({
            currentUser
          })
          






          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'contractLookup', 
              primaryKey: contractAddress, 
              requestOperation: 'get',
            }
          }).then(contractLookupResponse => {
            contractAddress = String(contractLookupResponse.Item.contractAddress)

            // Match the native credit-line cards. Read the *same* on-chain
            // snapshot for both amounts and keep it separate from the mutable
            // graph/transaction variables that are refreshed asynchronously.
            const displayContractAddress = contractAddress;
            const displayRouteAddress = String(this.props.contractAddress).toLowerCase();
            const displayRequestId = (this._creditDisplayRequestId || 0) + 1;
            this._creditDisplayRequestId = displayRequestId;
            this.setState({
              displayCreditLimitUSD: null,
              displayAvailableCreditUSD: null,
            });
            const displayContract = new web3.eth.Contract(
              CampaignContract_latest.abi,
              displayContractAddress
            );
            trackPageRequest(readOnChainAvailableCredit(displayContract))
              .then((creditUSD) => {
                if (!this._creditDisplayMounted ||
                    this._creditDisplayRequestId !== displayRequestId ||
                    String(this.props.contractAddress).toLowerCase() !==
                      displayRouteAddress) return;
                this.setState({ displayAvailableCreditUSD: creditUSD });
              })
              .catch((error) => {
                console.warn('Credit-line display unavailable:', error?.message || error);
              });

            that.checkLenderblockSubscriberStatus()

            if(true){

              var today = new Date()
              var priorDate = new Date().setDate(today.getDate()-that.state.chartDayRange)
              var formattedPriorDate = new Date(priorDate)
              formattedPriorDate = String(formattedPriorDate)
              formattedPriorDate = formattedPriorDate.substr(4, 11);
              formattedPriorDate = formattedPriorDate.substr(0,6).concat(', ').concat(formattedPriorDate.substr(7,5))


              that.setState({
                socialOverlayData_imageURI: null,
                socialOverlayData_bioString: '',
                socialOverlayData_weblink1: null,
                socialOverlayData_weblink2: null,
                socialOverlayData_weblink3: null,
                socialOverlayData_fullName: '',
                likedMediaItemMap: {},
                contractReceipts: [],
                expandStatWindow: 515,
                accountStatsArray,
                showPageLoader: true,
                realCollateralWei: null,
                thirtyDaysAgoDate: formattedPriorDate,
                contributeSignatureNeeded: true,
                _values: [
                  { availableCredit: 0, name: 0 },
                  { availableCredit: 0, name: 0 },
                  { availableCredit: 0, name: 0 },
                ],
              })
              

              clearInterval(buttonColorFlashIntervalDefault)
              clearInterval(buttonColorFlashIntervalSecondary)

              that.setState({
                currentUser
              })
              that.initialMountComponents()


              let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

              that.setState({
                currentUserProfilePicture: profilePicture_uri
              })

              Storage.get(
                `${currentUser.toLowerCase()}/profilePicture.jpg`,
                {
                    bucket: "platform-user-media-uploads",
                    level: "public"
                }
              ).then((res) => {
                trackPageRequest(fetch(
                  res
                )).then((image) => {
                  if(image.status == 200){
                    profilePicture_uri = res;
                  }
                  that.setState({
                    currentUserProfilePicture: profilePicture_uri
                  })
                })
              })


              authenticatedPut('api1169ba1e', '', { 
                headers: { Authorization: `Bearer ${cognitoID}` },
                body: { 
                  category: 'db',
                  tableName: 'general', 
                  primaryKey: 'xdaiGasOracle', 
                  requestOperation: 'get',
                }
              }).then((xdaiGasOracle) => {
                proposeGasPrice = Number(xdaiGasOracle.Item.xdaiGasOracle.fast) * 1000000000
              })


            }
          })
      }).catch((err) => {
        trackPageRequest(Auth.signOut())
        that.setState({
          navigationDestinationObject: {
              navigationRoute: '/welcome',
          },
        }) 
      })
  }

  initialMountComponents(){
    
    that.setState({
      showPageLoader: true,
      actionInitButtonBackgroundColor: 'rgba(0, 158, 129, 1)', 
      confirmButtonBackgroundColor: 'rgba(0, 158, 129, 1)',
      confirmSignatureButton: 'rgba(0, 158, 129, 1)',
      signatureJPG_Base64: null,
      alreadyVerified: true,
      helpGuideOverlay: false,
      helpCompleteOverlay: false,
      settingsOverlay: false,
      socialOverlay: false,
      moneyTransferOverlay: false,
      txnSectionHelpText: '',
      showPass: true,
      press: false,
      chartDayRange: 90,
      initialTooltipIndex: 90, 
      fundWalletPromptOverlay: false,
      timePeriodString: that.state.selectedLanguage == 'spanish' ? '90-Día' : '90-Day' ,
      statDesc: null,
      statName: null,
      statValue: null,
      statColor: null,
      statExplanationOverlay: false,
      collateralIncreaseOverlay: false,
      stakerCollateralIncreaseOverlay: false,
      collateralRequestOverlay: false,
      renameCreditLineOverlay: false,
      noDebtToRepayOverlay: false,
      pendingCollateralRequestStillWaitingOverlay: false,
      deniedCollateralRequestStillWaitingOverlay: false,
      successfulCollateralRequestOverlay: false,
      collateralToAddUSD: null,
      collateralAssistanceRequestedUSD: null,
      allZeroDayValuesBool: true,      
      isVerifiedRegistryAcceptedBool: false,
      allowsVerifiedRegistryCollateralInsurance: false,
      closeContractBool: false,
      closeContractBoolOverlay: false,
      imaginaryCollateralAlertOverlay: false,
      liquidRealCollateralAlertOverlay: false,
      generalNoticeOverlay: false,
      
      _compoundedBalance: 0

    })

    firstName = null
    lastName = null
    phoneNumber = null
    dob = null
    ipAddress = null
    fullAddress = null


    trackPageRequest(Auth.currentSession()).then((res) => {
     
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'us-east-1:8973ceec-5da3-423f-b3c6-e31ebdc08ce8',
        Logins: { 
          'cognito-idp.us-east-1.amazonaws.com/us-east-1_vS08WURWh': res.idToken.jwtToken,
        }
      })

      AWS.config.credentials.refresh((error) => {
        if (error) {
          return error
        }
      });
      
      AWS.config.credentials.get(function() {
        var accessKeyId = AWS.config.credentials.accessKeyId;
        var secretAccessKey = AWS.config.credentials.secretAccessKey;
        var sessionToken = AWS.config.credentials.sessionToken;
        AWS.config.update({
          accessKeyId: accessKeyId,
          secretAccessKey: secretAccessKey,
          sessionToken: sessionToken
        })
      })

      client = new AWS.SecretsManager({
        region: region,
      });  

    })


    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
        category: 'db',
        tableName: 'contracts', 
        primaryKey: contractAddress, 
        requestOperation: 'get',
      }
    }).then(response => {

      managerUsername = response.Item.managerUsername
      that.setState({
        managerUsername,
        managerDisplayName: String(managerUsername).toUpperCase(),
        moneyTransactionPreset: String(that.state.managerUsername).toLowerCase() != String(that.state.currentUser).toLowerCase() ? 'lend' : 'repay'
      })

      switch (thisDeploymentAddress) {
        case '':
          thisContract_CampaignContract = CampaignContract_latest;
          thisContract_CampaignFactoryContract = CampaignFactoryContract_latest;
          break;
        default:
          thisContract_CampaignContract = CampaignContract_latest;
          thisContract_CampaignFactoryContract = CampaignFactoryContract_latest;
          break;
      }


      campaign = new web3.eth.Contract( 
        thisContract_CampaignContract.abi,
        contractAddress
      );

      campaign.methods.deploymentAddress().call()
        .then((_deploymentAddress) => {

          thisDeploymentAddress = _deploymentAddress


          if(response.Item.hasOwnProperty('contractStructure')){
            if(response.Item.contractStructure.toLowerCase() == 'creditLine'.toLowerCase()){
              contractStructureType = 'creditLine'
              settlementDateFormatted = 'null'
              closureDateFormatted = 'null'
              offeredLenderCommissionUSD = 'null'
            }
          } else {
            contractStructureType = 'creditLine'
          }

          // that.setInitialChartDayRange()

          _values = [
            { availableCredit: 0, name: 0 },
            { availableCredit: 0, name: 0 },
            { availableCredit: 0, name: 0 },
          ];

          that.setState({
            _values
          })

          
          trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
            currentUser = res.username

            cognitoID = res.signInUserSession.idToken.jwtToken 
      

              authenticatedPut('api1169ba1e', '', { 
                headers: { Authorization: `Bearer ${cognitoID}` },
                body: { 
                  category: 'db',
                  tableName: 'users', 
                  primaryKey: currentUser, 
                  requestOperation: 'get',
                }
              }).then((userData) => {

              firstName = userData.Item.firstName
              lastName = userData.Item.lastName
              phoneNumber = userData.Item.phone
              dob = userData.Item.dob
              ipAddress = userData.Item.ipAddress
              streetAddress = userData.Item.streetAddress

              primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
              secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
            
              that.setState({
                primaryDisplayCurrency,
                secondaryDisplayCurrency
              })
                  
                        let price_usd = 1;
                    
                        that.setState({ 
                          confirmActionPopUp: false,
                          actionValue: null,
                          showPasswordOverlay: false,
                          verifyIDOverlay: false,
                          forceVerifyIDOverlay: false,
                          rescindDepleteWarningOverlay: false,
                          rescindExitWarningOverlay: false,
                          insufficientRescindWarningOverlay: false,
                          confirmDeleteCreditLineOverlay: false,
                          warningCannotDeleteCreditLineOverlay: false,
                          generalNoticeOverlay: false,
                          
                          showOverlay: false,
                          activityIndicator: null,
                          switch: 1,
                          star1: 'md-star-outline',
                          star2: 'md-star-outline',
                          star3: 'md-star-outline',
                          star4: 'md-star-outline',
                          star5: 'md-star-outline',
                          ratingDescription: null,
                          disableWhileTxn: false,
                          price_usd,
                          reclaimMoreInfo: null,
                          isManager: false,
                          lenderCountColor: 'rgba(60, 55, 66, .95)',
                          transactionKiosk: null,
                          blacklisted: false,
                          addWhitelist: null,
                          whitelistCt: 0,
                          confirmActionPopUpComponent: null,
                        })


                        that.mountingFunction()

              })
            

          })
        })
    })
  }

  mountingFunction(){

    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username

      cognitoID = res.signInUserSession.idToken.jwtToken




        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: currentUser, 
            requestOperation: 'get',
          }
        }).then((response) => {
          publicKey = response.Item.publicKey
          wishlist = response.Item.wishlist
          contractAddress = contractAddress
          squareCustomerID = response.Item.squareCustomerID
          
          emailAddress = response.Item.emailAddress
          openContracts = response.Item.openContracts


          trackPageRequest(web3.eth.getBalance(publicKey))
          .then((balance) => { 
            let walletBalanceWeiUSD = balance;
            that.setState({
              walletBalanceWeiUSD
            })
          })
          
          _values = [
            { availableCredit: 0, name: 0 },
            { availableCredit: 0, name: 0 },
            { availableCredit: 0, name: 0 },
          ];
          
          if(wishlist.includes(contractAddress)){
            that.setState({
              inWishlistBool: true
            })
          } else {
            that.setState({
              inWishlistBool: false
            })
          }
          trackPageRequest(web3.eth.getBalance(contractAddress))
            .then((balance) => { 
              contractBalance = balance;
            })
            
          campaign = new web3.eth.Contract( 
            thisContract_CampaignContract.abi,
            contractAddress
          );

          // Presentation only: match the mobile Credit Limit card's live collateral source.
          // The configured loanTarget can include non-monetary/imaginary collateral.
          const collateralDisplayAddress = String(contractAddress).toLowerCase();
          if (campaign.methods.totalCollateral) {
            campaign.methods.totalCollateral().call()
              .then((collateralWei) => {
                if (String(contractAddress).toLowerCase() === collateralDisplayAddress) {
                  that.setState({
                    realCollateralWei: String(collateralWei),
                    displayCreditLimitUSD: ethers.utils.formatEther(
                      ethers.BigNumber.from(String(collateralWei))
                    ),
                  });
                }
              })
              .catch((error) => {
                console.warn('Credit line real collateral display unavailable:', error?.message || error);
              });
          }

          let isImaginaryCollateralBool = false;
          campaign.methods.isImaginaryCollateralBool().call()
            .then((res) => {
              isImaginaryCollateralBool = res
              that.setState({
                isImaginaryCollateralBool
              })
            }).catch((err) => {}).then(() => {
            
              campaign.methods.closeContractBool().call()
                .then((res) => {
                  let closeContractBool = res

                  if(closeContractBool){
                    that.setState({
                      disableWhileTxn: closeContractBool,
                      closeContractBool,
                    })
                  }

                  campaign.methods.getSummary1().call()
                    .then(async (res) => {
                      web3BalancePost = Number(res[0])
                      loanTarget = Number(res[1])
                      minimumContribution = Number(res[2])
                      interestRate = res[3]
                      finalRequestsSum = Number(res[4])
                      repaymentSum = Number(res[5])
                      totalContributed = Number(res[6])
                      approversCount = res[7]
                      requestsCt = res[8]
                      receiptsCt = res[9]
                      approversList = res[10]
                      manager = res[11]
                      insuranceTotal = res[12]
                      compoundedInterestPaid = res[13]                      
                      


                  
                          let dateStampCheck = []
                          contractReceipts = []
                          for(let i=0; i<=receiptsCt-1; i++){
                            campaign.methods.receipts(i).call()
                              .then((receipt) => {
                                  let txnType = receipt.transactType
                                  let user = receipt.user
                                  let receiptValue = receipt.value
                  
                  
                                  authenticatedPut('api1169ba1e', '', { 
                                    headers: { Authorization: `Bearer ${cognitoID}` },
                                    body: { 
                                      category: 'db',
                                      tableName: 'wallet_username', 
                                      primaryKey: user, 
                                      requestOperation: 'get',
                                    }
                                  }).then((wallet_user) => {
                  
                                    if(wallet_user.hasOwnProperty('Item')){

                                      let username = String(wallet_user.Item.username).toUpperCase()

                                      let id = String(receipt.date, 10).concat(String(receiptValue)).concat(user)
                                      let dateSecs = receipt.date
                                      let receiptDate = String(new Date(parseInt(receipt.date, 10)*1000))
                                      receiptDate = receiptDate.substring(4,15)
                                      receiptDate = receiptDate.substr(0, receiptDate.length-5) + ',' + receiptDate.substr(receiptDate.length-5)
                                      receiptDate = receiptDate.substr(0,3) + '.' + receiptDate.substr(3, receiptDate.length-1)
                                      receiptValue = ((parseFloat(receiptValue, 10))/1000000000000000000).toFixed(2)
                                      if(txnType == 'contr'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Contribución' : 'Contribution'
                                      } else if(txnType == 'payment'){
                                        if(username.toUpperCase() == that.state.managerUsername.toUpperCase()){
                                          txnType = that.state.selectedLanguage == 'spanish' ? 'Pago Dado' : "Pymnt Given"
                                        } else {
                                          txnType = that.state.selectedLanguage == 'spanish' ? 'Pago Recib.' : "Pymnt Recvd"
                                        }
                                      } else if(txnType == 'lenderInsured'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Prest. Seguro' : "Lender Insured"
                                      } else if(txnType == 'approval'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Aprobada' : "Approval"
                                      } else if(txnType == 'resc'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Reclamar' : 'Reclaim'
                                      } else if(txnType == 'collateralIncrease'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Colateral' : 'Collateral'
                                      } else if(txnType == 'closeContract collateral assistance repayment'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Reclamar V.R.' : 'V.R. Claim'
                                      }  else if(txnType == 'closeContract commission payment'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Disolución' : 'Term. Fee'
                                      }  else if(txnType == 'closeContract borrower collateral reimbursement'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Reemb. Colateral' : 'Coll. Reimb.'
                                      } else if(txnType == 'collateralIncrease_byStaker'){
                                        txnType = that.state.selectedLanguage == 'spanish' ? 'Apostate' : 'Stake'
                                      } else if(txnType == 'closeContract'){
                                        if(username == String(that.state.managerUsername).toLowerCase()){
                                          if(Number(receiptValue) > 0){
                                            txnType = that.state.selectedLanguage == 'spanish' ? 'Devolv. Colat.' : 'Collat. Return'
                                          } else {
                                            txnType = that.state.selectedLanguage == 'spanish' ? 'Cuenta Cerrada' : 'Lined Closed'
                                          }
                                        } else {
                                          txnType = that.state.selectedLanguage == 'spanish' ? 'Devolv. cClat.' : 'Collat. Return'
                                        }
                                      } else if(txnType == 'withdrawal'){
                                        if(that.state.managerUsername.toLowerCase() == username.toLowerCase()){
                                          txnType = that.state.selectedLanguage == 'spanish' ? 'Prest. Retir.' : 'Loan Wthdrwn'
                                        } else {
                                          txnType = that.state.selectedLanguage == 'spanish' ? 'Prest. Dado' : 'Loan Given'
                                        }
                                      }
                    
                                      // if(username.length > 6){
                                      //   username =  username.substring(0,6)+'..'
                                      // }
                    
                                      let elapsedDays = Math.floor(Date.now() - Number(dateSecs)*1000)/86400000
                            
                    
                                      if(!dateStampCheck.includes([String(dateSecs), username]) && that.state.chartDayRange >= elapsedDays){
                                          // if(actionTypeFilteredIn.length == 0){
                                              dateStampCheck.push([String(dateSecs), username])
                                              contractReceipts.push({
                                                  txnType,
                                                  username,
                                                  receiptValue,
                                                  receiptDate,
                                                  dateSecs,
                                                  id,
                                                  contractAddress,
                                                  iconComp: 'USD'
                                              })
                                          // } else if (actionTypeFilteredIn.includes(txnType.toLowerCase())){
                                        
                                          //     dateStampCheck.push([String(dateSecs), username])
                                          //     contractReceipts.push({
                                          //         txnType,
                                          //         username,
                                          //         receiptValue,
                                          //         receiptDate,
                                          //         dateSecs,
                                          //         id,
                                          //         contractAddress,
                                          //         iconComp: 'USD'
                                          //     })
                                          // } else {
                                          //     dateStampCheck.push([String(dateSecs), username])
                                          // } 
                                      } else {
                                          dateStampCheck.push([String(dateSecs), username])
                                      }
                    
                                      let contractReceiptsCount = contractReceipts.length
                                      contractReceipts.sort((a, b) => (a.dateSecs < b.dateSecs) ? 1 : -1)
                    
                                      that.setState({
                                        contractReceipts,
                                        contractReceiptsCount,
                                      })
                                    }
                                  })
                              })
                          }
                  
                        














                      if(!approversList.includes(publicKey)){
                        that.setState({
                          contributeSignatureNeeded: true
                        })
                      } else {
                        that.setState({
                          contributeSignatureNeeded: false
                        })                        
                      }

                      availableCredit = await readOnChainAvailableCredit(campaign);
                      // Missing reads remain blank, rather than displaying liquidity as credit.
                      
                      that.setState({
                        availableCredit
                      })

                      campaign.methods.getSummary2(publicKey).call() 
                        .then((res) => {

                          currentUserLoanTotal = Number(res[0])
                          userLiquidValue = Number(res[1])
                          userFinalizedRequestLoanSum = Number(res[2])
                          approverCheck = res[3]
                          reclaimableValue = Number(res[4])
                          compoundInterestReceived = Number(res[5])

                          if(approverCheck == true){
                            that.setState({ lenderCountColor: 'rgba(0, 158, 129, .9)' })
                          }





                          that.fixIssue()



                          if(!(
                            contractAddress == '0xc1a99a9B75A5Cf8B422B7dbEe3F142B8cF9B8772' 
                          )){
                        
                            that.setState({ 
                              currentUser,
                              actionValue: null,
                              approverCheck,
                              submitButtonText: 'Submit'
                            })

                            authenticatedPut('api1169ba1e', '', { 
                              headers: { Authorization: `Bearer ${cognitoID}` },
                              body: { 
                                category: 'db',
                                tableName: 'verifiedRegistryApplications', 
                                primaryKey: currentUser, 
                                requestOperation: 'get',
                              }
                            }).then((verifiedRegistryApp) => {

                              if(verifiedRegistryApp.hasOwnProperty('Item')){
                                if(verifiedRegistryApp.Item.hasOwnProperty('applicationStatus')){
                                  let verifiedRegistryApplicationStatus = String(verifiedRegistryApp.Item.applicationStatus)

                                  if(verifiedRegistryApplicationStatus.toLowerCase() == 'activated'){
                                    that.setState({
                                      isVerifiedRegistryAcceptedBool: true
                                    })
                                  } else {
                                    that.setState({
                                      isVerifiedRegistryAcceptedBool: false
                                    })
                                  }
                                } else {
                                  that.setState({
                                    isVerifiedRegistryAcceptedBool: false
                                  })
                                }
                              } else {
                                that.setState({
                                  isVerifiedRegistryAcceptedBool: false
                                })
                              }
                            

                              authenticatedPut('api1169ba1e', '', { 
                                headers: { Authorization: `Bearer ${cognitoID}` },
                                body: { 
                                  category: 'db',
                                  tableName: 'contracts', 
                                  primaryKey: contractAddress, 
                                  requestOperation: 'get',
                                }
                              }).then(response => {
                                var contracts = response.Item

                                _managerLCase = contracts.managerUsername.toLowerCase()



                                that.setState({
                                  expandStatWindow: currentUser != _managerLCase ? 540 : 525,
                                  accountStatsArray,
                                  managerUsername: _managerLCase,
                                  webViewPreviewURL: '',
                                })

                                _lookupKey = contracts.lookupKey

                                let deletedWithdrawalRequestIndexArray = contracts.deletedWithdrawalRequestIndexArray

                                let profilePicture_base64 = null;
                                let profilePicture_uri = null;
                                let bioString = null
                                let weblink1 = null;
                                let weblink2 = null;
                                let weblink3 = null;

                                profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${_managerLCase.toLowerCase()}`;

                                Storage.get(
                                  `${_managerLCase.toLowerCase()}/profilePicture.jpg`,
                                  {
                                      bucket: "platform-user-media-uploads",
                                      level: "public"
                                  }
                                ).then((res) => {
                                  trackPageRequest(fetch(
                                    res
                                  )).then((image) => {
                        
                                    if(image.status == 200){
                                      profilePicture_uri = res;
                                    }

                                    authenticatedPut('api1169ba1e', '', { 
                                      headers: { Authorization: `Bearer ${cognitoID}` },
                                      body: {  
                                          category: 'db',
                                          tableName: 'socialUserData', 
                                          primaryKey: String(_managerLCase).toLowerCase(), 
                                          requestOperation: 'get',
                                      }
                                    }).then((socialUserData) => {
                                        if(socialUserData.hasOwnProperty('Item')){
                              
                                          if(socialUserData.Item.hasOwnProperty('bioString')){
                                            bioString = String(socialUserData.Item.bioString)
                                          } else {
                                            bioString = 'No Bio :('
                                          }
                                          if(socialUserData.Item.hasOwnProperty('weblink1')){
                                            weblink1 = String(socialUserData.Item.weblink1)
                                            that.setState({
                                              socialOverlayData_weblink1: weblink1,
                                            })
                                          } else {
                                            weblink1 = null
                                          }
                                          if(socialUserData.Item.hasOwnProperty('weblink2')){
                                            weblink2 = String(socialUserData.Item.weblink2)
                                            that.setState({
                                              socialOverlayData_weblink2: weblink2,
                                            })
                                          } else {
                                            weblink2 = null
                                          }
                                          if(socialUserData.Item.hasOwnProperty('weblink3')){
                                            weblink3 = String(socialUserData.Item.weblink3)
                                            that.setState({
                                              socialOverlayData_weblink3: weblink3,
                                            })
                                          } else {
                                            weblink3 = null
                                          }
                                        } else {
                                          bioString = 'No Bio :('
                                          weblink1 = null
                                          weblink2 = null
                                          weblink3 = null
                                        }
                                
                                
                                        that.setState({
                                          socialOverlayData_imageURI: (
                                            profilePicture_base64
                                            ?
                                            profilePicture_base64
                                            :
                                            profilePicture_uri
                                          ),
                                          socialOverlayData_bioString: bioString,
                                        })



                                        mediaMapArrayUserMap = {}

                                        buildMediaData();
                                        function buildMediaData(){
                                          authenticatedPut('api1169ba1e', '', { 
                                            headers: { Authorization: `Bearer ${cognitoID}` },
                                            body: { 
                                                category: 'db',
                                                tableName: 'socialUserData', 
                                                primaryKey: String(_managerLCase), 
                                                requestOperation: 'get',
                                            }
                                          }).then((userData) => {




                                              if(userData.hasOwnProperty('Item')){
                                                if(userData.Item.hasOwnProperty('bioString')){
                                                  bioString = String(userData.Item.bioString)
                                                } else {
                                                  bioString = 'No Bio :('
                                                }

                                                let mediaArray = []
                                                if(userData.Item.hasOwnProperty('mediaArray')){
                                                  mediaArray = userData.Item.mediaArray
                                                }
                                                
                                                let mediaMapArray = []

                                                loopUserMediaArray(0)
                                                function loopUserMediaArray(m){

                                                  if(m<=mediaArray.length-1){
                                                    let thisFileName = mediaArray[m]
                                                    let caption = '...'
                                                    let uploadTimestamp = 0;
                                                    let likesArray = [];
                                                    let commentsMap = {};
                                                    let commentsMapArray = [];
                                                    
                                                    Storage.get(
                                                        thisFileName,
                                                        {
                                                            bucket: "platform-user-media-uploads",
                                                            level: "public"
                                                        }
                                                    ).then((res) => {
                                                        if(res){
                    
                                                            authenticatedPut('api1169ba1e', '', { 
                                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                                body: { 
                                                                    category: 'db',
                                                                    tableName: 'mediaUploads', 
                                                                    primaryKey: String(thisFileName), 
                                                                    requestOperation: 'get',
                                                                }
                                                            }).then((mediaData) => {
                                                              if(mediaData.hasOwnProperty('Item')){
                                                                if(mediaData.Item.hasOwnProperty('caption')){
                                                                  caption = String(mediaData.Item.caption)
                                                                }
                                                                if(mediaData.Item.hasOwnProperty('uploadTimestamp')){
                                                                  uploadTimestamp = String(mediaData.Item.uploadTimestamp)
                                                                }
                                                                if(mediaData.Item.hasOwnProperty('likesArray')){
                                                                  likesArray = mediaData.Item.likesArray
                                                                }
                                                                if(mediaData.Item.hasOwnProperty('commentsMap')){
                                                                  commentsMap = mediaData.Item.commentsMap
                                                                }
                                                                if(mediaData.Item.hasOwnProperty('commentsMapArray')){
                                                                  commentsMapArray = mediaData.Item.commentsMapArray
                                                                }
            


                                                                function loopCommentsArray(c){

                                                                  if(commentsMapArray.length-1 >= c && commentsMapArray.length > 0){
                                                                    let thisComment = commentsMapArray[c]
                                                                    let thisSender = thisComment.sender

                                                                    let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                                
                                                                    Storage.get(
                                                                      `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                                      {
                                                                          bucket: "platform-user-media-uploads",
                                                                          level: "public"
                                                                      }
                                                                    ).then((res) => {
                                                                      trackPageRequest(fetch(
                                                                        res
                                                                      )).then((image) => {

                                                                        if(image.status == 200){
                                                                          profilePicture_uri = res;
                                                                        }
                                                                        commentsMapArray[c]['profilePictureURI'] = profilePicture_uri
                                                                        commentsMapArray[c]['mediaFileName'] = thisFileName

                                                                        let commentsReplyMapArray = []
                                                                        
                                                                        authenticatedPut('api1169ba1e', '', { 
                                                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                                                          body: { 
                                                                              category: 'db',
                                                                              tableName: 'mediaUploadComments', 
                                                                              primaryKey: commentsMapArray[c].messageID, 
                                                                              requestOperation: 'get',
                                                                          }
                                                                        }).then((messageData) => {

                                                                          if(messageData.hasOwnProperty('Item')){

                                                                            commentsMapArray[c]['likesArray'] = messageData.Item.likesArray

                                                                            if(messageData.Item.hasOwnProperty('commentsReplyMapArray')){
                                                                              commentsReplyMapArray = messageData.Item.commentsReplyMapArray
                                                                            }
                                                                          
                                                                            function loopCommentsReplyArray(r){
        
                                                                              if(commentsReplyMapArray.length-1 >= r && commentsReplyMapArray.length > 0){
                                                                                let thisComment = commentsReplyMapArray[r]
                                                                                let thisSender = thisComment.sender
        
                                                                                let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                                            
                                                                                Storage.get(
                                                                                  `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                                                  {
                                                                                      bucket: "platform-user-media-uploads",
                                                                                      level: "public"
                                                                                  }
                                                                                ).then((res) => {
                                                                                  trackPageRequest(fetch(
                                                                                    res
                                                                                  )).then((image) => {
                                                                                    if(image.status == 200){
                                                                                      profilePicture_uri = res;
                                                                                    }
                                                                                    commentsReplyMapArray[r]['profilePictureURI'] = profilePicture_uri
                                                                                    commentsReplyMapArray[r]['messageReplyID'] = commentsReplyMapArray[r].messageID
                                                                                    commentsReplyMapArray[r]['likesArray'] = commentsReplyMapArray[r].likesArray
                                                                                    

                                                                                    loopCommentsReplyArray(r+1)
                                                                                  })
                                                                                })
                                                                              } else {
                                                                                commentsMapArray[c]['commentsReplyMapArray'] = commentsReplyMapArray
                                                                                loopCommentsArray(c+1)
                                                                              }
                                                                            }

                                                                            loopCommentsReplyArray(0)


                                                                          } else {
                                                                            loopCommentsArray(c+1)
                                                                          }
                                                                        })
                                                                      })
                                                                    })

                                                                  } else {

                                                                    mediaMapArray.unshift({
                                                                      mediaURI: res,
                                                                      mediaFileName: thisFileName,
                                                                      mediaItemCaption: caption,
                                                                      uploadTimestamp: uploadTimestamp,
                                                                      likesArray: likesArray,
                                                                      commentsMapArray: commentsMapArray,
                                                                      publisherUsername: managerUsername
                                                                    })
                    
                                                                    mediaMapArray.sort(function(a,b) {
                                                                        return (b.uploadTimestamp - a.uploadTimestamp)
                                                                    });

                                                                    that.setState({
                                                                      socialOverlayData_username: managerUsername,
                                                                      socialOverlayData_fullName: that.state.managerFullName,
                                                                      socialOverlayData_imageURI: profilePicture_uri,
                                                                      socialOverlayData_bioString: bioString,
                                                                      socialOverlayData_contractAddress: contractAddress,
                                                                      mediaMapArray,
                                                                    })

                                                                    loopUserMediaArray(m+1)

                                                                  }
                                                                }
                                                                loopCommentsArray(0);

                                                            }
                                                        })
                                                        
                                                    }
                                                }).catch((err)=>{
                                                  loopUserMediaArray(m+1)
                                                })
                                              } else {
                                                mediaMapArrayUserMap[_managerLCase] = mediaMapArray
                                            
                                                that.setState({
                                                  mediaMapArrayUserMap
                                                })
                                                
                                                loadBorrowerContractData()
                                              }
                                            }
                                          } else {
                                            bioString = 'No Bio :('
                                          }
                                        })
                                      }









                                        function loadBorrowerContractData(){

                                          authenticatedPut('api1169ba1e', '', { 
                                            headers: { Authorization: `Bearer ${cognitoID}` },
                                            body: { 
                                              category: 'db',
                                              tableName: 'users', 
                                              primaryKey: currentUser, 
                                              requestOperation: 'get',
                                            }
                                          }).then((response) => {
                                            publicKey = response.Item.publicKey

                                            if(response.Item.hasOwnProperty('recentlyViewedContractsArray')){
                                              authenticatedPut('api1169ba1e', '', { 
                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                body: { 
                                                    category: 'db',
                                                    tableName: 'users', 
                                                    primaryKey: currentUser,
                                                    requestOperation: 'update',
                                                    updateExpression: 
                                                      `SET 
                                                        recentlyViewedContractsArray = list_append(recentlyViewedContractsArray, :recentlyViewedContracts)
                                                      `,
                                                    expressionAttributeValues: { 
                                                      ':recentlyViewedContracts': [contractAddress],
                                                    },
                                                }
                                              })
                                            } else {
                                              authenticatedPut('api1169ba1e', '', { 
                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                body: { 
                                                    category: 'db',
                                                    tableName: 'users', 
                                                    primaryKey: currentUser,
                                                    requestOperation: 'update',
                                                    updateExpression: 
                                                      `SET 
                                                        recentlyViewedContractsArray = :recentlyViewedContracts
                                                      `,
                                                    expressionAttributeValues: { 
                                                      ':recentlyViewedContracts': [contractAddress],
                                                    },
                                                }
                                              })
                                            }

                                            campaign = new web3.eth.Contract( 
                                              thisContract_CampaignContract.abi,
                                              contractAddress
                                            );
                                            
                                            campaign.methods.getSummary1().call()
                                              .then((res) => {
                                                web3BalancePre = String(res[0])
                                                web3BalancePost = String(res[0])
                                                loanTarget = String(res[1])
                                                minimumContribution = String(res[2])
                                                interestRate = String(res[3])
                                                finalRequestsSum = String(res[4])
                                                repaymentSum = String(res[5])
                                                totalContributed = String(res[6])
                                                approversCount = String(res[7])
                                                requestsCt = String(res[8])
                                                receiptsCt = String(res[9])
                                                approversList = String(res[10])
                                                manager = String(res[11])
                                                insuranceTotal = res[12]
                                                compoundedInterestPaid = res[13]
                                                
                                                campaign.methods.getSummary2(publicKey).call()
                                                  .then((res) => {

                                                        conversionRateGlobal = 1
                                                        currentUserLoanTotal = Number(res[0])
                                                        userLiquidValue = Number(res[1])
                                                        userFinalizedRequestLoanSum = Number(res[2])
                                                        approverCheck = res[3]
                                                        reclaimableValue = Number(res[4])
                                                        compoundInterestReceived = Number(res[5])

                                                        campaign.methods.getSummary3(publicKey).call()
                                                          .then(async (res) => {

                                                            let approverReceivedRepaymentSum = Number(res[0])

                                                            let availableCredit_unadjusted = ((((Number(loanTarget) - Number(finalRequestsSum) + Number(repaymentSum))) / 1000000000000000000))
                                      
                                                            availableCredit = await readOnChainAvailableCredit(campaign)


                                                            totalCreditMax = ((loanTarget / 1000000000000000000)).toFixed(5)

                                                            creditUtilizationPerc  = parseInt(100 - ((Number(availableCredit_unadjusted)/Number(totalCreditMax)) * 100))

                                                            if(isNaN(creditUtilizationPerc) || Number(creditUtilizationPerc)<0){
                                                              creditUtilizationPerc = '0'
                                                            }

                                                            if(Number(userLiquidValue) > Number(currentUserLoanTotal) - Number(minimumContribution) - 1){
                                                              _exitReclaimableValueWei = Number(currentUserLoanTotal) - Number(userFinalizedRequestLoanSum) + 1000
                                                              _safeReclaimableValueWei = Number(currentUserLoanTotal) - Number(minimumContribution) - 10000000
                                                            } else {
                                                              _exitReclaimableValueWei = Number(currentUserLoanTotal) - Number(userFinalizedRequestLoanSum) + 1000
                                                              _safeReclaimableValueWei = (Number(userLiquidValue) * 0.9) - 10000000
                                                            }

                                                            _reclaimableValue = _safeReclaimableValueWei / 1000000000000000000

                                                            if(_reclaimableValue < 0){
                                                              _reclaimableValue = 0
                                                            }
                                                            if(_exitReclaimableValueWei < 0){
                                                              _exitReclaimableValueWei = 0
                                                            }
                                                            if(_safeReclaimableValueWei < 0){
                                                              _safeReclaimableValueWei = 0
                                                            }

                                                            if(finalRequestsSum - repaymentSum < 0){
                                                              netDebt = 0
                                                            } else {
                                                              netDebt = finalRequestsSum - repaymentSum
                                                            }
                                                            receiptsCt = parseInt(receiptsCt, 10)
                                                            _payableValue = (parseInt(netDebt, 10)/1000000000000000000) 
                                                            _approversCt = parseInt(approversCount, 10)
                                                            _web3Balance = parseFloat((parseInt(web3BalancePost, 10))  , 10)/1000000000000000000
                                                            _web3Balance = _web3Balance.toFixed(2)
                                                            _targetValue = parseFloat(parseInt(loanTarget, 10) , 10)/1000000000000000000
                                                            _targetValue = _targetValue.toFixed(2)
                                                            _minLoan = parseFloat(parseInt(minimumContribution, 10) )/1000000000000000000
                                                            _minLoan = _minLoan.toFixed(2)
                                                            _blockchainBalance = parseFloat((parseInt(web3BalancePost, 10) ), 10)/1000000000000000000
                                                            _totalWithdrawn = (parseFloat((parseInt(finalRequestsSum, 10) ), 10)/1000000000000000000)
                                                            _userContributed = (parseFloat((parseInt(currentUserLoanTotal, 10) ), 10)/1000000000000000000)
                                                            _userFinalized = (parseFloat((parseInt(userFinalizedRequestLoanSum, 10) ), 10)/1000000000000000000)
                                                            _totalPaid = (parseInt(repaymentSum, 10) )/1000000000000000000
                                                            _totalPaid = _totalPaid.toFixed(2)
                                                            _totalWithdrawn = _totalWithdrawn.toFixed(2)
                                                            _userContributed = _userContributed.toFixed(2)
                                                            _userFinalized = _userFinalized.toFixed(2)
                                                            _totalContributedWei = parseInt(totalContributed, 10)
                                                            _totalContributed = parseFloat((parseInt(totalContributed, 10) ), 10)/1000000000000000000
                                                            _totalContributed = _totalContributed.toFixed(2)
                                                            _approversLoanTotal = parseFloat((parseInt(currentUserLoanTotal, 10) ), 10)
                                                            _borrowerInterestPaid = (parseInt(compoundedInterestPaid, 10) )/1000000000000000000
                                                            _userInterestEarned = ((parseInt(compoundInterestReceived, 10) )/1000000000000000000).toFixed(2)  
                                                            _approverReceivedRepaymentSum = ((parseInt(approverReceivedRepaymentSum, 10) )/1000000000000000000).toFixed(2)  

                                                            
                                                            requests = []

                                                            that.loadPage()

                                                            if(requestsCt > 0){

                                                              for(let r=0; r<=requestsCt-1; r++){
                                                                let _r =r
                                                                if(!deletedWithdrawalRequestIndexArray.includes(Number(_r))){
                                                                  campaign.methods.requests(_r).call()
                                                                    .then((res) => {
                                                                      let reqValue = res.value;
                                                                      if(Number(reqValue) > Number(web3BalancePre) - Number(insuranceTotal)){
                                                                        reqValue = Number(web3BalancePre) - Number(insuranceTotal)
                                                                      } 
                                                                      if(reqValue > Number(loanTarget) - (Number(finalRequestsSum) - Number(repaymentSum))){
                                                                        reqValue = Number(loanTarget) - (Number(finalRequestsSum) - Number(repaymentSum)) - 1
                                                                      }

                                                                      campaign.methods.getRequest(_r, publicKey).call()
                                                                        .then((approvalCheck) => {
                                                                          let approvalRatio = ((parseInt(res.approvalCount, 10)/_approversCt)*100).toFixed(0)
                                                                          if(_approversCt < 1){
                                                                            approvalRatio = 0
                                                                          }
                                                                          
                                                                          let iconName;
                                                                          let datePreComma = String(new Date(parseInt(res.dateSecs, 10))).substring(4,15)
                                                                          datePreComma = datePreComma.substr(0,3).concat('.' + datePreComma.substring(3,datePreComma.length))
                                                                          let datePostComma = datePreComma.substr(0,7) + ', ' + datePreComma.substr(-4, datePreComma.length-1) 
                                                          
                                                                          if(res.complete == false){
                                                                            let requestsLength = requests.length
                                                                            
                                                                              if(_managerLCase != currentUser.toLowerCase()){
                                                                                let requestValue = (Number(reqValue)*((Number(currentUserLoanTotal) - Number(userFinalizedRequestLoanSum))/(Number(web3BalancePre) - Number(insuranceTotal)))/1000000000000000000).toFixed(2)
                                                                                if(isNaN(requestValue)){
                                                                                  requestValue = '0.00'
                                                                                }
                                                                                if(approvalCheck == true){
                                                                                
                                                                                  requests.push({
                                                                                    requestId: String([...Array(10)].map(i=>(~~(Math.random()*36)).toString(36)).join('')),
                                                                                    requestValue: requestValue,   
                                                                                    requestCompleteStatus: res.complete,
                                                                                    requestApprovalCount: String(approvalRatio),
                                                                                    requestDate:datePostComma,
                                                                                    approvalCheck,
                                                                                    iconName: "md-checkbox-outline",
                                                                                    approvalRatio,
                                                                                    allRequestsIndex: _r,
                                                                                    filteredRequestIndex: requestsLength,
                                                                                    valid: true
                                                                                  })
                                                                                } else {
                                                                                  requests.push({
                                                                                    requestId: String([...Array(10)].map(i=>(~~(Math.random()*36)).toString(36)).join('')),
                                                                                    requestValue: requestValue,   
                                                                                    requestCompleteStatus: res.complete,
                                                                                    requestApprovalCount: String(approvalRatio),
                                                                                    requestDate: datePostComma,
                                                                                    approvalCheck,
                                                                                    iconName: "md-square-outline",
                                                                                    approvalRatio,
                                                                                    allRequestsIndex: _r,
                                                                                    filteredRequestIndex: requestsLength,
                                                                                    valid: true
                                                                                  })
                                                                                }
                                                                              } else {
                                                                                if(parseInt(approvalRatio, 10) > 50){
                                                                                  requests.push({
                                                                                    requestId: String([...Array(10)].map(i=>(~~(Math.random()*36)).toString(36)).join('')),
                                                                                    requestValue: (Math.ceil(parseFloat((parseFloat(reqValue, 10) )/1000000000000000000, 10)*10000)/10000).toFixed(2),
                                                                                    requestCompleteStatus: res.complete,
                                                                                    requestApprovalCount: String(approvalRatio),
                                                                                    requestDate: datePostComma,
                                                                                    approvalCheck,
                                                                                    iconName: "md-checkbox-outline",
                                                                                    approvalRatio,
                                                                                    allRequestsIndex: _r,
                                                                                    filteredRequestIndex: requestsLength,
                                                                                    valid: true
                                                                                  })
                                                                                } else {
                                                                                  requests.push({
                                                                                    requestId: String([...Array(10)].map(i=>(~~(Math.random()*36)).toString(36)).join('')),
                                                                                    requestValue: (Math.ceil(parseFloat((parseFloat(reqValue, 10) )/1000000000000000000, 10)*10000)/10000).toFixed(2),
                                                                                    requestCompleteStatus: res.complete,
                                                                                    requestApprovalCount: String(approvalRatio),
                                                                                    requestDate: datePostComma,
                                                                                    approvalCheck,
                                                                                    iconName: "md-square-outline",
                                                                                    approvalRatio,
                                                                                    allRequestsIndex: _r,
                                                                                    filteredRequestIndex: requestsLength,
                                                                                    valid: true
                                                                                  })
                                                                                }
                                                                              }
                                                                            
                                                                          }
                                                                        })
                                                                    })
                                                                  }
                                                              }
                                                              
                                                        
                                                            } else {
                                                              requests.push({
                                                                requestId: String([...Array(10)].map(i=>(~~(Math.random()*36)).toString(36)).join('')),
                                                                requestValue: '    -----  ',
                                                                requestCompleteStatus: false,
                                                                requestApprovalCount: '-',
                                                                requestDate: '------    ',
                                                                approvalCheck: false,
                                                                iconName: "md-square-outline",
                                                                approvalRatio: '-',
                                                                allRequestsIndex: 0,
                                                                filteredRequestIndex: 0,
                                                                valid: false
                                                              })
                                                            }
                                                          
                                                            
                                                          })
                                                      
                                                  })
                                              })
                                          }) 
                                        }
                                      }) 

                                    })
                                })
                              })
                            })
                          }
                      })
                  })
              })
          })

        
      })
    })
  }

  checkLenderblockSubscriberStatus(){
          

    let isSubscribedCurrentBool = false;

    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
        category: 'db',
        tableName: 'users', 
        primaryKey: String(currentUser), 
        requestOperation: 'get',
      }
    }).then((userData) => {
      primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
      secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
      publicKey = userData.Item.publicKey
      emailAddress = userData.Item.emailAddress
      firstName = userData.Item.firstName
      let firstNameFormatted = firstName.substr(0,1).concat(firstName.substr(1,firstName.length-1))


      
      

      

      that.setState({
          
      })
      

        
      Promise.resolve().then(() => {
if (userData.Item.isSubscribedCurrentBool === true) {
                    

                    isSubscribedCurrentBool = true
                    that.setState({
                        isSubscribedCurrentBool
                    })
                    
                  } else {
                    

                    isSubscribedCurrentBool = false
                    that.setState({
                        isSubscribedCurrentBool
                    })
                    
                  }
});

      authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'platformConfigurations', 
            primaryKey: 'BlenderProPlusBenefits', 
            requestOperation: 'get',
          }
      }).then((userData) => {

          let subscriberBenefitsArray = userData.Item.BlenderProPlusBenefits
          that.setState({
              subscriberBenefitsArray
          })

      })

      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'platformConfigurations', 
          primaryKey: 'LenderblockSubscription1_CommissionIntegerPCT', 
          requestOperation: 'get',
        }
      }).then((userData) => {

        let LenderblockSubscription1_CommissionIntegerPCT = userData.Item.LenderblockSubscription1_CommissionIntegerPCT
        let contributeCommissionIntegerPCT = LenderblockSubscription1_CommissionIntegerPCT.contribute
        let repayCommissionIntegerPCT = LenderblockSubscription1_CommissionIntegerPCT.repay
        let rescindCommissionIntegerPCT = LenderblockSubscription1_CommissionIntegerPCT.rescind
        let withdrawCommissionIntegerPCT = LenderblockSubscription1_CommissionIntegerPCT.withdraw

        that.setState({
          contributeCommissionIntegerPCT,
          repayCommissionIntegerPCT,
          rescindCommissionIntegerPCT,
          withdrawCommissionIntegerPCT
        })
      




      })
    })

  }

  

  fixIssue(){
    let distributionFractSum = 0
    let userFinalizedRequestLoanSumTotal = 0
    let approverReceivedRepaymentSumTotal = 0

    campaign.methods.getSummary1().call()
    .then((res) => {
      let web3BalancePre = String(res[0])
      let web3BalancePost = String(res[0])
      let loanTarget = String(res[1])
      let minimumContribution = String(res[2])
      let interestRate = String(res[3])
      let finalRequestsSum = String(res[4])
      let repaymentSum = String(res[5])
      let totalContributed = String(res[6])
      let approversCount = String(res[7])
      let requestsCt = String(res[8])
      let receiptsCt = String(res[9])
      let approversList = res[10]
      let manager = String(res[11])
      let insuranceTotal = res[12]
      let compoundedInterestPaid = res[13]
      
      for(let a=0; a<=approversList.length-1; a++){
        let thisApprover = approversList[a]
        campaign.methods.getSummary2(thisApprover).call()
          .then((res) => {
            
            let currentUserLoanTotal = Number(res[0])
            let userLiquidValue = Number(res[1])
            let userFinalizedRequestLoanSum = Number(res[2])
            let approverCheck = res[3]
            let reclaimableValue = Number(res[4])
            let compoundInterestReceived = Number(res[5])

            campaign.methods.getSummary3(thisApprover).call()
              .then((res) => {
                let approverReceivedRepaymentSum = Number(res[0])


                let distributionFraction = (Number(userFinalizedRequestLoanSum) - Number(approverReceivedRepaymentSum))/(Number(finalRequestsSum) - Number(repaymentSum))

                distributionFractSum += distributionFraction
                userFinalizedRequestLoanSumTotal += Number(userFinalizedRequestLoanSum)
                approverReceivedRepaymentSumTotal += Number(approverReceivedRepaymentSum)

              })
          })
      }
    })
  }

  loadPage(conversionRate, mountingBool, did_CDM){

    _openValue = Math.round((_targetValue - _totalContributed)*10000000)/10000000
    let actionPlaceHolder;
    let whitelistCt;
    let adjusted_userContributed;
    let adjusted_userFinalized;



    let _dateCreatedNonFormat;

    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
        category: 'db',
        tableName: 'contracts',  
        primaryKey: contractAddress, 
        requestOperation: 'get',
      }
    }).then(response => {
      
      var contracts = response.Item
      var _managerLCase = contracts.managerUsername.toLowerCase()

      that.setState({
        managerUsername: _managerLCase,
        moneyTransactionPreset: String(_managerLCase).toLowerCase() == String(that.state.currentUser).toLowerCase() ? 'repay' : 'lend'
      })




      var _contractType = contracts.contractType

      blacklisted = false
  
      let offeredLenderCommissionUSD_adjusted


      if(Number(finalRequestsSum) < Number(loanTarget)){
        _offeredLenderCommissionUSD_adjusted = Number(offeredLenderCommissionUSD) * (Number(finalRequestsSum)/Number(loanTarget))
        offeredLenderCommissionUSD_adjusted = Number(offeredLenderCommissionUSD) * (Number(finalRequestsSum)/Number(loanTarget))
      } else {
        _offeredLenderCommissionUSD_adjusted = Number(offeredLenderCommissionUSD)
        offeredLenderCommissionUSD_adjusted = Number(offeredLenderCommissionUSD)
      }
  
      if(Number(finalRequestsSum) <= 1){
        _offeredLenderCommissionUSD_adjusted = 0
        offeredLenderCommissionUSD_adjusted = 0
      }
      offeredLenderCommissionUSD_adjusted = offeredLenderCommissionUSD_adjusted
  

      
    
    _dateCreatedNonFormat = contracts.creationDate
    _weiCompoundedBalance = contracts.compoundedBalance
    // _compoundedBalance = ((Number(contracts.compoundedBalance)/1000000000000000000) + Number(offeredLenderCommissionUSD_adjusted))
    _compoundedBalance = ((Number(contracts.compoundedBalance)/1000000000000000000))

    if(_compoundedBalance > 3000000000000000000){
      _canDeleteCreditLineBool = false
    } else {
      _canDeleteCreditLineBool = true
    }

    _availableCreditReadyWithdraw = (Number(insuranceTotal)/1000000000000000000) - Number(_compoundedBalance);
    if(_availableCreditReadyWithdraw < 0){
      _availableCreditReadyWithdraw = 0;
    }

    _compoundedBalanceWEI = Number(contracts.compoundedBalance)
    _dateCreated = _dateCreatedNonFormat.substring(0,10)
    targetValue = contracts.targetValue

    let paymentStatus
                                
    var time = new Date().getTime(); // get your number
    var date = new Date(time); // create Date object

    let lastPaymentDate = contracts.lastPaymentDate;
    let timeSinceLastPayment = Date.now() - lastPaymentDate;
    let compoundedDebt = contracts.compoundedBalance          
  
    let daysOfMonth = Number(date.toString().substr(10,2))
    let daysOfMonthMillisec = daysOfMonth * 86400000

    if(((timeSinceLastPayment > daysOfMonthMillisec && daysOfMonth >= 15)) && compoundedDebt > 0){
      paymentStatus = "PAYMENT DUE"
    } else {
      paymentStatus = "GOOD"
    }



    let monthNum = _dateCreated.substr(5,2)
    let yearNum = _dateCreated.substr(0,4)
    let dayNum = _dateCreated.substr(8,2)
    let monthString
    if(monthNum == '01'){
      monthString = 'Jan. '
    } else if(monthNum == '02'){
      monthString = 'Feb. '
    } else if(monthNum == '03'){
      monthString = 'Mar. '
    } else if(monthNum == '04'){
      monthString = 'Apr. '
    } else if(monthNum == '05'){
      monthString = 'May. '
    } else if(monthNum == '06'){
      monthString = 'Jun. '
    } else if(monthNum == '07'){
      monthString = 'Jul. '
    } else if(monthNum == '08'){
      monthString = 'Aug. '
    } else if(monthNum == '09'){
      monthString = 'Sep. '
    } else if(monthNum == '10'){
      monthString = 'Oct. '
    } else if(monthNum == '11'){
      monthString = 'Nov. '
    } else if(monthNum == '12'){
      monthString = 'Dec. '
    } 
    _dateCreated = monthString + dayNum + ', ' + yearNum
    _intRate = contracts.intRate

    managerUsername = _managerLCase

    that.setState({
      managerUsername,
    })

    _lenders = contracts.lenders.length



    managerDisplay = _managerLCase.toUpperCase()


    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
        category: 'db',
        tableName: 'platformConfigurations', 
        primaryKey: 'corporateBackedUsernamesArray', 
        requestOperation: 'get',
      }
    }).then((_corporateBackedUsernamesArray) => {
      corporateBackedUsernamesArray = _corporateBackedUsernamesArray.Item.corporateBackedUsernamesArray
      if(corporateBackedUsernamesArray.includes(_managerLCase)){
        isCorporateBondBool = true
        that.setState({
          isCorporateBondBool,
          allowsVerifiedRegistryCollateralInsurance: false
        })
      } else {
        isCorporateBondBool = false
        that.setState({
          isCorporateBondBool,
          allowsVerifiedRegistryCollateralInsurance: true
        })
      }

      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'users', 
          primaryKey: _managerLCase, 
          requestOperation: 'get',
        }
      }).then(userData => { 
              
        let firstName = userData.Item.firstName ?? ''
        let lastName = userData.Item.lastName ?? ''

        let fullName = firstName.substring(0,1).toUpperCase()+firstName.substring(1,firstName.length) + ' ' + lastName.substring(0,1).toUpperCase()+lastName.substring(1,lastName.length)
        that.setState({
          managerFullName: fullName
        })
     
        let contractTypeDescription2, contractTypeDescription1,  headerColor, headerTextColor

        let managerDisplayName = null;

        if(isCorporateBondBool){
          managerDisplayName = 'LENDERBLOCK CORPORATION'
        } else {
          managerDisplayName = String(managerUsername).toUpperCase()
        }

        that.setState({
          managerDisplayName: managerUsername
        })

        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
              category: 'db',
              tableName: 'socialUserData', 
              primaryKey: String(managerUsername), 
              requestOperation: 'get',
          }
        }).then((userData) => {
          if(userData.hasOwnProperty('Item')){
            if(userData.Item.hasOwnProperty('dynamicPublicUsername')){
              managerDisplayName = userData.Item.dynamicPublicUsername;


              that.setState({
                managerDisplayName: String(managerDisplayName).toUpperCase(),
                socialOverlayData_fullName: fullName,
                socialOverlayData_username: String(managerUsername).toUpperCase()
              })

            }
          }
          
          
          if(managerDisplayName){
            contractTypeDescription1 = managerDisplayName
            contractTypeDescription2 = 'User-Managed Credit-Line'
            headerColor = 'rgba(256, 256, 256, 1)'
            headerTextColor = 'rgba(0, 158, 129, 1)'
            
            that.setState({
              contractTypeDescription1,
              contractTypeDescription2,
              headerColor,
              headerTextColor
            })
          } else {

            if(isCorporateBondBool){
              if(contractStructureType == 'creditLine'){
                contractTypeDescription1 = 'LENDERBLOCK CORPORATION'
                contractTypeDescription2 = 'Corporate-Backed Credit-Line'
                headerColor = 'rgba(256, 256, 256, 1)'
                headerTextColor = 'rgba(0, 158, 129, 1)'
                
                that.setState({
                  contractTypeDescription1,
                  contractTypeDescription2,
                  headerColor,
                  headerTextColor
                })
              } else {
                contractTypeDescription1 = 'LENDERBLOCK CORPORATION'
                contractTypeDescription2 = 'Corporate-Backed Loan-Agreement'
                headerColor = 'rgba(256, 256, 256, 1)'
                headerTextColor = 'rgba(0, 158, 129, 1)'
                
                that.setState({
                  contractTypeDescription1,
                  contractTypeDescription2,
                  headerColor,
                  headerTextColor
                })
              }
            
            } else {
              if(contractStructureType == 'creditLine'){
                contractTypeDescription1 = managerDisplay
                contractTypeDescription2 = 'User Managed Credit-Line'
                headerColor = 'rgba(256, 256, 256, 1)'
                headerTextColor = 'rgba(0, 158, 129, 1)'

                that.setState({
                  contractTypeDescription1,
                  contractTypeDescription2,
                  headerColor,
                  headerTextColor
                })
              } else {
                contractTypeDescription1 = managerDisplay 
                contractTypeDescription2 = 'User Managed Loan-Agreement'
                headerColor = 'rgba(256, 256, 256, 1)'
                headerTextColor = 'rgba(0, 158, 129, 1)'

                that.setState({
                  contractTypeDescription1,
                  contractTypeDescription2,
                  headerColor,
                  headerTextColor
                })
              }
            }
          }

          that.setState({
            managerHeader:
              <div 
                style={{ backgroundColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 158, 129, 0)' : 'rgba(41, 41, 44, 0)', marginTop: 45, height: 95, width: '100vw', }}
              >
                {
                  currentUser.toLowerCase() == managerUsername.toLowerCase() 
                  ?
                  <Button
                    style={{
                      right: 30,
                      top: 20,
                      zIndex: 999,
                      position: 'absolute',
                      // backgroundColor: 'rgba(0, 158, 129, 1)',
                      borderRadius: 3, 
                      padding: 5, 
                    }}
                    disabled={that.state.disableWhileTxn}
                    onClick={() => {
                      that.setState({
                        settingsOverlay: true
                      })
                    }}
                  >
                    <p style = {{  
                      fontWeight: '600',
                      textAlign: 'right',
                      
                      textShadowColor: 'rgba(0, 0, 0, 0.1)',
                      textShadowOffset: {width: -1, height: 1},
                      textShadowRadius: 10, 
                    }}> 
                      <i 
                        className={"setting icon"}
                        size={35} 
                        style={{ 
                          position: 'relative', 
                          color: 'rgba(204, 12, 12, 1)', 
                          fontSize: 30,
                          top: 0, 
                          left: -5,
                        }}
                      />
                    </p>
                  </Button>
                  : 
                  null
                }
                <p 
                  style={{ 
                    color:'rgba(0, 0, 0, 1)', 
                    fontSize: 17,
                    textAlign: 'left',
                    left: 30,
                    // marginLeft: 15,
                    width: '66vw',
                    marginTop: 20,
                    marginBottom: 15,
                    fontWeight: '600',
                  }}
                >
                  <p 
                    style={{ 
                      color: headerTextColor,
                      fontSize: 16,
                      textAlign: 'left',
                      left: 30,
                      // marginLeft: 15,
                      width: '66vw',
                      marginTop: 20,
                      marginBottom: 0,
                      fontWeight: '600',
                    }}
                  >
                    {String(contractTypeDescription1).toUpperCase()}{'\n'}
                  </p>   

                  <p 
                    style={{ 
                      color: that.state.mode_light_dark == 'dark' ? 'rgba(177, 177, 177, 1)' : 'rgba(0, 0, 0, 1)',
                      fontSize: 12,
                      textAlign: 'left',
                      left: 30,
                      // marginLeft: 15,
                      marginBottom: 0,
                      fontWeight: '600',
                    }}
                  >
                    {fullName}{'\n'}
                  </p>   
                  
                </p>            
              </div>
          })
        


        _currentUserContribution = contracts.userContributionMap[currentUser]/1000000000000000000


        if(mountingBool == true){
          actionTypeStakingBool = false;
          if(_managerLCase == currentUser.toLowerCase()){
              actionPlaceHolder = "MIN "+ (Math.ceil(Number(_minLoan)*1000000)/1000000).toFixed(2)+" "+'USD' 
              actionType = 'pay'
              actionButton =
                <Button 
                  style={{
                    height: 40, 
                    width: 125, 
                    paddingBottom: 9, 
                    paddingTop: 9, 
                    paddingLeft: 10, 
                    paddingRight: 10,  
                    borderRadius: 5, 
                    backgroundColor:  that.state.actionInitButtonBackgroundColor,
                    marginLeft: 20, 
                    justifyContent: 'center',
                  }}
                  disabled={that.state.disableWhileTxn}
                  onClick={() => {  
                    if(that.state._compoundedBalance >= 1){
                      if(that.state.freezeButtonsNoVerify){
                        that.setState({ verifyIDOverlay: true })
                      } else {
                        if(that.state.actionValue >= (minimumContribution / 1000000000000000000)){
                          if(that.state.confirmActionPopUp == false && (Number(that.state.actionValue) >= Number(_minLoan))){
                            that.repay()
                          }
                        } else {
                          that.setState({ 
                            activityIndicator: 
                              <div style={{ justifyContent: 'center', marginLeft: 0, marginRight: 0, alignItems: 'center', marginTop: 15, marginBottom: 15 }}>
                                <p style={{ color: 'rgba(204, 12, 12, .70)', fontWeight: '600', fontSize: 20, textAlign: 'center', marginBottom: 10, marginTop: 10 }}> 
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    `Valor de Transacción debe ser\nal menos ${(minimumContribution / 1000000000000000000).toFixed(2)} USD`
                                      :
                                    `Transaction Value must be\nat least ${(minimumContribution / 1000000000000000000).toFixed(2)} USD`
                                  }
                                </p> 
                              </div>
                          })
                        }
                      }
                    } else {
                      that.setState({
                        generalNoticeOverlay: true,
                        generalNoticeText: 
                          (that.state.selectedLanguage == 'spanish' ? 
                            'No hay deudas para pagar.'
                              :
                            'No Debt To Repay'
                          )
                      })
                    }
                  }}
                  
                >
                  <p style={{ fontSize: 17, justifyContent: 'center', alignContent: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', textAlign: 'center',}}>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Pagar'
                        :
                      'Pay'
                    }
                  </p>
                </Button>    
                
                
              interactionHeader = 
                <div
                  style={{
                    marginTop: (
                      that.state.isCorporateBondBool ?
                        60:
                        50
                    )
                  }}
                >
                  <p style={{ fontSize: 16, fontWeight: '600', borderBottomWidth: 0.2, borderBottomColor: 'rgba(11, 28, 24, .95)', width:'100vw', marginLeft: 60, marginRight: 60, color: 'rgba(0, 158, 129, 1)', textAlign: 'center' }}>
                    {
                      that.state.selectedLanguage == 'spanish' ? 
                        that.state.isCorporateBondBool ?
                        'Adminstrado Internamente\n\nLenderblock Corporation\nLínea de Crédito Fundada de Lenderblock':
                        'Interactuar con su Línea de Crédito'
                      :
                      that.state.isCorporateBondBool ?
                        'Internal Corporate Management\n\nLenderblock Corporation\nLenderblock-Backed Credit Line':
                        'Interact with Your Credit-Line'
                    } 
                  </p>
                </div>

              _userContributed = '-----' 
              _userFinalized = '-----' 
              _userInterestEarned = '-----' 
                
              
              _txnSectionHelpText = 'Create/Finalize Withdrawal Requests &  \nMake Payments in the middle.'
              
          } else {

            actionPlaceHolder = '0 USD'
            actionType = 'contribute'
            actionButton =
              <Button 
              style={{
                height: 40, 
                width: 125, 
                paddingBottom: 9, 
                paddingTop: 9, 
                paddingLeft: 5, 
                paddingRight: 5,  
                borderRadius: 5, 
                backgroundColor:  that.state.actionInitButtonBackgroundColor,
                marginLeft: 20, 
                justifyContent: 'center',
              }}
              disabled={that.state.disableWhileTxn}
              onClick={() => {
                if(that.state.freezeButtonsNoVerify){
                  that.setState({ verifyIDOverlay: true })
                } else {
                    if(that.state.confirmActionPopUp == false){

                      
                    }
                }
              }}
            >
              <p style={{ fontSize: 17, justifyContent: 'center', alignContent: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', textAlign: 'center',}}>
                {that.state.selectedLanguage == 'spanish' ? 
                  'Prestar'
                    :
                  'Lend'
                }
              </p>
              </Button>   

            interactionHeader = 
              <div
                style={{
                  marginTop: (
                    that.state.isCorporateBondBool ?
                      60 :
                      50
                  )
                }}
              >
                <p style={{ fontSize: 16, width: '100vw', marginLeft: 60, fontWeight: '600', marginRight: 60, color: 'rgba(0, 158, 129, 1)', textAlign: 'center' }}>
                  {that.state.selectedLanguage == 'spanish' ? 
                    that.state.isCorporateBondBool ?
                      `Lenderblock Corporation\nLínea de Crédito Fundada por Lenderblock`:
                      `Prestar a ${managerDisplay} 's\nLínea de Crédito `
                    :
                    that.state.isCorporateBondBool ?
                      `Lenderblock Corporation\nCorporate-Backed Credit-Line`:
                      `Lend to ${managerDisplay} 's\nCredit-Line `
                  }
                </p>
              </div>

            _txnSectionHelpText = 'Lend/Reclaim Funds & Approve  \nWithdrawal Requests in the middle.'

          }
        }
        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: _managerLCase, 
            requestOperation: 'get',
          }
        })
          .then(response => { 
      
                let _openContractsCt = parseInt(response.Item.openContracts.length, 10)
                let _totalRepaid_nonConvert = parseFloat(response.Item.totalPaid, 10)/1000000000000000000
                let _totalLending_nonConvert = parseFloat(response.Item.nowLending, 10)/1000000000000000000
                let _totalBorrowing_nonConvert = parseFloat(response.Item.nowBorrowing, 10)/1000000000000000000
                let _lentTotal_nonConvert = parseFloat(response.Item.totalLent, 10)/1000000000000000000
                let _borrowingRec_nonConvert = (parseFloat(response.Item.totalWithdrawn, 10)+1)/1000000000000000000
                let _joinDateSecs = response.Item.joinDateSecs

                let currentDay = parseInt(Date.now()/86400000)
                let createdDate = parseInt(_dateCreatedNonFormat/86400000)
                let timeArray = [];
                let lastValue = 0;
                let lastValueDelta = 0; 
                let monthsJoined
                let alpha
                let highestValue, lowestValue

                let raters = response.Item.raters;
                let ratingsMap = response.Item.ratingsMap;
                let ratingSum = 0;
                for(let r=0; r<=raters.length-1; r++){
                  ratingSum += ratingsMap[raters[r]].rating
                }

                _userAvgRating = Math.floor(10 * Number(ratingSum)/raters.length)/10
                _fico = response.Item.ficoCheck
                _totalLending = Number((response.Item.nowLending)/1000000000000000000).toFixed(2)
                _totalBorrowing = Number((response.Item.nowBorrowing)/1000000000000000000).toFixed(2)
                _lentTotal = Number((response.Item.totalLent)/1000000000000000000).toFixed(2)
                _borrowingRec = Number((response.Item.totalWithdrawn)/1000000000000000000).toFixed(2)
                _loanRate = Number((response.Item.lendRate))
                _withdrawalRate = Number(Math.round(response.Item.borrowRate)*10)/10
                _lendingRate = Number(Math.round(response.Item.lendRate)*10)/10
                _repayRate = Number(Math.round(response.Item.paymentRate)*10)/10
                _joinDate = new Date(response.Item.joinDateSecs)

                _joinDate = String(_joinDate)
                _repaymentTotal = parseFloat(((parseInt(response.Item.totalPaid, 10))/1000000000000000000),10).toFixed(2)

                if(_borrowingRec_nonConvert == 0){
                  _blenderScore = 400
                } else {
                  _blenderScore = Math.ceil( 500 * (_totalRepaid_nonConvert/_borrowingRec_nonConvert) + 400 ) 
                }      

                // let monthNum = _joinDate.substr(5,2)
                let yearNum = _joinDate.substr(11,4)
                let dayNum = _joinDate.substr(8,2)
                let monthString = _joinDate.substr(4,3)
                // if(monthNum == '01'){
                //   monthString = 'Jan. '
                // } else if(monthNum == '02'){
                //   monthString = 'Feb. '
                // } else if(monthNum == '03'){
                //   monthString = 'Mar. '
                // } else if(monthNum == '04'){
                //   monthString = 'Apr. '
                // } else if(monthNum == '05'){
                //   monthString = 'May. '
                // } else if(monthNum == '06'){
                //   monthString = 'Jun. '
                // } else if(monthNum == '07'){
                //   monthString = 'Jul. '
                // } else if(monthNum == '08'){
                //   monthString = 'Aug. '
                // } else if(monthNum == '09'){
                //   monthString = 'Sep. '
                // } else if(monthNum == '10'){
                //   monthString = 'Oct. '
                // } else if(monthNum == '11'){
                //   monthString = 'Nov. '
                // } else if(monthNum == '12'){
                //   monthString = 'Dec. '
                // } 
                _joinDate = monthString + '. ' + dayNum + ', ' + yearNum
                _joinDateSecs = response.Item.joinDateSecs

                monthsJoined = Math.ceil((Date.now() - _joinDateSecs)/(86400000*30))
                _loanRate = parseFloat(_lentTotal/monthsJoined, 10).toFixed(2)
                _lendingRate = parseFloat(_lendingRate/monthsJoined, 10).toFixed(2)
                _withdrawalRate = parseFloat(_borrowingRec/monthsJoined, 10).toFixed(2)
                _repayRate = parseFloat(_repaymentTotal/monthsJoined, 10).toFixed(2) 



                highestValue = lowestValue = 0;

                let chartDayRange = that.state.chartDayRange
                for(let t=currentDay; t>=currentDay-chartDayRange; t--){
                  timeArray.unshift(t)
                }
                let firstDayValueFound = false;
                let firstDayValue;
                let firstDayValueIndex;
                let firstDayValueDelta;
                let lastDayValueFound = false;
                let lastDayValue;
                let lastDayValueIndex;
                let previousDayValue1 = 'null';
                let previousDayValueIndex;
                let allZeroValues = []

                let dayValues = []

                for(let j=0; j<=timeArray.length-1; j++){
                  var today = new Date()
                  var dateString = new Date().setDate(today.getDate()-that.state.chartDayRange + j)
                  var dateString = new Date(dateString)
                  dateString = String(dateString)
                  dateString = dateString.substr(4, 11);
                  dateString = dateString.substr(0,6).concat(', ').concat(dateString.substr(7,5))  
                  dateString = dateString.substr(0,3).concat('.').concat(dateString.substr(3,dateString.length-3))

                  allZeroValues.push({ 
                    availableCredit: 0, 
                    name: dateString
                  })
                  
                  if(contracts.interactions.hasOwnProperty(timeArray[j])){

                    previousDayValue1 = contracts.interactions[timeArray[j]].value
                    previousDayValueIndex = j
                    if(firstDayValueFound == false){
                      firstDayValueFound = true
                      firstDayValue = contracts.interactions[timeArray[j]].value
                      // firstDayValue = that.state.availableCredit * 1000000000000000000;
                      firstDayValueDelta = contracts.interactions[timeArray[j]].valueDelta
                      firstDayValueIndex = j
                      previousDayValue1 = firstDayValue
                    }
                  }
                  if(j == timeArray.length-1){
                    if(previousDayValue1 != 'null'){
                      lastDayValueFound = true
                      lastDayValue = previousDayValue1
                      lastDayValueIndex = previousDayValueIndex
                      noDailyDataPointsFoundBool = false
                    } else {
                      _values = allZeroValues
                      noDailyDataPointsFoundBool = true

                      let allZeroDayValuesBool = true 

                      completeGraphGeneration(
                        _targetValue,
                        _minLoan,
                        _totalContributed,
                        _totalWithdrawn,
                        _userContributed,
                        _userFinalized,
                        _userInterestEarned,
                        _approverReceivedRepaymentSum,
                        _borrowerInterestPaid,
                        _totalPaid,
                        _balance,
                        _web3Balance,
                        _compoundedBalance,
                        _canDeleteCreditLineBool,
                        _dateCreated,
                        _approversCt,
                        _intRate,
                        managerDisplay,
                        maxDayValue,
                        minDayValue,
                        _lenders,
                        _offeredLenderCommissionUSD_adjusted,
                        _openValue,
                        _values,
                        _userAvgRating,
                        _blenderScore,
                        _fico,
                        _totalLending,
                        _totalBorrowing,
                        _lentTotal,
                        _borrowingRec,
                        _loanRate,
                        _withdrawalRate,
                        _lendingRate,
                        _repayRate,
                        _joinDate,
                        _repaymentTotal,
                        _availableCreditReadyWithdraw,
                        availableCredit,
                        actionType, 
                        actionTypeStakingBool,
                        actionButton,
                        interactionHeader,
                        requests,
                        blacklisted,
                        wishlistIcon,
                        actionPlaceHolder,
                        whitelistCt,
                        borrowerStatsArray,
                        accountStatsArray,
                        allZeroDayValuesBool,
                      )
                    }
                  }
                }

                function completeGraphGeneration(
                  _targetValue,
                  _minLoan,
                  _totalContributed,
                  _totalWithdrawn,
                  _userContributed,
                  _userFinalized,
                  _userInterestEarned,
                  _approverReceivedRepaymentSum,
                  _borrowerInterestPaid,
                  _totalPaid,
                  _balance,
                  _web3Balance,
                  _compoundedBalance,
                  _canDeleteCreditLineBool,
                  _dateCreated,
                  _approversCt,
                  _intRate,
                  managerDisplay,
                  maxDayValue,
                  minDayValue,
                  _lenders,
                  _offeredLenderCommissionUSD_adjusted,
                  _openValue,
                  _valuesArray,
                  _userAvgRating,
                  _blenderScore,
                  _fico,
                  _totalLending,
                  _totalBorrowing,
                  _lentTotal,
                  _borrowingRec,
                  _loanRate,
                  _withdrawalRate,
                  _lendingRate,
                  _repayRate,
                  _joinDate,
                  _repaymentTotal,
                  _availableCreditReadyWithdraw,
                  availableCredit,
                  actionType, 
                  actionTypeStakingBool,
                  actionButton,
                  interactionHeader,
                  requests,
                  blacklisted,
                  wishlistIcon,
                  actionPlaceHolder,
                  whitelistCt,
                  borrowerStatsArray,
                  accountStatsArray,
                  allZeroDayValuesBool,
                ){

                  let _values = _valuesArray;


                  if(_values[_values.length-1].availableCredit > availableCredit){
                    let offset = _values[_values.length-1].availableCredit - availableCredit
                    for(let n=0; n<=_values.length-1; n++){
                      _values[n].availableCredit = _values[n].availableCredit - offset
                      dayValues[n] = dayValues[n] - offset
                      if(_values[n].availableCredit < 0){
                        _values[n].availableCredit = 0
                      }
                      if(dayValues[n] < 0){
                        dayValues[n] = 0;
                      }
                      if(n==_values.length-1){
                        finishGraphGen()
                      }
                    }
                  } else if(_values[_values.length-1].availableCredit < availableCredit){
                    let offset = availableCredit - _values[_values.length-1].availableCredit
                    for(let n=0; n<=_values.length-1; n++){
                      _values[n].availableCredit = _values[n].availableCredit + offset
                      dayValues[n] = dayValues[n] + offset
                      if(_values[n].availableCredit < 0){
                        _values[n].availableCredit = 0
                      }
                      if(dayValues[n] < 0){
                        dayValues[n] = 0;
                      }
                      if(n==_values.length-1){
                        finishGraphGen()
                      }
                    }
                  } else {
                    finishGraphGen()
                  }

                  async function finishGraphGen(){
                    let v = _values[_values.length-1]
                    let editedValueString = Number(v.availableCredit).toFixed(2)
                    let dateString = v.name
                    dateString = dateString.substr(0,3).concat('.').concat(dateString.substr(3,dateString.length-3))
                    let formattedValueTooltipString = dateString + ' • ' + editedValueString + ' USD'

                    if(String(formattedValueTooltipString[5]) == '0'){
                      formattedValueTooltipString = formattedValueTooltipString.substr(0,5) + formattedValueTooltipString.substr(6,formattedValueTooltipString.length-6)
                    }

                    
                    if(!allZeroDayValuesBool){
                      maxDayValue = Math.max(...dayValues).toFixed(0)
                      minDayValue = Math.min(...dayValues).toFixed(0)
                    } else {
                      maxDayValue = Number(availableCredit)*1.9
                      minDayValue = -1
                    }


                    if(Number(maxDayValue) == 0){
                      maxDayValue = '1'
                    }

                    if(isNaN(maxDayValue) || isNaN(minDayValue)){
                      maxDayValue = Number(availableCredit)*1.9
                      minDayValue = -1
                    }

                    // Keep web staking/account statistics aligned with the validated mobile app.
                    let collateralStakedThisUser = '0';
                    let claimedRewards = '0';
                    let commissionEarned = '0';
                    let availableRewards = '0';

                    try {
                      if (
                        campaign &&
                        campaign.methods &&
                        campaign.methods.getStakerSummary &&
                        campaign.methods.pendingRewards &&
                        publicKey
                      ) {
                        const [stakerSummary, pendingRewardsValue] = await Promise.all([
                          campaign.methods.getStakerSummary(publicKey).call(),
                          campaign.methods.pendingRewards(publicKey).call()
                        ]);
                        collateralStakedThisUser = String(stakerSummary[0] || '0');
                        claimedRewards = String(stakerSummary[1] || '0');
                        availableRewards = String(pendingRewardsValue || stakerSummary[3] || '0');
                        const awaitingPayoutValue = String(stakerSummary[3] || '0');
                        commissionEarned = ethers.BigNumber
                          .from(claimedRewards)
                          .add(ethers.BigNumber.from(awaitingPayoutValue))
                          .toString();

                        that.setState({ availableRewards });
                      }
                    } catch (stakingStatsError) {

                    }

                    if(that.state.selectedLanguage == 'spanish'){

                      borrowerStatsArray = [
                        {
                          statName: 'Marca de Blender',
                          statDesc: "La marca de Blender se resume la relación del miembro entre dar y recibir préstamos.",
                          statValue: Number(_blenderScore).toFixed(0),
                          statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        },
                        {
                          statName: 'Prestando Actualmente',
                          statDesc: "La suma total que este miembro presta actualmente en êsta plataforma.",
                          statValue: Number(_totalLending).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Retirando Actualmente',
                          statDesc: "La suma total que este miembro prestatario toma actualmente en ésta plataforma.",
                          statValue: Number(_totalBorrowing).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Valor Prestado Total',
                          statDesc: "La suma total que este miembro prestatario ha tomado en ésta plataforma.",
                          statValue: Number(_lentTotal).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Valor Retirado Total',
                          statDesc: "La suma total que este miembro prestatario ha prestado en ésta plataforma.",
                          statValue: Number(_borrowingRec).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Valor Pagado Total',
                          statDesc: "La suma pagada de este miembro prestatario sus prestadores en ésta plataforma.",
                          statValue: Number(_repaymentTotal).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Frecuencia de Prestar',
                          statDesc: "La suma total que este miembro prestatario ha tomado en ésta plataforma.",
                          statValue: Number(_loanRate).toFixed(1) + ' x / mes',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Rato de Prestar',
                          statDesc: "El rato de instancias en que ha dado préstamos el miembro prestatario.",
                          statValue: Number(_lendingRate).toFixed(2) + ' USD / mes',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Rato de Retirar',
                          statDesc: "El rato de instancias en que ha tomado préstamos el miembro prestatario.",
                          statValue: Number(_withdrawalRate).toFixed(2) + ' USD / mes',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Rato de Pagar',
                          statDesc: "El rato de instancias en que ha hecho pagos a sus prestadores del miembro prestatario.",
                          statValue: Number(_repayRate).toFixed(2) + ' USD / mes',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Unirse Blender',
                          statDesc: "La fecha de unirse el miembro a The Blender Platform.",
                          statValue: _joinDate,
                          statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        }
                      ]
  
                      if(currentUser == _managerLCase){
                        accountStatsArray = [
                          {
                            statName: 'Valor Retirable',
                            statDesc: "El valor disponible para retirar por el miembro prestatario.",
                            statValue: Number(_availableCreditReadyWithdraw).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Deudas Compuestas',
                            statDesc: "La sum de pagos adeudados de el miembro prestatario a los miembros prestadores.",
                            statValue: Number(_compoundedBalance).toFixed(2) + ' USD',
                            statColor: 'rgba(204, 12, 12, .70)',
                          },
                          {
                            statName: 'Estatus de Pagos',
                            statDesc: "El bienestar de la cuenta por si hay pagos adeudados tardes.",
                            statValue: paymentStatus,
                            statColor: paymentStatus.toLowerCase() == 'good' ? 'rgba(0, 158, 129, 1)' : 'rgba(204, 12, 12, .7)',
                          },
                          {
                            statName: 'Pago Mensual Mínima',
                            statDesc: "El valor adeudado del miembro prestatario por pago de cada mes en que hay deudas.",
                            statValue: Number(_minLoan).toFixed(2) + ' USD',
                            statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          },
                          {
                            statName: 'Fecha de Creación',
                            statDesc: "La fecha de la creación de la cuenta de la línea de crédito.",
                            statValue: _dateCreated,
                            statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          }
                        ]
                      } else {
  
  
                        accountStatsArray = [
                          {
                            statName: 'Valor Prestado',
                            statDesc: "La suma de todos los préstamos pasados que he dado a la línea de crédito.",
                            statValue: Number(_userContributed).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Valor Reclamable',
                            statDesc: "El valor de préstamos que he dado que es disponible para reclamar.",
                            statValue: Number(_safeReclaimableValueWei / 1000000000000000000).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Ganancias de Interes',
                            statDesc: "Los pagos que he recibido de interés provechoso del miembro prestatario.",
                            statValue: Number(_userInterestEarned).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Pagos Recibidos',
                            statDesc: "Los pagos que he recibido del miembro prestatario.",
                            statValue: Number(_approverReceivedRepaymentSum).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Contribución Mínima ',
                            statDesc: "El valor mínimo que un miembro prestador puede prestar por instancía.",
                            statValue: Number(_minLoan).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Tu Valor Apostado',
                            statDesc: "El valor que has apostado al prestatario.",
                            statValue: Number(Number(collateralStakedThisUser) / 1000000000000000000).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Tus Comisiones Ganadas',
                            statDesc: "El valor de las ganancias de apostar, incluyendo las comisiones disponibles y retiradas.",
                            statValue: Number(Number(commissionEarned) / 1000000000000000000).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Tus Comisiones Retiradas',
                            statDesc: "El valor de las ganancias de comisiones que has retirado al Blender Wallet.",
                            statValue: Number(Number(claimedRewards) / 1000000000000000000).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Cantidad de Prestadores',
                            statDesc: "La quantidad de miembros prestadores actuales en este línea de crédito.",
                            statValue: Number(_approversCt).toFixed(0),
                            statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          },
                          {
                            statName: 'Fecha de Creación',
                            statDesc: "La fecha de la creación de la línea de crédito.",
                            statValue: _dateCreated,
                            statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          }
                        ]
                      }

                    } else {

                      borrowerStatsArray = [
                        {
                          statName: 'Blender Score',
                          statDesc: "The Blender Score summarizes a user's repayment to borrowing ratio.",
                          statValue: Number(_blenderScore).toFixed(0),
                          statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        },
                        {
                          statName: 'Currently Lending',
                          statDesc: "The total sum this borrower is currently lending across the platform",
                          statValue: Number(_totalLending).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Currently Borrowing',
                          statDesc: "The total sum this borrower is currently borrowing across the platform",
                          statValue: Number(_totalBorrowing).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Total Lent All-Time',
                          statDesc: "The total sum this borrower has lent across the platform",
                          statValue: Number(_lentTotal).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Total Borrowed All-Time',
                          statDesc: "The total sum this borrower has borrowed across the platform",
                          statValue: Number(_borrowingRec).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Total Repaid All-Time',
                          statDesc: "The total sum this borrower has repaid across the platform",
                          statValue: Number(_repaymentTotal).toFixed(2) + ' USD',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Lending Frequency',
                          statDesc: "The frequency of which this borrower loans funds",
                          statValue: Number(_loanRate).toFixed(1) + ' x / month',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Lending Rate',
                          statDesc: "The frequency at which this borrower loans funds",
                          statValue: Number(_lendingRate).toFixed(2) + ' USD / month',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Borrowing Rate',
                          statDesc: "The rate at which this borrower withdraws loans from created accounts",
                          statValue: Number(_withdrawalRate).toFixed(2) + ' USD / month',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Repayment Rate',
                          statDesc: "The rate at which this borrower repays withdrawn loans from created accounts",
                          statValue: Number(_repayRate).toFixed(2) + ' USD / month',
                          statColor: 'rgba(0, 158, 129, 1)',
                        },
                        {
                          statName: 'Joined Blender',
                          statDesc: "The date this borrower joined The Blender Platform",
                          statValue: _joinDate,
                          statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                        }
                      ]

                      if(currentUser == _managerLCase){
                        accountStatsArray = [
                          {
                            statName: 'Available to Withdraw',
                            statDesc: "The lent total ready for\nyou to withdrawal",
                            statValue: Number(_availableCreditReadyWithdraw).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Compounded Due Debt',
                            statDesc: "The total you currently owe to your lenders",
                            statValue: Number(_compoundedBalance).toFixed(2) + ' USD',
                            statColor: 'rgba(204, 12, 12, .70)',
                          },
                          {
                            statName: 'Payment Status',
                            statDesc: "The minimum monthly payment due if the compounded due debt exceeds this value",
                            statValue: paymentStatus,
                            statColor: paymentStatus.toLowerCase() == 'good' ? 'rgba(0, 158, 129, 1)' : 'rgba(204, 12, 12, .7)',
                          },
                          {
                            statName: 'Minimum Monthly Payment',
                            statDesc: "The minimum monthly payment due if the compounded due debt exceeds this value",
                            statValue: Number(_minLoan).toFixed(2) + ' USD',
                            statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          },
                          {
                            statName: 'Creation Date',
                            statDesc: "The date that account was created.",
                            statValue: _dateCreated,
                            statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          }
                        ]

                      } else {

                        accountStatsArray = [
                          {
                            statName: 'Your Lent Total',
                            statDesc: "The total you've lent to that account",
                            statValue: Number(_userContributed).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Your Reclaimable Total',
                            statDesc: "The amount you've lent which\nyou may take back as a continued lender",
                            statValue: Number(_safeReclaimableValueWei / 1000000000000000000).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Your Interest Profit',
                            statDesc: "The payment profit you've earned from compounded interest",
                            statValue: Number(_userInterestEarned).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Your Received Payments',
                            statDesc: "The repayment value you've received from your borrower",
                            statValue: Number(_approverReceivedRepaymentSum).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Minimum Contribution',
                            statDesc: "The minimum value lendable per lending instance",
                            statValue: Number(_minLoan).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Your Staked Funds',
                            statDesc: "The total value of funds you've staked into this account.",
                            statValue: Number(Number(collateralStakedThisUser) / 1000000000000000000).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Your Commissions Earned',
                            statDesc: "The total staking commissions you've earned, including pending and withdrawn rewards.",
                            statValue: Number(Number(commissionEarned) / 1000000000000000000).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Your Withdrawn Commissions',
                            statDesc: "The staking commissions you've already withdrawn to your Blender Wallet.",
                            statValue: Number(Number(claimedRewards) / 1000000000000000000).toFixed(2) + ' USD',
                            statColor: 'rgba(0, 158, 129, 1)',
                          },
                          {
                            statName: 'Lender Count',
                            statDesc: "The number of current lenders to the account",
                            statValue: Number(_approversCt).toFixed(0),
                            statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          },
                          {
                            statName: 'Creation Date',
                            statDesc: "The date that account was created",
                            statValue: _dateCreated,
                            statColor: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)',
                          }
                        ]
                      }
                      
                    }

                    if(!requests.length > 0){
                      requests.push({
                        requestId: String([...Array(10)].map(i=>(~~(Math.random()*36)).toString(36)).join('')),
                        requestValue: '    -----  ',
                        requestCompleteStatus: false,
                        requestApprovalCount: '-',
                        requestDate: '------    ',
                        approvalCheck: false,
                        iconName: "md-square-outline",
                        approvalRatio: '-',
                        allRequestsIndex: 0,
                        filteredRequestIndex: 0,
                        valid: false
                      })
                    }


                    that.setState({
                      initialTooltipIndex: that.state.chartDayRange, 
                    })              

          

                    that.setState({
                      _targetValue,
                      _minLoan,
                      _totalContributed,
                      _totalWithdrawn,
                      _userContributed,
                      _userFinalized,
                      _userInterestEarned,
                      _approverReceivedRepaymentSum,
                      _borrowerInterestPaid,
                      _totalPaid,
                      _balance,
                      _web3Balance,
                      _compoundedBalance,
                      _dateCreated,
                      _approversCt,
                      _intRate,
                      managerDisplay,
                      maxDayValue,
                      minDayValue,
                      _lenders,
                      _offeredLenderCommissionUSD_adjusted,
                      _openValue,
                      _values,
                      formattedValueTooltipString,
                      _userAvgRating,
                      _blenderScore,
                      _fico,
                      _totalLending,
                      _totalBorrowing,
                      _lentTotal,
                      _borrowingRec,
                      _loanRate,
                      _withdrawalRate,
                      _lendingRate,
                      _repayRate,
                      _joinDate,
                      _repaymentTotal,
                      availableCredit,
                      actionType, 
                      actionTypeStakingBool,
                      actionButton,
                      interactionHeader,
                      requests,
                      blacklisted,
                      wishlistIcon,
                      actionPlaceHolder,
                      whitelistCt,
                      borrowerStatsArray,
                      accountStatsArray,
                      allZeroDayValuesBool
                    }, () => {
                      that.setState({
                        showPageLoader: false,
                        closeContractBoolOverlay: that.state.closeContractBool
                      }, () => {
                        
                      })
                 
                      clearInterval(loadingTextInterval)
                    })
                  }
                }

                authenticatedPut('api1169ba1e', '', { 
                  headers: { Authorization: `Bearer ${cognitoID}` },
                  body: { 
                    category: 'db',
                    tableName: 'users', 
                    primaryKey: currentUser, 
                    requestOperation: 'get',
                  }
                }).then((response) => {
                  publicKey = response.Item.publicKey
                  

                  campaign = new web3.eth.Contract( 
                    thisContract_CampaignContract.abi,
                    contractAddress
                  );
                  
                  campaign.methods.getSummary1().call()
                    .then((res) => {
    
                      web3BalancePost = String(res[0])
                      loanTarget = String(res[1])
                      minimumContribution = String(res[2])
                      interestRate = String(res[3])
                      finalRequestsSum = String(res[4])
                      repaymentSum = String(res[5])
                      totalContributed = String(res[6])
                      approversCount = String(res[7])
                      requestsCt = String(res[8])
                      receiptsCt = String(res[9])
                      approversList = res[10]
                      manager = String(res[11])
                      insuranceTotal = res[12]
                      compoundedInterestPaid = res[13]

                      if(!approversList.includes(publicKey)){
                        that.setState({
                          contributeSignatureNeeded: true
                        })
                      } else {
                        that.setState({
                          contributeSignatureNeeded: false
                        })                        
                      }

                      campaign.methods.getSummary2(publicKey).call()
                        .then((res) => {

                              conversionRateGlobal = 1
                              currentUserLoanTotal = Number(res[0])
                              userLiquidValue = Number(res[1])
                              userFinalizedRequestLoanSum = Number(res[2])
                              approverCheck = res[3]
                              reclaimableValue = Number(res[4])
                              compoundInterestReceived = Number(res[5])
                        
                              if(Number(userLiquidValue) > Number(currentUserLoanTotal) - Number(minimumContribution) - 1){
                                _exitReclaimableValueWei = Number(currentUserLoanTotal) - Number(userFinalizedRequestLoanSum) + 1000
                                _safeReclaimableValueWei = Number(currentUserLoanTotal) - Number(minimumContribution) - 10000000
                              } else {
                                _exitReclaimableValueWei = Number(currentUserLoanTotal) - Number(userFinalizedRequestLoanSum) + 1000
                                _safeReclaimableValueWei = (Number(userLiquidValue) * 0.9) - 10000000
                              }

                              _reclaimableValue = _safeReclaimableValueWei / 1000000000000000000

                              if(_reclaimableValue < 0){
                                _reclaimableValue = 0
                              }
                              if(_exitReclaimableValueWei < 0){
                                _exitReclaimableValueWei = 0
                              }
                              if(_safeReclaimableValueWei < 0){
                                _safeReclaimableValueWei = 0
                              }
                              _valuesONLY = ''

                              function checkForNegatives(b){
                                let lastDayValueIndex = dayValues.length-1
                                if(Number(dayValues[lastDayValueIndex]) < 0){
                                  if(lastDayValueIndex > 0){
                                    dayValues[lastDayValueIndex] = dayValues[lastDayValueIndex-1]
                                  } else {
                                    dayValues[lastDayValueIndex] = 0
                                  }
                                } 

                                var today = new Date()
                                var dateString = new Date().setDate(today.getDate()-that.state.chartDayRange + b)
                                var dateString = new Date(dateString)
                                dateString = String(dateString)
                                dateString = dateString.substr(4, 11);
                                dateString = dateString.substr(0,3).concat('.').concat(dateString.substr(3,3)).concat(', ').concat(dateString.substr(7,5))

                                dataIndexDayMap[String(_values.length)] = dateString

                                if(_values.length <= that.state.chartDayRange && !noDailyDataPointsFoundBool){
                                  _values.push({
                                    name: dateString,
                                    availableCredit: Number(Number(dayValues[lastDayValueIndex]).toFixed(2)),
                                  })
                                  _valuesONLY = _valuesONLY.concat(`${Number(Number(dayValues[lastDayValueIndex]).toFixed(2))}, `)
                                } 


                                
                                if(b == timeArray.length-1 && _values.length > 0){

                                  let allZeroDayValuesBool = false 

                                  completeGraphGeneration(
                                    _targetValue,
                                    _minLoan,
                                    _totalContributed,
                                    _totalWithdrawn,
                                    _userContributed,
                                    _userFinalized,
                                    _userInterestEarned,
                                    _approverReceivedRepaymentSum,
                                    _borrowerInterestPaid,
                                    _totalPaid,
                                    _balance,
                                    _web3Balance,
                                    _compoundedBalance,
                                    _canDeleteCreditLineBool,
                                    _dateCreated,
                                    _approversCt,
                                    _intRate,
                                    managerDisplay,
                                    maxDayValue,
                                    minDayValue,
                                    _lenders,
                                    _offeredLenderCommissionUSD_adjusted,
                                    _openValue,
                                    _values,
                                    _userAvgRating,
                                    _blenderScore,
                                    _fico,
                                    _totalLending,
                                    _totalBorrowing,
                                    _lentTotal,
                                    _borrowingRec,
                                    _loanRate,
                                    _withdrawalRate,
                                    _lendingRate,
                                    _repayRate,
                                    _joinDate,
                                    _repaymentTotal,
                                    _availableCreditReadyWithdraw,
                                    availableCredit,
                                    actionType, 
                                    actionTypeStakingBool,
                                    actionButton,
                                    interactionHeader,
                                    requests,
                                    blacklisted,
                                    wishlistIcon,
                                    actionPlaceHolder,
                                    whitelistCt,
                                    borrowerStatsArray,
                                    accountStatsArray,
                                    allZeroDayValuesBool,
                                  )
                                }
                              }

                              _values = []
                            
                              if(dayValues.length == 0){
                                // _values = []
                                let previousDayValue2
                                for(let b=0; b<=timeArray.length-1; b++){
                                  
                                  if(b < firstDayValueIndex){

                                    if(Number(firstDayValue) - Number(firstDayValueDelta) <= 0){
                                      dayValues.push(0)
                                    } else {

                                      dayValues.push((Number(firstDayValue) - Number(firstDayValueDelta))/1000000000000000000)
                                    }
                                    checkForNegatives(b)
                                  } else if(b == firstDayValueIndex){

                                    dayValues.push((Number(firstDayValue))/1000000000000000000)
                                    previousDayValue2 = firstDayValue 
                                    checkForNegatives(b)
                                  } else if(b >= lastDayValueIndex){
                                    dayValues.push((Number(lastDayValue))/1000000000000000000)
                                    checkForNegatives(b)
                                  } else if(b > firstDayValueIndex && b < lastDayValueIndex){
                                    if(contracts.interactions.hasOwnProperty(timeArray[b])){
                                      dayValues.push((Number(contracts.interactions[timeArray[b]].value))/1000000000000000000)
                                      previousDayValue2 = contracts.interactions[timeArray[b]].value
                                      checkForNegatives(b)
                                    } else {
                                      dayValues.push((Number(previousDayValue2))/1000000000000000000)
                                      checkForNegatives(b)
                                    }
                                  }
                                }
                              } else {
                                checkForNegatives(timeArray.length-1)
                              }
                              
                              that.setState({
                                lenderCount,
                                intRate,
                                openValue,
                                minLoan,
                                totalPaid,
                                totalWithdrawn,
                                userFinalized,
                                userInterestEarned, 
                                borrowerInterestPaid,
                                userContributed,
                                totalValue,
                                availableCreditRatio,
                                riskCoveragePercentage,
                                userRiskValue,
                                targetValue,
                                blenderScore,
                                fico,
                                totalLending,
                                totalBorrowing,
                                repaidRec,
                                borrowingRec,
                                loanRate,
                                withdrawalRate,
                                lendingRate,
                                repayRate,
                                disableChangeChartDayRange: false,
                              })
                          
                      })
                  })
              })
          })
      })
    })

      })
    })
  }

  reloadPage(){

      // Clear the transaction lifecycle immediately so the next transaction
      // starts with fresh values without waiting for the delayed page refresh.
      that.setState({
        showPasswordOverlay: false,
        password: null,
        passwordText: null,
        disableWhileTxn: false,
        pendingTransactionLoaderOverlay: false,
        moneyTransactionLiveValue: '',
      })

      setTimeout(() => {
        that.setState({
          confirmActionPopUpComponent: null,
          successOverlay: false,          
          successSubscriberSavingsOverlay: false,
          refreshingIconBool: false
        })

        that.mountingFunction()

      
    }, 3500)
  }

  componentWillUnmount() {
    this._creditDisplayMounted = false;
    this._creditDisplayRequestId = (this._creditDisplayRequestId || 0) + 1;
    that.setState({
      showPasswordOverlay: false,
      generalNoticeOverlay: false,
      
      verifyIDOverlay: false,
      forceVerifyIDOverlay: false,
      password: null,
      blacklisted: false
    })  
  }


  clearNotifications(){

    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
        category: 'db',
        tableName: 'contracts', 
        primaryKey: contractAddress, 
        requestOperation: 'update',
        updateExpression: `SET notifications = :notifications`, 
        expressionAttributeValues: { 
          ':notifications': 0
        }
      }
    })
  }

  // addCollateralTxn(password){
  //   displayValue = String(that.state.collateralToAddUSD) 

  //   displayValue = parseFloat(displayValue, 10)
  //   displayValue = displayValue.toFixed(2)
    
  //   let weiValue = Number(that.state.collateralToAddUSD) * 1000000000000000000

  //   let weiValueString, weiValueNum, adjustedWeiValueNum;
  //   let randomString = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  //   var timer = setTimeout(() => {
  //     that.setState({
  //       disableWhileTxn: false,
  //       generalNoticeTimedOverlay: false,
  //       generalNoticeOverlay: false,
        
  //       activityIndicator: 
  //       <div style={{ justifyContent: 'center', marginLeft: 0, marginRight: 0, alignContent: 'center', marginTop: 15, marginBottom: 15 }}>
  //         <p style={{ fontWeight: '600', fontSize: 20, textAlign: 'center', color: 'rgba(204, 12, 12, .9)' }}>
  //           {that.state.selectedLanguage == 'spanish' ? 
  //             'Permisos Invalidos'
  //               :
  //             'Incorrect Permissions!'
  //           }
  //         </p>
  //       </div>
  //     })
  //     clearTimeout(errorWarningOverlayTimeout)
  //     errorWarningOverlayTimeout = setTimeout(() => {
  //       that.setState({
  //         activityIndicator: null
  //       })
  //     }, 2500)
  //   }, 15000);

  //   randomString =  randomString.substring(0,18)
  //   weiValueString = String(Math.round(weiValue))

  //   adjustedWeiValueNum = weiValue
    
  //   that.setState({ 
  //     showPasswordOverlay: false,
  //     password: null,
  //     disableWhileTxn: true,
  //     generalNoticeTimedOverlay: true,
  //     generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
  //       'Conectando a Blockchain ...\n\nEste puede hacer por\nuna máxima de 20 segundos.'
  //         :
  //       'Connecting to Blockchain ...\n\nThis may take up to 20s.'
  //     ),
  //   })

  //   try{
  //     campaign.methods.getSummary1().call()
  //       .then((res) => {
  //         web3BalancePre = res[0]

  //         authenticatedPut('api1169ba1e', '', { 
  //           headers: { Authorization: `Bearer ${cognitoID}` },
  //           body: { 
  //             category: 'db',
  //             tableName: 'users', 
  //             primaryKey: currentUser, 
  //             requestOperation: 'get',
  //           }
  //         }).then((response) => {









  //                 publicKey = response.Item.publicKey
  //                 let lastNonce = response.Item.lastNonce
  //                 let emailAddress = response.Item.emailAddress
  //                 let firstName = response.Item.firstName
  //                 let privateKey = response.Item.privateKey
  //                 let bytes = CryptoJS.AES.decrypt(String(privateKey), password);
  //                 let plaintextPK
  //                 try{
  //                   plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
  //                   finishTxn()
  //                 }catch(err){
  //                   
  //                   that.setState({
  //                     disableWhileTxn: false,
  //                     generalNoticeTimedOverlay: false,
  //                     generalNoticeOverlay: false,
  //                     errorTags: 
  //                       <p style={{ textAlign: 'left', }}>
  //                         {that.state.selectedLanguage == 'spanish' ? 
  //                           'Contraseña no Válida'
  //                             :
  //                           'Incorrect Password'
  //                         }
  //                       </p>,
  //                   })
  //                   clearTimeout(errorWarningOverlayTimeout)
  //                   errorWarningOverlayTimeout = setTimeout(() => {
  //                     that.setState({
  //                       activityIndicator: null
  //                     })
  //                   }, 2500)
  //                 }
  //                 function finishTxn(){
  //                   plaintextPK = plaintextPK.substring(64, plaintextPK.length-64)
  //                   // let provider = new HDWalletProvider(
  //                   //   plaintextPK,
  //                   //   "https://rpc.gnosischain.com/"
  //                   // );
                  
  //                   // let providerBlender = new HDWalletProvider(
  //                   //   blenderPrivateKey,
  //                   //   "https://rpc.gnosischain.com/"
  //                   // );
  //                   plaintextPK = null
  //                   privateKey = null
  //                   bytes = null


  //                   web3.eth.getBalance(publicKey)
  //                     .then((balance) => { 

  //                       let currentWalletBalance = Number(balance)
  //                       let campaignPrivate = new web3.eth.Contract(
  //                         thisContract_CampaignContract.abi,
  //                         contractAddress
  //                       )
                       

  //                         let maxValue = (Math.floor(((Number(currentWalletBalance) - (1100000 * Number(proposeGasPrice) * 1.05)) * 100)/1000000000000000000)/100)
  //                         maxValue = maxValue.toFixed(2)
  //                         if(Number(maxValue) < 0){
  //                           maxValue = 0
  //                         }

  //                         web3.eth.getTransactionCount(publicKey).then((nonce) => {
  //                           let minimumBalance = Number(weiValueString) + 1100000 * Number(proposeGasPrice)
  //                           if(Number(currentWalletBalance) <= Number(minimumBalance)){
  //                             
  //                             that.setState({
  //                               disableWhileTxn: false,
  //                               generalNoticeTimedOverlay: false,
  //                               generalNoticeOverlay: false,
                                
  //                               activityIndicator: 
  //                               <div style={{ height: 100, width: 300, justifyContent: 'center', marginLeft: 0, marginRight: 0, alignItems: 'center',  }}>
  //                                 <p style={{ fontSize: 20, textAlign: 'center', textAlignVertical: 'center', fontWeight: '600', color: 'rgba(204, 12, 12, .9)' }}>
  //                                   {that.state.selectedLanguage == 'spanish' ? 
  //                                     'Valor de Cartera Insuficiente\n\n'
  //                                       :
  //                                     'Insufficient Wallet Balance\n\n'
  //                                   }
  //                                   <p style={{ fontSize: 16, color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)', }}>  
  //                                     {String(`Blender Wallet Balance is `)}
  //                                     {that.state.selectedLanguage == 'spanish' ? 
  //                                       `Valor de Cartera Blender es `
  //                                         :
  //                                       `Blender Wallet Balance is `
  //                                     }
  //                                   </p>
  //                                   <p style={{ fontSize: 16, color: that.state.mode_light_dark == 'light' ? 'rgba(0, 0, 0, 1)' : 'rgba(177, 177, 177, 1)' }}>
  //                                     {String(`${that.state.walletBalanceUSD} USD`)}
  //                                   </p>
  //                                 </p> 
  //                               </div>
  //                             })
  //                             clearTimeout(errorWarningOverlayTimeout)
  //                             errorWarningOverlayTimeout = setTimeout(() => {
  //                               that.setState({
  //                                 activityIndicator: null,
  //                                 actionValue: String(maxValue)
  //                               })
  //                               if(that.state.confirmActionPopUp == true){
  //                                 that.toggleModal1(null, null, null, null, Number(maxValue) < Number(minimumContribution)/1000000000000000000)
  //                               }
  //                             }, 3000)

  //                           } else {

  //                             campaignPrivate.methods.increaseCollateral(
  //                               false, 
  //                               '0'
  //                             ).send({
  //                               chainId: 100,
  //                               gasLimit: '1500000',
  //                               gasPrice: String(proposeGasPrice),
  //                               value: (Number(weiValueString)).toLocaleString('fullwide', {useGrouping: false}),
  //                               from: publicKey
  //                             }).on('transactionHash', function(newTxnHash){
                            
  //                               campaignPrivate = null 

  //                               

  //                               campaign.methods.getSummary1().call()
  //                                 .then((res) => {
  //                                   web3BalancePost = res[0]
  //                                   loanTarget = res[1]
  //                                   minimumContribution = res[2]
  //                                   interestRate = res[3]
  //                                   finalRequestsSum = res[4]
  //                                   repaymentSum = res[5]
  //                                   totalContributed = res[6]
  //                                   approversCount = res[7]
  //                                   requestsCt = res[8]
  //                                   receiptsCt = res[9]
  //                                   approversList = res[10]
  //                                   manager = res[11]
  //                                   insuranceTotal = res[12]
  //                                   compoundedInterestPaid = res[13]


  //                                   campaign.methods.getSummary2(publicKey).call()
  //                                     .then((res) => {
  //                                       currentUserLoanTotal = Number(res[0])
  //                                       userLiquidValue = Number(res[1])
  //                                       userFinalizedRequestLoanSum = Number(res[2])
  //                                       approverCheck = res[3]
  //                                       reclaimableValue = Number(res[4])
  //                                       compoundInterestReceived = Number(res[5])
                          
  //                                       let _dateCreated = new Date()
  //                                       _dateCreated = String(_dateCreated).substring(0,10)

  //                                       let monthNum = _dateCreated.substr(5,2)
  //                                       let yearNum = _dateCreated.substr(0,4)
  //                                       let dayNum = _dateCreated.substr(8,2)
  //                                       let monthString
  //                                       if(monthNum == '01'){
  //                                         monthString = 'Jan. '
  //                                       } else if(monthNum == '02'){
  //                                         monthString = 'Feb. '
  //                                       } else if(monthNum == '03'){
  //                                         monthString = 'Mar. '
  //                                       } else if(monthNum == '04'){
  //                                         monthString = 'Apr. '
  //                                       } else if(monthNum == '05'){
  //                                         monthString = 'May. '
  //                                       } else if(monthNum == '06'){
  //                                         monthString = 'Jun. '
  //                                       } else if(monthNum == '07'){
  //                                         monthString = 'Jul. '
  //                                       } else if(monthNum == '08'){
  //                                         monthString = 'Aug. '
  //                                       } else if(monthNum == '09'){
  //                                         monthString = 'Sep. '
  //                                       } else if(monthNum == '10'){
  //                                         monthString = 'Oct. '
  //                                       } else if(monthNum == '11'){
  //                                         monthString = 'Nov. '
  //                                       } else if(monthNum == '12'){
  //                                         monthString = 'Dec. '
  //                                       } 
  //                                       _dateCreated = monthString + dayNum + ', ' + yearNum

  //                                       var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  //                                       randomString1 =  randomString1.substring(0,18)

  //                                       var randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  //                                       randomString2 =  randomString2.substring(0,18)

                                       
  //                                         authenticatedPut('api1169ba1e', '', { 
  //                                           headers: { Authorization: `Bearer ${cognitoID}` },
  //                                           body: { 
  //                                             category: 'db',
  //                                             tableName: 'pendingTransactions', 
  //                                             primaryKey: newTxnHash, 
  //                                             requestOperation: 'update',
  //                                             updateExpression: 
  //                                               `SET 
  //                                                 transactionType = :txnType,
  //                                                 creationDate = :creationDate, 
  //                                                 creationDateSecs = :creationDateSecs, 
  //                                                 #st = :status, 
  //                                                 currentUser = :currentUser,
  //                                                 publicKey = :publicKey,
  //                                                 emailType = :emailType,
  //                                                 firstName = :firstName,
  //                                                 emailAddress = :emailAddress,
  //                                                 randomString1 = :randomString1,
  //                                                 randomString2 = :randomString2,
  //                                                 manager = :managerUsername,
  //                                                 adjustedWeiValueNum = :adjustedWeiValueNum,
  //                                                 web3BalancePre = :web3BalancePre,
  //                                                 web3BalancePost = :web3BalancePost,
  //                                                 interestRate = :interestRate,
  //                                                 finalRequestsSum = :finalRequestsSum,
  //                                                 repaymentSum = :repaymentSum,
  //                                                 totalContributed = :totalContributed,
  //                                                 approversCount = :approversCount,
  //                                                 requestsCt = :requestsCt,
  //                                                 receiptsCt = :receiptsCt,
  //                                                 approversList = :approversList,
  //                                                 currentUserLoanTotal = :currentUserLoanTotal,
  //                                                 userLiquidValue = :userLiquidValue,
  //                                                 userFinalizedRequestLoanSum = :userFinalizedRequestLoanSum,
  //                                                 approverCheck = :approverCheck,
  //                                                 reclaimableValue = :reclaimableValue,
  //                                                 contractAddress = :contractAddress,
  //                                                 application = :application,
  //                                                 displayValue = :displayValue,
  //                                                 lookupKey = :lookupKey,
  //                                                 currency = :currency,
  //                                                 conversionRateGlobal = :conversionRateGlobal,
  //                                                 availableCredit = :availableCredit,
  //                                                 offeredLenderCommissionUSD = :offeredLenderCommissionUSD,
  //                                                 contractStructure = :contractStructure,
  //                                                 settlementDate = :settlementDate,
  //                                                 closureDate = :closureDate,
  //                                                 loanTarget = :loanTarget
  //                                               `,
  //                                             expressionAttributeNames: {"#st":"status"},
  //                                             expressionAttributeValues: { 
  //                                               ':txnType': 'increaseCollateral',
  //                                               ':creationDate': new Date(),
  //                                               ':creationDateSecs': Date.now(), 
  //                                               ':currentUser': currentUser,
  //                                               ':status': 'active',
  //                                               ':managerUsername': _managerLCase,
  //                                               ':publicKey': publicKey,
  //                                               ':lookupKey': _lookupKey,
  //                                               ':emailAddress': emailAddress,
  //                                               ':emailType': 'contribution',
  //                                               ':randomString1': randomString1,
  //                                               ':randomString2': randomString2,
  //                                               ':firstName': firstName,
  //                                               ':adjustedWeiValueNum': adjustedWeiValueNum,
  //                                               ':web3BalancePre': web3BalancePre,
  //                                               ':web3BalancePost': web3BalancePost,
  //                                               ':interestRate': interestRate,
  //                                               ':finalRequestsSum': finalRequestsSum,
  //                                               ':repaymentSum': repaymentSum,
  //                                               ':totalContributed': totalContributed,
  //                                               ':approversCount': approversCount,
  //                                               ':requestsCt': requestsCt,
  //                                               ':receiptsCt': receiptsCt,
  //                                               ':approversList': approversList,
  //                                               ':currentUserLoanTotal': currentUserLoanTotal,
  //                                               ':userLiquidValue': userLiquidValue,
  //                                               ':userFinalizedRequestLoanSum': userFinalizedRequestLoanSum,
  //                                               ':approverCheck': approverCheck,
  //                                               ':reclaimableValue': reclaimableValue,
  //                                               ':contractAddress': contractAddress,
  //                                               ':application': 'TBP',
  //                                               ':displayValue': displayValue,
  //                                               ':currency': 'USD',
  //                                               ':conversionRateGlobal': 1,
  //                                               ':availableCredit': Number(availableCredit)*1000000000000000000,
  //                                               ':offeredLenderCommissionUSD': offeredLenderCommissionUSD,
  //                                               ':contractStructure': contractStructureType,
  //                                               ':settlementDate': settlementDateFormatted,
  //                                               ':closureDate': closureDateFormatted,
  //                                               ':loanTarget': loanTarget
  //                                             }
  //                                           }
  //                                         }).then((res) => {
  //                                           authenticatedPut('api1169ba1e', '', { 
  //                                             headers: { Authorization: `Bearer ${cognitoID}` },
  //                                             body: { 
  //                                                 category: 'db',
  //                                                 tableName: 'users', 
  //                                                 primaryKey: currentUser,
  //                                                 requestOperation: 'update',
  //                                                 updateExpression: 
  //                                                     `SET proxy
  //                                                         lastNonce = :lastNonce
  //                                                     `,
  //                                                 expressionAttributeValues: { 
  //                                                     ':lastNonce': nonce
  //                                                 },
  //                                             }
  //                                           }).then((res) => {
  //                                             authenticatedPut('api1169ba1e', '', { 
  //                                               headers: { Authorization: `Bearer ${cognitoID}` },
  //                                               body: { 
  //                                                 category: 'db',
  //                                                 tableName: 'general', 
  //                                                 primaryKey: 'txnHash', 
  //                                                 requestOperation: 'update',
  //                                                 updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
  //                                                 expressionAttributeValues: { 
  //                                                   ':txnHash': [newTxnHash]
  //                                                 }
  //                                               }
  //                                             }).then((res) => {
  //                                               that.setState({
  //                                                 successOverlay: true,
  //                                                 generalNoticeTimedOverlay: true,
  //                                                 generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
  //                                                   'Exito!\n\nReseña su email en pronto para confirmación segunda.'
  //                                                     :
  //                                                   'Success!\n\nCheck your email soon for a second confirmation.'
  //                                                 ),
  //                                                 actionValue: null,
  //                                                 disableWhileTxn: false,
  //                                                 generalNoticeTimedOverlay: false,
  //                                                 generalNoticeOverlay: false,
                                                  
  //                                                 confirmActionPopUpComponent: null,
                                                  
  //                                               })
  //                                               clearTimeout(errorWarningOverlayTimeout)
  //                                               errorWarningOverlayTimeout = setTimeout(() => {
  //                                                 that.setState({
                                                      // pendingTransactionLoaderOverlay: false
  //                                                 })
  //                                               }, 2500)
  //                                               that.reloadPage()
  
  //                                             })
  //                                           })
  //                                         })
                                          
                                        
  //                                     })
  //                                 })
                              
  //                             })
  //                           }
  //                         })
                        
  //                   })
  //                 }



          
  //       })
  //     })
  //   } catch(error) {
  //     return
  //   }
  // }





  closeContractTxn(password){
    displayValue = String(that.state.collateralToAddUSD) 

    displayValue = parseFloat(displayValue, 10)
    displayValue = displayValue.toFixed(2)
    
    let weiValue = Number(that.state.collateralToAddUSD) * 1000000000000000000

    let weiValueString, weiValueNum, adjustedWeiValueNum;
    let randomString = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    randomString =  randomString.substring(0,18)
    weiValueString = String(Math.round(weiValue))

    adjustedWeiValueNum = weiValue
    
    that.setState({ 
      showPasswordOverlay: false,
      generalNoticeOverlay: false,
      
      password: null,
      disableWhileTxn: true,
      generalNoticeTimedOverlay: true,
    })

    try{
      campaign.methods.getSummary1().call()
        .then((res) => {
          web3BalancePre = res[0]

          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'users', 
              primaryKey: currentUser, 
              requestOperation: 'get',
            }
          }).then((response) => {









            publicKey = response.Item.publicKey
            let lastNonce = response.Item.lastNonce
            let emailAddress = response.Item.emailAddress
            let firstName = response.Item.firstName
            let privateKey = response.Item.privateKey
            let bytes = CryptoJS.AES.decrypt(String(privateKey), password);
            let plaintextPK
            try{
              plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
              finishTxn()
            }catch(err){
              
              that.setState({
                disableWhileTxn: false,
                generalNoticeTimedOverlay: false,
                generalNoticeOverlay: false,
                pendingTransactionLoaderOverlay: false,
                errorTags: 
                  <p style={{ textAlign: 'left', }}>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Contraseña no Válida'
                        :
                      'Incorrect Password'
                    }
                  </p>,
              })
            }
            function finishTxn(){
              plaintextPK = plaintextPK.substring(64, plaintextPK.length-64)
              // let provider = new HDWalletProvider(
              //   plaintextPK,
              //   "https://rpc.gnosischain.com/"
              // );

            
              // let providerBlender = new HDWalletProvider(
              //   blenderPrivateKey,
              //   "https://rpc.gnosischain.com/"
              // );
              plaintextPK = null
              privateKey = null
              bytes = null


              let undecimaledTransactionValue = Number(Number(_compoundedBalance).toFixed(0)) 
              let undecimaledTransactionValueWei = String(undecimaledTransactionValue) + '000000000000000000'
              _weiCompoundedBalance = undecimaledTransactionValueWei

              let compoundedDebtBool = Number(_compoundedBalance) > Number(finalRequestsSum) - Number(repaymentSum)


              highRateWeb3.eth.getBalance(publicKey)
                .then((balance) => { 

                  let currentWalletBalance = Number(balance)
                  let campaignPrivate = new highRateWeb3.eth.Contract(
                    thisContract_CampaignContract.abi,
                    contractAddress
                  )
                  
                    highRateWeb3.eth.getTransactionCount(publicKey).then((nonce) => {
                      let minimumBalance = 15000000 * Number(proposeGasPrice)
                      if(Number(currentWalletBalance) <= Number(minimumBalance)){
                        
                        that.setState({
                          disableWhileTxn: false,
                          generalNoticeTimedOverlay: false,
                          generalNoticeOverlay: false,
                          errorTags: 
                            <p style={{ textAlign: 'left' }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                `Fondos Insuficientes - El límite de tu Cartera Blender es ${spendableWalletUSD(balance, proposeGasPrice, 15000000).toFixed(2)} USD`
                                  :
                                `Insufficient Funds - Your Blender Wallet Balance Limit is ${spendableWalletUSD(balance, proposeGasPrice, 15000000).toFixed(2)} USD`
                              }
                            </p>
                        })

                      } else {
                        throw 'forcedError';

                        campaignPrivate.methods.closeContract(
                          String(_weiCompoundedBalance), 
                          String(compoundedDebtBool)
                        ).send({
                          chainId: 100,
                          gasLimit: '1500000',
                          gasPrice: String(proposeGasPrice),
                          from: publicKey
                        }).on('transactionHash', function(newTxnHash){
                      
                          campaignPrivate = null 

                          

                          campaign.methods.getSummary1().call()
                            .then((res) => {
                              web3BalancePost = res[0]
                              loanTarget = res[1]
                              minimumContribution = res[2]
                              interestRate = res[3]
                              finalRequestsSum = res[4]
                              repaymentSum = res[5]
                              totalContributed = res[6]
                              approversCount = res[7]
                              requestsCt = res[8]
                              receiptsCt = res[9]
                              approversList = res[10]
                              manager = res[11]
                              insuranceTotal = res[12]
                              compoundedInterestPaid = res[13]


                              campaign.methods.getSummary2(publicKey).call()
                                .then((res) => {
                                  currentUserLoanTotal = Number(res[0])
                                  userLiquidValue = Number(res[1])
                                  userFinalizedRequestLoanSum = Number(res[2])
                                  approverCheck = res[3]
                                  reclaimableValue = Number(res[4])
                                  compoundInterestReceived = Number(res[5])
                    
                                  let _dateCreated = new Date()
                                  _dateCreated = String(_dateCreated).substring(0,10)

                                  let monthNum = _dateCreated.substr(5,2)
                                  let yearNum = _dateCreated.substr(0,4)
                                  let dayNum = _dateCreated.substr(8,2)
                                  let monthString
                                  if(monthNum == '01'){
                                    monthString = 'Jan. '
                                  } else if(monthNum == '02'){
                                    monthString = 'Feb. '
                                  } else if(monthNum == '03'){
                                    monthString = 'Mar. '
                                  } else if(monthNum == '04'){
                                    monthString = 'Apr. '
                                  } else if(monthNum == '05'){
                                    monthString = 'May. '
                                  } else if(monthNum == '06'){
                                    monthString = 'Jun. '
                                  } else if(monthNum == '07'){
                                    monthString = 'Jul. '
                                  } else if(monthNum == '08'){
                                    monthString = 'Aug. '
                                  } else if(monthNum == '09'){
                                    monthString = 'Sep. '
                                  } else if(monthNum == '10'){
                                    monthString = 'Oct. '
                                  } else if(monthNum == '11'){
                                    monthString = 'Nov. '
                                  } else if(monthNum == '12'){
                                    monthString = 'Dec. '
                                  } 
                                  _dateCreated = monthString + dayNum + ', ' + yearNum

                                  var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                  randomString1 =  randomString1.substring(0,18)

                                  var randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                  randomString2 =  randomString2.substring(0,18)

                                 
                                  
                                    authenticatedPut('api1169ba1e', '', { 
                                      headers: { Authorization: `Bearer ${cognitoID}` },
                                      body: { 
                                        category: 'db',
                                        tableName: 'pendingTransactions', 
                                        primaryKey: newTxnHash, 
                                        requestOperation: 'update',
                                        updateExpression: 
                                          `SET 
                                            transactionType = :txnType,
                                            creationDate = :creationDate, 
                                            creationDateSecs = :creationDateSecs, 
                                            currentUser = :currentUser,
                                            publicKey = :publicKey,
                                            emailType = :emailType,
                                            firstName = :firstName,
                                            emailAddress = :emailAddress,
                                            randomString1 = :randomString1,
                                            randomString2 = :randomString2,
                                            manager = :managerUsername,
                                            adjustedWeiValueNum = :adjustedWeiValueNum,
                                            web3BalancePre = :web3BalancePre,
                                            web3BalancePost = :web3BalancePost,
                                            interestRate = :interestRate,
                                            finalRequestsSum = :finalRequestsSum,
                                            repaymentSum = :repaymentSum,
                                            totalContributed = :totalContributed,
                                            approversCount = :approversCount,
                                            requestsCt = :requestsCt,
                                            receiptsCt = :receiptsCt,
                                            approversList = :approversList,
                                            currentUserLoanTotal = :currentUserLoanTotal,
                                            userLiquidValue = :userLiquidValue,
                                            userFinalizedRequestLoanSum = :userFinalizedRequestLoanSum,
                                            approverCheck = :approverCheck,
                                            reclaimableValue = :reclaimableValue,
                                            contractAddress = :contractAddress,
                                            application = :application,
                                            displayValue = :displayValue,
                                            lookupKey = :lookupKey,
                                            currency = :currency,
                                            conversionRateGlobal = :conversionRateGlobal
                                          `,
                                        expressionAttributeValues: { 
                                          ':txnType': 'closeContract',
                                          ':creationDate': new Date(),
                                          ':creationDateSecs': Date.now(), 
                                          ':currentUser': currentUser,
                                          
                                          ':managerUsername': _managerLCase,
                                          ':publicKey': publicKey,
                                          ':lookupKey': _lookupKey,
                                          ':emailAddress': emailAddress,
                                          ':emailType': 'contribution',
                                          ':randomString1': randomString1,
                                          ':randomString2': randomString2,
                                          ':firstName': firstName,
                                          ':adjustedWeiValueNum': adjustedWeiValueNum,
                                          ':web3BalancePre': web3BalancePre,
                                          ':web3BalancePost': web3BalancePost,
                                          ':interestRate': interestRate,
                                          ':finalRequestsSum': finalRequestsSum,
                                          ':repaymentSum': repaymentSum,
                                          ':totalContributed': totalContributed,
                                          ':approversCount': approversCount,
                                          ':requestsCt': requestsCt,
                                          ':receiptsCt': receiptsCt,
                                          ':approversList': approversList,
                                          ':currentUserLoanTotal': currentUserLoanTotal,
                                          ':userLiquidValue': userLiquidValue,
                                          ':userFinalizedRequestLoanSum': userFinalizedRequestLoanSum,
                                          ':approverCheck': approverCheck,
                                          ':reclaimableValue': reclaimableValue,
                                          ':contractAddress': contractAddress,
                                          ':application': 'TBP',
                                          ':displayValue': displayValue,
                                          ':currency': 'USD',
                                          ':conversionRateGlobal': 1,
                                        }
                                      }
                                    }).then((res) => {

                                        authenticatedPut('api1169ba1e', '', { 
                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                          body: { 
                                            category: 'db',
                                            tableName: 'general', 
                                            primaryKey: 'txnHash', 
                                            requestOperation: 'update',
                                            updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                                            expressionAttributeValues: { 
                                              ':txnHash': [newTxnHash]
                                            }
                                          }
                                        }).then((res) => {

                                          that.setState({
                                            successOverlay: true,
                                            generalNoticeOverlay: true,
                                            generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
                                              `Has cerrado tu línea de crédito.`
                                                :
                                              `You've closed your credit line.`
                                            ),
                                            pendingTransactionLoaderOverlay: false
                                          })
                                          that.reloadPage()
                                        })
                                    })
                                    
                                  
                                })
                            })
                        
                        })
                      }
                    })
                  
              })
            }
          
        })
      })
    } catch(error) {
      return
    }
  }


  async writeValidatedPendingTransactionAndQueue(txnHash, record, nonce = null) {
    const fields = Object.keys(record);
    const attributeNames = {};
    const attributeValues = {};

    fields.forEach((field, index) => {
      attributeNames['#field' + index] = field;
      attributeValues[':value' + index] = record[field];
    });

    await authenticatedPut('api1169ba1e', '', {
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: {
        category: 'db',
        tableName: 'pendingTransactions',
        primaryKey: txnHash,
        requestOperation: 'update',
        updateExpression: 'SET ' + fields.map((field, index) => '#field' + index + ' = :value' + index).join(', '),
        expressionAttributeNames: attributeNames,
        expressionAttributeValues: attributeValues
      }
    });

    const pendingCheck = await authenticatedPut('api1169ba1e', '', {
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: {
        category: 'db',
        tableName: 'pendingTransactions',
        primaryKey: txnHash,
        requestOperation: 'get'
      }
    });

    if (!pendingCheck || !pendingCheck.Item || pendingCheck.Item.transactionType !== record.transactionType) {
      throw new Error('PENDING_TRANSACTION_WRITE_NOT_VERIFIED_' + record.transactionType);
    }

    if (nonce !== null && nonce !== undefined) {
      await authenticatedPut('api1169ba1e', '', {
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: {
          category: 'db',
          tableName: 'users',
          primaryKey: record.currentUser,
          requestOperation: 'update',
          updateExpression: 'SET lastNonce = :lastNonce',
          expressionAttributeValues: { ':lastNonce': Number(nonce) }
        }
      });
    }

    const queueResponse = await authenticatedPut('api1169ba1e', '', {
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: {
        category: 'db',
        tableName: 'general',
        primaryKey: 'txnHash',
        requestOperation: 'get'
      }
    });

    if (!(queueResponse.Item && Array.isArray(queueResponse.Item.txnHash) && queueResponse.Item.txnHash.includes(txnHash))) {
      await authenticatedPut('api1169ba1e', '', {
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: {
          category: 'db',
          tableName: 'general',
          primaryKey: 'txnHash',
          requestOperation: 'update',
          updateExpression: 'SET txnHash = list_append(if_not_exists(txnHash, :emptyList), :txnHash)',
          expressionAttributeValues: {
            ':emptyList': [],
            ':txnHash': [txnHash]
          }
        }
      });
    }

    return txnHash;
  }


  async uploadStakePendingTransaction(pendingStake) {

    const fields = Object.keys(pendingStake.record);
    const attributeNames = {};
    const attributeValues = {};

    fields.forEach((field, index) => {
      attributeNames['#field' + index] = field;
      attributeValues[':value' + index] = pendingStake.record[field];
    });

    if (!pendingStake.recordSaved) {
      await authenticatedPut('api1169ba1e', '', {
        body: {
          category: 'db',
          tableName: 'pendingTransactions',
          primaryKey: pendingStake.txnHash,
          requestOperation: 'update',
          updateExpression: 'SET ' + fields.map((field, index) => '#field' + index + ' = :value' + index).join(', '),
          expressionAttributeNames: attributeNames,
          expressionAttributeValues: attributeValues
        }
      });

      const pendingCheck = await authenticatedPut('api1169ba1e', '', {
        body: {
          category: 'db',
          tableName: 'pendingTransactions',
          primaryKey: pendingStake.txnHash,
          requestOperation: 'get'
        }
      });

      if (!pendingCheck || !pendingCheck.Item || pendingCheck.Item.transactionType !== pendingStake.record.transactionType) {
        throw new Error('STAKE_PENDING_TRANSACTION_WRITE_NOT_VERIFIED');
      }

      pendingStake.recordSaved = true;
    }

    if (!pendingStake.nonceSaved) {
      await authenticatedPut('api1169ba1e', '', {
        body: {
          category: 'db',
          tableName: 'users',
          primaryKey: pendingStake.record.currentUser,
          requestOperation: 'update',
          updateExpression: 'SET lastNonce = :lastNonce',
          expressionAttributeValues: { ':lastNonce': pendingStake.nonce }
        }
      });
      pendingStake.nonceSaved = true;
    }

    const receiptResponse = await authenticatedPut('api1169ba1e', '', {
      body: {
        category: 'db',
        tableName: 'receipts',
        primaryKey: pendingStake.record.randomString1,
        requestOperation: 'get'
      }
    });

    if (receiptResponse.Item && receiptResponse.Item.txnHash === pendingStake.txnHash) return;

    const queueResponse = await authenticatedPut('api1169ba1e', '', {
      body: {
        category: 'db',
        tableName: 'general',
        primaryKey: 'txnHash',
        requestOperation: 'get'
      }
    });

    if (!(queueResponse.Item && Array.isArray(queueResponse.Item.txnHash) && queueResponse.Item.txnHash.includes(pendingStake.txnHash))) {
      await authenticatedPut('api1169ba1e', '', {
        body: {
          category: 'db',
          tableName: 'general',
          primaryKey: 'txnHash',
          requestOperation: 'update',
          updateExpression: 'SET txnHash = list_append(if_not_exists(txnHash, :empty), :txnHash)',
          expressionAttributeValues: {
            ':empty': [],
            ':txnHash': [pendingStake.txnHash]
          }
        }
      });
    }

  }

  async retryStakePendingTransaction(pendingStake = that.state.pendingStakeRegistration) {

    if (!pendingStake || that.stakeRegistrationSaving) return;
    that.stakeRegistrationSaving = true;
    that.setState({
      stakeConfirmation: {
        amount: pendingStake.record.displayValue,
        txHash: pendingStake.txnHash,
        registrationStatus: 'SAVING'
      }
    });

    try {
      await that.uploadStakePendingTransaction(pendingStake);
      that.setState({
        pendingStakeRegistration: null,
        stakeConfirmation: {
          amount: pendingStake.record.displayValue,
          txHash: pendingStake.txnHash,
          registrationStatus: 'SAVED'
        }
      });
    } catch (error) {
      that.setState({
        pendingStakeRegistration: pendingStake,
        stakeConfirmation: {
          amount: pendingStake.record.displayValue,
          txHash: pendingStake.txnHash,
          registrationStatus: 'FAILED'
        }
      });
    } finally {
      that.stakeRegistrationSaving = false;
    }

  }

  stakeTxn(password){
    if (!that.state.alreadyVerified || !currentUser ||
        String(that.state.managerUsername).toLowerCase() == String(currentUser).toLowerCase()) {
      that.setState({ pendingTransactionLoaderOverlay: false, disableWhileTxn: false });
      return;
    }

    let weiValueString;
    try {
      weiValueString = ethers.utils.parseUnits(String(that.state.moneyTransactionLiveValue).trim(), 18).toString();
      if (ethers.BigNumber.from(weiValueString).lte(0)) throw new Error('INVALID_AMOUNT');
    } catch (error) {
      that.setState({
        pendingTransactionLoaderOverlay: false,
        disableWhileTxn: false,
        errorTags: <p>{that.state.selectedLanguage == 'spanish' ? 'Ingresa un Importe Válido.' : 'Enter a Valid Stake Amount.'}</p>,
      });
      return;
    }

    that.setState({
      showPasswordOverlay: false,
      password: null,
      passwordText: null,
      disableWhileTxn: true,
      pendingTransactionLoaderOverlay: true
    });

    authenticatedPut('api1169ba1e', '', {
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: {
        category: 'db',
        tableName: 'users',
        primaryKey: currentUser,
        requestOperation: 'get',
      }
    }).then((response) => {
      publicKey = response.Item.publicKey;
      const encryptedPrivateKey = response.Item.privateKey;
      const bytes = CryptoJS.AES.decrypt(String(encryptedPrivateKey), password);
      let plaintextPK;

      try {
        plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
        plaintextPK = plaintextPK.substring(64, plaintextPK.length - 64);
        if (!plaintextPK) throw new Error('BAD_PASSWORD');
      } catch (err) {
        that.setState({
          disableWhileTxn: false,
          pendingTransactionLoaderOverlay: false,
          errorTags:
            <p style={{ textAlign: 'left' }}>
              {that.state.selectedLanguage == 'spanish' ? 'Contraseña no Válida' : 'Incorrect Password'}
            </p>,
        });
        return;
      }

      const stakeUser = response.Item;
      if (!stakeUser.firstName || !stakeUser.emailAddress) {
        throw new Error('User confirmation details unavailable');
      }
      const stakeAddress = contractAddress;
      const stakeManager = String(that.state.managerUsername).toLowerCase();
      const stakeUsername = currentUser;
      const campaignPrivate = new highRateWeb3.eth.Contract(
        thisContract_CampaignContract.abi,
        stakeAddress
      );

      Promise.all([
        highRateWeb3.eth.getBalance(publicKey),
        highRateWeb3.eth.getTransactionCount(publicKey, 'pending'),
        campaignPrivate.methods.getSummary1().call(),
        campaignPrivate.methods.stakerCollateralValue(publicKey).call(),
        campaignPrivate.methods.totalCollateralAssistanceOwed_staker().call(),
        campaignPrivate.methods.integerCommissionPCT().call(),
        campaignPrivate.methods.integerStakerDerivedCommissionPCT().call(),
        authenticatedPut('api1169ba1e', '', {
          body: {
            category: 'db',
            tableName: 'contracts',
            primaryKey: stakeAddress,
            requestOperation: 'get'
          }
        })
      ]).then(([balance, nonce, summary, existingStake, totalStake, commissionPercent, stakerPercent, contractResponse]) => {
        if (!contractResponse.Item || !contractResponse.Item.lookupKey) {
          throw new Error('Credit-Line record unavailable');
        }

        const stakeholderShare = ethers.BigNumber.from(String(existingStake)).add(weiValueString);
        const totalStakeAfter = ethers.BigNumber.from(String(totalStake)).add(weiValueString);
        const stakerCommissionPercentEntitle = Number(stakeholderShare
          .mul(String(commissionPercent))
          .mul(String(stakerPercent))
          .mul(10000)
          .div(totalStakeAfter)
          .div(100)
          .toString()) / 10000;
        const gasLimit = 1500000;
        const minimumBalance = ethers.BigNumber.from(weiValueString).add(ethers.BigNumber.from(String(proposeGasPrice)).mul(gasLimit));

        if (ethers.BigNumber.from(String(balance)).lt(minimumBalance)) {
          that.setState({
            disableWhileTxn: false,
            pendingTransactionLoaderOverlay: false,
            errorTags:
              <p style={{ textAlign: 'left' }}>
                {that.state.selectedLanguage == 'spanish'
                  ? `Fondos Insuficientes - El límite de tu Cartera Blender es ${spendableWalletUSD(balance, proposeGasPrice, 1500000).toFixed(2)} USD`
                  : `Insufficient Funds - Your Blender Wallet Balance Limit is ${spendableWalletUSD(balance, proposeGasPrice, 1500000).toFixed(2)} USD`}
              </p>,
          });
          return;
        }

        const data = campaignPrivate.methods.increaseCollateral(false, 0).encodeABI();
        const tx_stake = {
          chainId: 100,
          gas: String(gasLimit),
          gasPrice: String(proposeGasPrice),
          from: publicKey,
          to: stakeAddress,
          value: weiValueString,
          data,
          nonce: Number(nonce)
        };

        const mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
        const signingPrivateKey = mnemonicWallet.privateKey;
        plaintextPK = null;

        highRateWeb3.eth.accounts.signTransaction(tx_stake, signingPrivateKey)
          .then((signedTx) => highRateWeb3.eth.sendSignedTransaction(signedTx.rawTransaction))
          .then(async (receipt) => {
            if (!receipt || !(receipt.status === true || receipt.status === 1 || receipt.status === '0x1')) {
              throw new Error('Stake transaction failed');
            }
            const createdAt = Date.now();
            const pendingStake = {
              txnHash: receipt.transactionHash,
              nonce: Number(nonce),
              record: {
                transactionType: 'stake',
                creationDate: new Date(createdAt).toISOString(),
                creationDateSecs: createdAt,
                status: 'active',
                currentUser: stakeUsername,
                publicKey: stakeUser.publicKey,
                emailAddress: stakeUser.emailAddress,
                firstName: stakeUser.firstName,
                emailType: 'stake',
                randomString1: String(createdAt) + receipt.transactionHash.substring(2, 14),
                randomString2: String(createdAt) + receipt.transactionHash.substring(14, 26),
                manager: stakeManager,
                managerUsername: stakeManager,
                contractAddress: stakeAddress,
                newContractAddress: stakeAddress,
                lookupKey: contractResponse.Item.lookupKey,
                adjustedWeiValueNum: weiValueString,
                valueRaw: weiValueString,
                displayValue: ethers.utils.formatUnits(weiValueString, 18),
                currency: 'USD',
                conversionRateGlobal: 1,
                application: 'TBP',
                contractStructure: contractResponse.Item.contractStructure || 'creditLine',
                loanTarget: String(summary[1]),
                approversList: Array.from(summary[10] || []),
                stakerCommissionPercentEntitle
              }
            };

            that.setState({
              disableWhileTxn: false,
              pendingTransactionLoaderOverlay: false,
              successOverlay: true,
              stakeConfirmation: {
                amount: pendingStake.record.displayValue,
                txHash: receipt.transactionHash,
                registrationStatus: 'SAVING'
              },
              pendingStakeRegistration: pendingStake,
              moneyTransferOverlay: false,
              moneyTransactionLiveValue: null
            });

            await that.retryStakePendingTransaction(pendingStake);
          })
          .catch((err) => {
            that.setState({
              disableWhileTxn: false,
              pendingTransactionLoaderOverlay: false,
              errorTags:
                <p style={{ textAlign: 'left' }}>
                  {that.state.selectedLanguage == 'spanish' ? 'No se pudo completar la Aportación de Garantía.' : 'Unable to complete Stake.'}
                </p>,
            });
          });
      }).catch(() => {
        that.setState({
          disableWhileTxn: false,
          pendingTransactionLoaderOverlay: false,
          errorTags: <p>{that.state.selectedLanguage == 'spanish' ? 'No se pudo Preparar la Operación. Inténtalo de Nuevo.' : 'Unable to Prepare Stake. Please Try Again.'}</p>
        });
      });
    }).catch(() => {
      that.setState({
        disableWhileTxn: false,
        pendingTransactionLoaderOverlay: false,
        errorTags: <p>{that.state.selectedLanguage == 'spanish' ? 'No se pudo Cargar Tu Cartera. Inténtalo de Nuevo.' : 'Unable to Load Your Wallet. Please Try Again.'}</p>
      });
    });
  }


  async claimRewardsTxn(password){
    const rewardWei = String(that.state.availableRewards || '0');

    try {
      if (ethers.BigNumber.from(rewardWei).lte(0)) {
        that.setState({
          pendingTransactionLoaderOverlay: false,
          disableWhileTxn: false,
          errorTags: <p>{that.state.selectedLanguage == 'spanish' ? 'No Hay Comisiones Disponibles.' : 'No Staking Commissions Available.'}</p>,
        });
        return;
      }
    } catch (error) {
      that.setState({
        pendingTransactionLoaderOverlay: false,
        disableWhileTxn: false,
        errorTags: <p>{that.state.selectedLanguage == 'spanish' ? 'No Hay Comisiones Disponibles.' : 'No Staking Commissions Available.'}</p>,
      });
      return;
    }

    const displayValue = Number(ethers.utils.formatUnits(rewardWei, 18)).toFixed(2);

    that.setState({
      showPasswordOverlay: false,
      password: null,
      passwordText: null,
      disableWhileTxn: true,
      pendingTransactionLoaderOverlay: true
    });

    try {
      const [preSummary, userResponse] = await Promise.all([
        campaign.methods.getSummary1().call(),
        authenticatedPut('api1169ba1e', '', {
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: {
            category: 'db',
            tableName: 'users',
            primaryKey: currentUser,
            requestOperation: 'get'
          }
        })
      ]);

      const userItem = userResponse.Item;
      const bytes = CryptoJS.AES.decrypt(String(userItem.privateKey), password);
      let plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
      plaintextPK = plaintextPK.substring(64, plaintextPK.length - 64);

      if (!plaintextPK) throw new Error('BAD_PASSWORD');

      publicKey = userItem.publicKey;
      const campaignPrivate = new highRateWeb3.eth.Contract(
        thisContract_CampaignContract.abi,
        contractAddress
      );

      const nonce = Number(await highRateWeb3.eth.getTransactionCount(publicKey, 'pending'));
      const data = campaignPrivate.methods.claimRewards().encodeABI();

      const tx_claimRewards = {
        chainId: 100,
        gas: '1500000',
        gasPrice: String(proposeGasPrice),
        from: publicKey,
        to: contractAddress,
        data,
        nonce
      };

      const mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
      const signingPrivateKey = mnemonicWallet.privateKey;
      plaintextPK = null;

      const signedTx = await highRateWeb3.eth.accounts.signTransaction(
        tx_claimRewards,
        signingPrivateKey
      );

      const receipt = await highRateWeb3.eth.sendSignedTransaction(signedTx.rawTransaction);

      if (!receipt || !(receipt.status === true || receipt.status === 1 || receipt.status === '0x1')) {
        throw new Error('Claim rewards transaction failed');
      }

      const newTxnHash = receipt.transactionHash;
      const [postSummary, summary2] = await Promise.all([
        campaign.methods.getSummary1().call(),
        campaign.methods.getSummary2(publicKey).call()
      ]);

      const randomString1 = (
        String(Date.now()) +
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      ).substring(0, 18);

      const record = {
        transactionType: 'claimRewards',
        creationDate: new Date(),
        creationDateSecs: Date.now(),
        status: 'active',
        currentUser,
        publicKey,
        emailType: 'reclaim',
        firstName: userItem.firstName || '',
        emailAddress: userItem.emailAddress || '',
        randomString1,
        manager: _managerLCase,
        adjustedWeiValueNum: rewardWei,
        web3BalancePre: preSummary[0],
        web3BalancePost: postSummary[0],
        interestRate: postSummary[3],
        finalRequestsSum: postSummary[4],
        repaymentSum: postSummary[5],
        totalContributed: postSummary[6],
        approversCount: postSummary[7],
        requestsCt: postSummary[8],
        receiptsCt: postSummary[9],
        approversList: postSummary[10],
        userLoanTotal: Number(summary2[0]),
        userLiquidValue: Number(summary2[1]),
        userFinalizedRequestLoanSum: Number(summary2[2]),
        reclaimableValue: Number(summary2[4]),
        contractAddress,
        approverCheck: summary2[3],
        minLoan: postSummary[2],
        application: 'TBP',
        displayValue,
        currency: 'USD',
        conversionRateGlobal: 1,
        lookupKey: _lookupKey,
        availableCredit: Number(availableCredit) * 1000000000000000000,
        offeredLenderCommissionUSD,
        contractStructure: contractStructureType,
        settlementDate: settlementDateFormatted,
        closureDate: closureDateFormatted
      };

      await that.writeValidatedPendingTransactionAndQueue(newTxnHash, record, nonce);

      that.setState({
        successOverlay: true,
        disableWhileTxn: false,
        pendingTransactionLoaderOverlay: false,
        moneyTransferOverlay: false,
        moneyTransactionLiveValue: '',
      });

      that.reloadPage();
    } catch (err) {
      that.setState({
        disableWhileTxn: false,
        pendingTransactionLoaderOverlay: false,
        errorTags:
          <p style={{ textAlign: 'left' }}>
            {that.state.selectedLanguage == 'spanish'
              ? 'No se Pudieron Retirar las Comisiones de Apuesta.'
              : 'Unable to Withdraw Staking Commissions.'}
          </p>,
      });
    }
  }


  contributeTxn(password){
    if (that.state.alreadyVerified){
      let weiValue = Number(that.state.moneyTransactionLiveValue) * 1000000000000000000
      let transactionValueUSD = Number(that.state.moneyTransactionLiveValue).toFixed(2);
      let weiValueString, weiValueNum, adjustedWeiValueNum;
      let randomString = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    

      randomString =  randomString.substring(0,18)
      weiValueString = String(Math.round(weiValue))

      if(!that.state.isSubscribedCurrentBool){
        adjustedWeiValueNum = weiValue - (weiValue * blenderPercentCharge)
      } else {
        adjustedWeiValueNum = weiValue
      }
      that.setState({ 
        showPasswordOverlay: false,
        password: null,
        disableWhileTxn: true,      
        pendingTransactionLoaderOverlay: true

      })

      try{
        campaign.methods.deploymentAddress().call()
          .then((_deploymentAddress) => {
            deploymentAddress = _deploymentAddress;

              campaign.methods.getSummary1().call()
                .then((res) => {
                  web3BalancePre = res[0]

                  authenticatedPut('api1169ba1e', '', { 
                    headers: { Authorization: `Bearer ${cognitoID}` },
                    body: { 
                      category: 'db',
                      tableName: 'users', 
                      primaryKey: currentUser, 
                      requestOperation: 'get',
                    }
                  }).then((response) => {
                    authenticatedPut('api1169ba1e', '', { 
                      headers: { Authorization: `Bearer ${cognitoID}` },
                      body: { 
                        category: 'db',
                        tableName: 'privateBlenderKeys', 
                        primaryKey: 'proxyKeys', 
                        requestOperation: 'get',
                      }
                    }).then((proxyKey) => {
                      client.getSecretValue({SecretId: secretName}, function(err, data) {
                        if (err) {
                            if (err.code === 'DecryptionFailureException'){
                                return
                            } else if (err.code === 'InternalServiceErrorException'){
                                return 
                            } else if (err.code === 'InvalidParameterException'){
                                return
                            } else if (err.code === 'InvalidRequestException'){
                                return
                            } else if (err.code === 'ResourceNotFoundException'){
                                return
                            }
                        } else {

                          let encryptSecret, decodedBinarySecret;
                          if ('SecretString' in data) {
                              encryptSecret = JSON.parse(data.SecretString);
                              encryptSecret = encryptSecret.blenderProxyPrivateKey
                          } else {
                              let buff = new Buffer(data.SecretBinary, 'base64');
                              decodedBinarySecret = buff.toString('ascii');
                          }
                  
                          let proxyPrivKeyHash = proxyKey.Item.privateKeyHash
                          let proxyPubKey = proxyKey.Item.publicKey
                          let bytesProxy = CryptoJS.AES.decrypt(String(proxyPrivKeyHash), encryptSecret);

                          proxyPrivKeyHash = null
                          encryptSecret = null;
                          decodedBinarySecret = null;

                          let blenderPrivateProxyKey = bytesProxy.toString(CryptoJS.enc.Utf8);
                          blenderPrivateProxyKey = String(blenderPrivateProxyKey)

                          bytesProxy = null

                          publicKey = response.Item.publicKey
                          let lastNonce = response.Item.lastNonce
                          let emailAddress = response.Item.emailAddress
                          let firstName = response.Item.firstName
                          let privateKey = response.Item.privateKey
                          let bytes = CryptoJS.AES.decrypt(String(privateKey), password);

                          let plaintextPK
                          try{
                            plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
                            finishTxn()
                          }catch(err){
                            
                            that.setState({
                              disableWhileTxn: false,
                              generalNoticeTimedOverlay: false,
                              generalNoticeOverlay: false,
                              pendingTransactionLoaderOverlay: false,
                              errorTags: 
                                <p style={{ textAlign: 'left', }}>
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    'Contraseña no Válida'
                                      :
                                    'Incorrect Password'
                                  }
                                </p>,
                            })
                          }
                          function finishTxn(){
                            plaintextPK = plaintextPK.substring(64, plaintextPK.length-64)

                            
                            blenderPrivateProxyKey = null
                            privateKey = null
                            bytes = null

                            authenticatedPut('api1169ba1e', '', { 
                              headers: { Authorization: `Bearer ${cognitoID}` },
                              body: { 
                                category: 'db',
                                tableName: 'platformConfigurations', 
                                primaryKey: 'preHashString', 
                                requestOperation: 'get',
                              }
                            }).then((platformConfigurations) => {
                      
                              let preHashString = String(platformConfigurations.Item.preHashString)

                              
                              highRateWeb3.eth.getBalance(publicKey)
                                .then((balance) => { 

                                  let currentWalletBalance = Number(balance)
                                  let campaignPrivate = new highRateWeb3.eth.Contract(
                                    thisContract_CampaignContract.abi,
                                    contractAddress
                                  )

                                  let maxValue = (Math.floor(((Number(currentWalletBalance) - (1100000 * Number(proposeGasPrice) * 1.05)) * 100)/1000000000000000000)/100)
                                  maxValue = maxValue.toFixed(2)
                                  if(Number(maxValue) < 0){
                                    maxValue = 0
                                  }
                                  

                                  highRateWeb3.eth.getTransactionCount(publicKey).then((nonce) => {
                                    let minimumBalance = Number(weiValueString) + 1100000 * Number(proposeGasPrice)

                                    if(Number(currentWalletBalance) <= Number(minimumBalance)){
                                      
                                      that.setState({
                                        disableWhileTxn: false,
                                        generalNoticeTimedOverlay: false,
                                        generalNoticeOverlay: false,
                                        errorTags: 
                                          <p style={{ textAlign: 'left' }}>
                                            {that.state.selectedLanguage == 'spanish' ? 
                                              `Fondos Insuficientes - El limite de tu Cartera Blender es ${spendableWalletUSD(balance, proposeGasPrice, 1100000).toFixed(2)} USD`
                                                :
                                              `Insufficient Funds - Your Blender Wallet Balance Limit is ${spendableWalletUSD(balance, proposeGasPrice, 1100000).toFixed(2)} USD`
                                            }
                                          </p>
                                      })
                                    } else {










                                      highRateWeb3.eth.getTransactionCount(publicKey).then((_nonce) => {
                                        const nonce = Number(_nonce);
                              
                                        var campaign = new highRateWeb3.eth.Contract(
                                          thisContract_CampaignContract.abi,
                                          contractAddress
                                        );


                                        var data = campaign.methods.contribute(
                                          Number(preHashString), 
                                          String(that.state.isSubscribedCurrentBool ? that.state.contributeCommissionIntegerPCT : 100000)
                                        ).encodeABI();

                                        const tx_contribute = {  
                                          chainId: 100,
                                          gas: '1500000',
                                          gasPrice: String(proposeGasPrice),
                                          from: publicKey, 
                                          to: contractAddress,
                                          value: (Number(weiValueString)).toLocaleString('fullwide', {useGrouping: false}),
                                          data,
                                          nonce: nonce
                                        }
                              
                                        let mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
                                        var plaintextMnemonic = mnemonicWallet.privateKey


                                        highRateWeb3.eth.accounts.signTransaction(tx_contribute, plaintextMnemonic)
                                          .then((signedTx_contribute) => {

                                            highRateWeb3.eth.sendSignedTransaction(signedTx_contribute.rawTransaction).then((_tx_contribute_receipt) => {
                                              let newTxnHash = _tx_contribute_receipt.transactionHash













                                                  try {
                                                    if(that.state.selectedLanguage == 'spanish'){
                                                      // that.setNativeNotification(`Daste prestamo de $${Number(transactionValueUSD).toFixed(2)} a ${String(managerUsername).toUpperCase()}`)
                                                      if(that.state.isSubscribedCurrentBool){
                                                        that.setState({
                                                          subscriptionSavingUSD: Number(Number(transactionValueUSD)*0.05).toFixed(2),
                                                        })
                                                        setTimeout(() => {
                                                          // that.setNativeNotification(`Blender Pro Plus Ahorros - Has guardado $${Number(Number(transactionValueUSD)*0.05).toFixed(2)} por dar prestamo a ${String(managerUsername).toUpperCase()}`)
                                                        }, 2000)
                                                      } 
                                                    } else {
                                                      // that.setNativeNotification(`You lent $${Number(transactionValueUSD).toFixed(2)} to ${String(managerUsername).toUpperCase()}`)
                                                      if(that.state.isSubscribedCurrentBool){
                                                        that.setState({
                                                          subscriptionSavingUSD: Number(Number(transactionValueUSD)*0.05).toFixed(2),
                                                        })
                                                        setTimeout(() => {
                                                          // that.setNativeNotification(`Blender Pro Plus Savings - You saved $${Number(Number(transactionValueUSD)*0.05).toFixed(2)} lending to ${String(managerUsername).toUpperCase()}`)
                                                        }, 2000)
                                                      } 
                                                    }
                                                  } catch (err){
                                                  }                                      

                                                campaignPrivate = null 

                                                

                                                campaign.methods.getSummary1().call()
                                                  .then((res) => {
                                                    web3BalancePost = res[0]
                                                    loanTarget = res[1]
                                                    minimumContribution = res[2]
                                                    interestRate = res[3]
                                                    finalRequestsSum = res[4]
                                                    repaymentSum = res[5]
                                                    totalContributed = res[6]
                                                    approversCount = res[7]
                                                    requestsCt = res[8]
                                                    receiptsCt = res[9]
                                                    approversList = res[10]
                                                    manager = res[11]
                                                    insuranceTotal = res[12]
                                                    compoundedInterestPaid = res[13]


                                                    campaign.methods.getSummary2(publicKey).call()
                                                      .then((res) => {
                                                        currentUserLoanTotal = Number(res[0])
                                                        userLiquidValue = Number(res[1])
                                                        userFinalizedRequestLoanSum = Number(res[2])
                                                        approverCheck = res[3]
                                                        reclaimableValue = Number(res[4])
                                                        compoundInterestReceived = Number(res[5])
                                          
                                                        let _dateCreated = new Date()
                                                        _dateCreated = String(_dateCreated).substring(0,10)

                                                        let monthNum = _dateCreated.substr(5,2)
                                                        let yearNum = _dateCreated.substr(0,4)
                                                        let dayNum = _dateCreated.substr(8,2)
                                                        let monthString
                                                        if(monthNum == '01'){
                                                          monthString = 'Jan. '
                                                        } else if(monthNum == '02'){
                                                          monthString = 'Feb. '
                                                        } else if(monthNum == '03'){
                                                          monthString = 'Mar. '
                                                        } else if(monthNum == '04'){
                                                          monthString = 'Apr. '
                                                        } else if(monthNum == '05'){
                                                          monthString = 'May. '
                                                        } else if(monthNum == '06'){
                                                          monthString = 'Jun. '
                                                        } else if(monthNum == '07'){
                                                          monthString = 'Jul. '
                                                        } else if(monthNum == '08'){
                                                          monthString = 'Aug. '
                                                        } else if(monthNum == '09'){
                                                          monthString = 'Sep. '
                                                        } else if(monthNum == '10'){
                                                          monthString = 'Oct. '
                                                        } else if(monthNum == '11'){
                                                          monthString = 'Nov. '
                                                        } else if(monthNum == '12'){
                                                          monthString = 'Dec. '
                                                        } 
                                                        _dateCreated = monthString + dayNum + ', ' + yearNum

                                                        var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                                        randomString1 =  randomString1.substring(0,18)

                                                        var randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                                        randomString2 =  randomString2.substring(0,18)

                                                        let new_contractCovenantSigningID = contractAddress.concat('_'+String(Math.floor(Math.random()*9000) + 1000))
                                                        
                                                            authenticatedPut('api1169ba1e', '', { 
                                                              headers: { Authorization: `Bearer ${cognitoID}` },
                                                              body: { 
                                                                category: 'db',
                                                                tableName: 'pendingTransactions', 
                                                                primaryKey: newTxnHash, 
                                                                requestOperation: 'update',
                                                                updateExpression: 
                                                                  `SET 
                                                                    transactionType = :txnType,
                                                                    creationDate = :creationDate, 
                                                                    creationDateSecs = :creationDateSecs, 
                                                                    #st = :status, 
                                                                    currentUser = :currentUser,
                                                                    publicKey = :publicKey,
                                                                    emailType = :emailType,
                                                                    firstName = :firstName,
                                                                    emailAddress = :emailAddress,
                                                                    randomString1 = :randomString1,
                                                                    randomString2 = :randomString2,
                                                                    manager = :managerUsername,
                                                                    adjustedWeiValueNum = :adjustedWeiValueNum,
                                                                    web3BalancePre = :web3BalancePre,
                                                                    web3BalancePost = :web3BalancePost,
                                                                    interestRate = :interestRate,
                                                                    finalRequestsSum = :finalRequestsSum,
                                                                    repaymentSum = :repaymentSum,
                                                                    totalContributed = :totalContributed,
                                                                    approversCount = :approversCount,
                                                                    requestsCt = :requestsCt,
                                                                    receiptsCt = :receiptsCt,
                                                                    approversList = :approversList,
                                                                    userLoanTotal = :currentUserLoanTotal,
                                                                    currentUserLoanTotal = :currentUserLoanTotal,
                                                                    userLiquidValue = :userLiquidValue,
                                                                    userFinalizedRequestLoanSum = :userFinalizedRequestLoanSum,
                                                                    approverCheck = :approverCheck,
                                                                    reclaimableValue = :reclaimableValue,
                                                                    contractAddress = :contractAddress,
                                                                    application = :application,
                                                                    displayValue = :displayValue,
                                                                    lookupKey = :lookupKey,
                                                                    currency = :currency,
                                                                    conversionRateGlobal = :conversionRateGlobal,
                                                                    availableCredit = :availableCredit,
                                                                    offeredLenderCommissionUSD = :offeredLenderCommissionUSD,
                                                                    contractStructure = :contractStructure,
                                                                    settlementDate = :settlementDate,
                                                                    closureDate = :closureDate
                                                                  `,
                                                                expressionAttributeNames: {"#st":"status"},
                                                                expressionAttributeValues: { 
                                                                  ':txnType': 'contribution',
                                                                  ':creationDate': new Date(),
                                                                  ':creationDateSecs': Date.now(), 
                                                                  ':currentUser': currentUser,
                                                                  ':status': 'active',
                                                                  ':managerUsername': _managerLCase,
                                                                  ':publicKey': publicKey,
                                                                  ':lookupKey': _lookupKey,
                                                                  ':emailAddress': emailAddress,
                                                                  ':emailType': 'contribution',
                                                                  ':randomString1': randomString1,
                                                                  ':randomString2': randomString2,
                                                                  ':firstName': firstName,
                                                                  ':adjustedWeiValueNum': adjustedWeiValueNum,
                                                                  ':web3BalancePre': web3BalancePre,
                                                                  ':web3BalancePost': web3BalancePost,
                                                                  ':interestRate': interestRate,
                                                                  ':finalRequestsSum': finalRequestsSum,
                                                                  ':repaymentSum': repaymentSum,
                                                                  ':totalContributed': totalContributed,
                                                                  ':approversCount': approversCount,
                                                                  ':requestsCt': requestsCt,
                                                                  ':receiptsCt': receiptsCt,
                                                                  ':approversList': approversList,
                                                                  ':currentUserLoanTotal': currentUserLoanTotal,
                                                                  ':userLiquidValue': userLiquidValue,
                                                                  ':userFinalizedRequestLoanSum': userFinalizedRequestLoanSum,
                                                                  ':approverCheck': approverCheck,
                                                                  ':reclaimableValue': reclaimableValue,
                                                                  ':contractAddress': contractAddress,
                                                                  ':application': 'TBP',
                                                                  ':displayValue': transactionValueUSD,
                                                                  ':currency': 'USD',
                                                                  ':conversionRateGlobal': 1,
                                                                  ':availableCredit': Number(availableCredit)*1000000000000000000,
                                                                  ':offeredLenderCommissionUSD': offeredLenderCommissionUSD,
                                                                  ':contractStructure': contractStructureType,
                                                                  ':settlementDate': settlementDateFormatted,
                                                                  ':closureDate': closureDateFormatted
                                                                }
                                                              }
                                                            }).then((res) => {

                                                              authenticatedPut('api1169ba1e', '', { 
                                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                                body: { 
                                                                    category: 'db',
                                                                    tableName: 'users', 
                                                                    primaryKey: currentUser,
                                                                    requestOperation: 'update',
                                                                    updateExpression: 
                                                                        `SET
                                                                            lastNonce = :lastNonce
                                                                        `,
                                                                    expressionAttributeValues: { 
                                                                        ':lastNonce': nonce
                                                                    },
                                                                }
                                                              }).then((res) => {

                                                                authenticatedPut('api1169ba1e', '', { 
                                                                  headers: { Authorization: `Bearer ${cognitoID}` },
                                                                  body: { 
                                                                    category: 'db',
                                                                    tableName: 'general', 
                                                                    primaryKey: 'txnHash', 
                                                                    requestOperation: 'update',
                                                                    updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                                                                    expressionAttributeValues: { 
                                                                      ':txnHash': [newTxnHash]
                                                                    }
                                                                  }
                                                                }).then((res) => {

                                                                  if(that.state.isSubscribedCurrentBool){
                                                                    that.setState({
                                                                      pendingTransactionLoaderOverlay: false,
                                                                      generalNoticeOverlay: true,
                                                                      generalNoticeText:
                                                                        (that.state.selectedLanguage == 'spanish' ? 
                                                                          `Has prestado ${transactionValueUSD} USD a ${String(that.state.managerUsername).toUpperCase()}.  Por Blender Pro Plus has ahorrado ${Number(that.state.subscriptionSavingUSD).toFixed(2)} USD.`
                                                                            :
                                                                          `You've lent ${transactionValueUSD} USD to ${String(that.state.managerUsername).toUpperCase()}.  You saved ${Number(that.state.subscriptionSavingUSD).toFixed(2)} USD through Blender Pro Plus.`
                                                                        )
                                                                    })
                                                                  } else {
                                                                    that.setState({
                                                                      pendingTransactionLoaderOverlay: false,
                                                                      generalNoticeOverlay: true,
                                                                      generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
                                                                        `Has prestado ${transactionValueUSD} USD a miembro ${String(that.state.managerUsername).toUpperCase()}`
                                                                          :
                                                                        `You've lent ${transactionValueUSD} USD to member ${String(that.state.managerUsername).toUpperCase()}`
                                                                      ),
                                                                    })
                                                                  }

                                                                
                                                                  that.reloadPage()
                                                                })
                                                              })
                                                            })
                                                          
                                                        
                                                      })
                                                  })
                                              
                                              

                                            })
                                          })
                                        })
                                    
                                    }
                                  })
                                })
                            })
                          }
                        }
                      });
                    })
                  
                })
              })
            })
      } catch(error) {
      return
      }
    }
  }

  rescindTxn(password){

    let weiValue = Number(that.state.moneyTransactionLiveValue) * 1000000000000000000
    let transactionValueUSD = Number(that.state.moneyTransactionLiveValue).toFixed(2);
    let weiValueString, weiValueNum, adjustedWeiValueNum;
    let randomString = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  

    randomString =  randomString.substring(0,18)
    weiValueString = String(Math.round(weiValue))


    that.setState({ 
      showPasswordOverlay: false,
      password: null,
      disableWhileTxn: true,
      generalNoticeOverlay: false,      
      pendingTransactionLoaderOverlay: true
    })
        
    try{
      campaign.methods.getSummary1().call()
        .then((res) => {
          web3BalancePre = res[0]
          loanTarget = res[1]
          minimumContribution = res[2]
          interestRate = res[3]
          finalRequestsSum = res[4]
          repaymentSum = res[5]
          totalContributed = res[6]
          approversCount = res[7]
          requestsCt = res[8]
          receiptsCt = res[9]
          approversList = res[10]
          manager = res[11]
          insuranceTotal = res[12]
          compoundedInterestPaid = res[13]

          campaign.methods.getSummary2(publicKey).call()
            .then((res) => {
              currentUserLoanTotal = Number(res[0])
              var userLiquidValuePre = Number(res[1])
              userFinalizedRequestLoanSum = Number(res[2])
              approverCheck = res[3]
              reclaimableValue = Number(res[4])
              compoundInterestReceived = Number(res[5])

              authenticatedPut('api1169ba1e', '', { 
                headers: { Authorization: `Bearer ${cognitoID}` },
                body: { 
                  category: 'db',
                  tableName: 'users', 
                  primaryKey: currentUser, 
                  requestOperation: 'get',
                }
              }).then((response) => {
                authenticatedPut('api1169ba1e', '', { 
                  headers: { Authorization: `Bearer ${cognitoID}` },
                  body: { 
                    category: 'db',
                    tableName: 'privateBlenderKeys', 
                    primaryKey: 'proxyKeys', 
                    requestOperation: 'get',
                  }
                }).then((proxyKey) => {
                  client.getSecretValue({SecretId: secretName}, function(err, data) {
                    if (err) {
                        if (err.code === 'DecryptionFailureException'){
                            return
                        } else if (err.code === 'InternalServiceErrorException'){
                            return 
                        } else if (err.code === 'InvalidParameterException'){
                            return
                        } else if (err.code === 'InvalidRequestException'){
                            return
                        } else if (err.code === 'ResourceNotFoundException'){
                            return
                        }
                    } else {
                      let encryptSecret, decodedBinarySecret;
                      if ('SecretString' in data) {
                          encryptSecret = JSON.parse(data.SecretString);
                          encryptSecret = encryptSecret.blenderProxyPrivateKey
                      } else {
                          let buff = new Buffer(data.SecretBinary, 'base64');
                          decodedBinarySecret = buff.toString('ascii');
                      }
              
                      let proxyPrivKeyHash = proxyKey.Item.privateKeyHash
                      let proxyPubKey = proxyKey.Item.publicKey
                      let bytesProxy = CryptoJS.AES.decrypt(String(proxyPrivKeyHash), encryptSecret);
    
                      proxyPrivKeyHash = null
                      encryptSecret = null;
                      decodedBinarySecret = null;
    
                      let blenderPrivateProxyKey = bytesProxy.toString(CryptoJS.enc.Utf8);
                      blenderPrivateProxyKey = String(blenderPrivateProxyKey)
    
                      bytesProxy = null
    

                      publicKey = response.Item.publicKey
                      let lastNonce = response.Item.lastNonce
                      let emailAddress = response.Item.emailAddress
                      let firstName = response.Item.firstName
                      let privateKey = response.Item.privateKey
                      let bytes = CryptoJS.AES.decrypt(String(privateKey), password);
                      let plaintextPK
                      try{
                        plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
                        finishTxn()
                      }catch(err){
                        
                        that.setState({
                          disableWhileTxn: false,
                          generalNoticeTimedOverlay: false,
                          generalNoticeOverlay: false,
                          pendingTransactionLoaderOverlay: false,
                          errorTags: 
                            <p style={{ textAlign: 'left', }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Contraseña no Válida'
                                  :
                                'Incorrect Password'
                              }
                            </p>,
                        })
                       
                      }
                      function finishTxn(){
                        plaintextPK = plaintextPK.substring(64, plaintextPK.length-64)
                        
                        
                        blenderPrivateProxyKey = null
                        privateKey = null
                        
                        
                        highRateWeb3.eth.getBalance(publicKey)
                          .then((balance) => { 

                            let currentWalletBalance = Number(balance)
                            let campaignPrivate = new highRateWeb3.eth.Contract(
                              thisContract_CampaignContract.abi,
                              contractAddress
                            )
                         
                            highRateWeb3.eth.getTransactionCount(publicKey).then((nonce) => {

                                if(currentWalletBalance <= (1000000 * proposeGasPrice)){
                                  
                                  that.setState({
                                    disableWhileTxn: false,
                                    generalNoticeTimedOverlay: false,
                                    generalNoticeOverlay: false,
                                    errorTags: 
                                      <p style={{ textAlign: 'left' }}>
                                        {that.state.selectedLanguage == 'spanish' ? 
                                          `Fondos Insuficientes - El limite de tu Cartera Blender es ${spendableWalletUSD(balance, proposeGasPrice, 1000000).toFixed(2)} USD`
                                            :
                                          `Insufficient Funds - Your Blender Wallet Balance Limit is ${spendableWalletUSD(balance, proposeGasPrice, 1000000).toFixed(2)} USD`
                                        }
                                      </p>
                                  })
                               
                                } else {




                                  highRateWeb3.eth.getTransactionCount(publicKey).then((_nonce) => {
                                    const nonce = Number(_nonce);
                          
                      

                                    var campaign = new highRateWeb3.eth.Contract(
                                      thisContract_CampaignContract.abi,
                                      contractAddress
                                    );


                                    var data = campaign.methods.rescind(
                                      String(weiValue), 
                                      '500',
                                    ).encodeABI();


                                    const tx_rescind = {  
                                      chainId: 100,
                                      gas: '1500000',
                                      gasPrice: String(proposeGasPrice),
                                      from: publicKey, 
                                      to: contractAddress,
                                      data,
                                      nonce: nonce
                                    }
                           
                                    let mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
                                    var plaintextMnemonic = mnemonicWallet.privateKey


                                    highRateWeb3.eth.accounts.signTransaction(tx_rescind, plaintextMnemonic)
                                      .then((signedTx_rescind) => {

                                        highRateWeb3.eth.sendSignedTransaction(signedTx_rescind.rawTransaction).then((_tx_rescind_receipt) => {
                                          let newTxnHash = _tx_rescind_receipt.transactionHash


                                          campaign.methods.getSummary1().call()
                                            .then((res) => {
                                              web3BalancePost = res[0]
                                              loanTarget = res[1]
                                              minimumContribution = res[2]
                                              interestRate = res[3]
                                              finalRequestsSum = res[4]
                                              repaymentSum = res[5]
                                              totalContributed = res[6]
                                              approversCount = res[7]
                                              requestsCt = res[8]
                                              receiptsCt = res[9]
                                              approversList = res[10]
                                              manager = res[11]
                                              insuranceTotal = res[12]
                                              compoundedInterestPaid = res[13]

                                              campaign.methods.getSummary2(publicKey).call()
                                                .then((res) => {
                                                  currentUserLoanTotal = Number(res[0])
                                                  var userLiquidValuePost = Number(res[1])
                                                  userFinalizedRequestLoanSum = Number(res[2])
                                                  approverCheck = res[3]
                                                  reclaimableValue = Number(res[4])
                                                  compoundInterestReceived = Number(res[5])

                                                  let _dateCreated = new Date()
                                                  _dateCreated = String(_dateCreated).substring(0,10)

                                                  let monthNum = _dateCreated.substr(5,2)
                                                  let yearNum = _dateCreated.substr(0,4)
                                                  let dayNum = _dateCreated.substr(8,2)
                                                  let monthString
                                                  if(monthNum == '01'){
                                                    monthString = 'Jan. '
                                                  } else if(monthNum == '02'){
                                                    monthString = 'Feb. '
                                                  } else if(monthNum == '03'){
                                                    monthString = 'Mar. '
                                                  } else if(monthNum == '04'){
                                                    monthString = 'Apr. '
                                                  } else if(monthNum == '05'){
                                                    monthString = 'May. '
                                                  } else if(monthNum == '06'){
                                                    monthString = 'Jun. '
                                                  } else if(monthNum == '07'){
                                                    monthString = 'Jul. '
                                                  } else if(monthNum == '08'){
                                                    monthString = 'Aug. '
                                                  } else if(monthNum == '09'){
                                                    monthString = 'Sep. '
                                                  } else if(monthNum == '10'){
                                                    monthString = 'Oct. '
                                                  } else if(monthNum == '11'){
                                                    monthString = 'Nov. '
                                                  } else if(monthNum == '12'){
                                                    monthString = 'Dec. '
                                                  } 
                                                  _dateCreated = monthString + dayNum + ', ' + yearNum

                                                  var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

                                                  randomString1 =  randomString1.substring(0,18)

                                                  var randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                                  randomString2 =  randomString2.substring(0,18)

                                                  authenticatedPut('api1169ba1e', '', { 
                                                    headers: { Authorization: `Bearer ${cognitoID}` },
                                                    body: { 
                                                      category: 'db',
                                                      tableName: 'pendingTransactions', 
                                                      primaryKey: newTxnHash, 
                                                      requestOperation: 'update',
                                                      updateExpression: 
                                                        `SET 
                                                          transactionType = :txnType,
                                                          creationDate = :creationDate, 
                                                          creationDateSecs = :creationDateSecs, 
                                                          #st = :status, 
                                                          currentUser = :currentUser,
                                                          publicKey = :publicKey,
                                                          emailType = :emailType,
                                                          firstName = :firstName,
                                                          emailAddress = :emailAddress,
                                                          randomString1 = :randomString1,
                                                          manager = :managerUsername,
                                                          adjustedWeiValueNum = :adjustedWeiValueNum,
                                                          web3BalancePre = :web3BalancePre,
                                                          web3BalancePost = :web3BalancePost,
                                                          interestRate = :interestRate,
                                                          finalRequestsSum = :finalRequestsSum,
                                                          repaymentSum = :repaymentSum,
                                                          totalContributed = :totalContributed,
                                                          approversCount = :approversCount,
                                                          requestsCt = :requestsCt,
                                                          receiptsCt = :receiptsCt,
                                                          approversList = :approversList,
                                                          userLoanTotal = :userLoanTotal,
                                                          userLiquidValue = :userLiquidValue,
                                                          userFinalizedRequestLoanSum = :userFinalizedRequestLoanSum,
                                                          reclaimableValue = :reclaimableValue,
                                                          contractAddress = :contractAddress,
                                                          approverCheck = :approverCheck,
                                                          minLoan = :minLoan,
                                                          application = :application,
                                                          displayValue = :displayValue,
                                                          currency = :currency,
                                                          conversionRateGlobal = :conversionRateGlobal,
                                                          lookupKey = :lookupKey,
                                                          availableCredit = :availableCredit,
                                                          offeredLenderCommissionUSD = :offeredLenderCommissionUSD,
                                                          contractStructure = :contractStructure,
                                                          settlementDate = :settlementDate,
                                                          closureDate = :closureDate
                                                        `,
                                                      expressionAttributeNames: {"#st":"status"},
                                                      expressionAttributeValues: { 
                                                        ':txnType': 'reclaim',
                                                        ':creationDate': new Date(),
                                                        ':creationDateSecs': Date.now(), 
                                                        ':currentUser': currentUser,
                                                        ':status': 'active',
                                                        ':managerUsername': _managerLCase,
                                                        ':publicKey': publicKey,
                                                        ':emailAddress': emailAddress,
                                                        ':emailType': 'reclaim',
                                                        ':randomString1': randomString1,
                                                        ':firstName': firstName,
                                                        ':adjustedWeiValueNum': weiValue,
                                                        ':web3BalancePre': web3BalancePre,
                                                        ':web3BalancePost': web3BalancePost,
                                                        ':interestRate': interestRate,
                                                        ':finalRequestsSum': finalRequestsSum,
                                                        ':repaymentSum': repaymentSum,
                                                        ':totalContributed': totalContributed,
                                                        ':approversCount': approversCount,
                                                        ':requestsCt': requestsCt,
                                                        ':receiptsCt': receiptsCt,
                                                        ':approversList': approversList,
                                                        ':userLoanTotal': currentUserLoanTotal,
                                                        ':userLiquidValue': userLiquidValue,
                                                        ':userFinalizedRequestLoanSum': userFinalizedRequestLoanSum,
                                                        ':approverCheck': that.state.postRescindApproverStatus ,
                                                        ':reclaimableValue': reclaimableValue,
                                                        ':contractAddress': contractAddress,
                                                        ':minLoan': minimumContribution,
                                                        ':application': 'TBP',
                                                        ':displayValue': transactionValueUSD,
                                                        ':currency': 'USD',
                                                        ':conversionRateGlobal': 1,
                                                        ':lookupKey': _lookupKey,
                                                        ':availableCredit': Number(availableCredit)*1000000000000000000,
                                                        ':offeredLenderCommissionUSD': offeredLenderCommissionUSD,
                                                        ':contractStructure': contractStructureType,
                                                        ':settlementDate': settlementDateFormatted,
                                                        ':closureDate': closureDateFormatted
                                                      }
                                                    }
                                                  }).then((res) => {

                                                    authenticatedPut('api1169ba1e', '', { 
                                                      headers: { Authorization: `Bearer ${cognitoID}` },
                                                      body: { 
                                                        category: 'db',
                                                        tableName: 'general', 
                                                        primaryKey: 'txnHash', 
                                                        requestOperation: 'update',
                                                        updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                                                        expressionAttributeValues: { 
                                                          ':txnHash': [newTxnHash]
                                                        }
                                                      }
                                                    })
                                                  }).then((res) => {

                                                    that.setState({
                                                      successOverlay: true,
                                                      generalNoticeOverlay: true,
                                                      generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
                                                        `Has reclamado ${transactionValueUSD} USD de miembro ${String(that.state.managerUsername).toUpperCase()}`
                                                          :
                                                        `You've reclaimed ${transactionValueUSD} USD from member ${String(that.state.managerUsername).toUpperCase()}`
                                                      ),
                                                      pendingTransactionLoaderOverlay: false,
                                                      
                                                    })
                                                    
                                                    that.reloadPage()
                                                  })
                                                })
                                            })


                                          })
                                        })
                                      })
                                      
                              }
                            })
                          })
                        }
                      }
                    })
                  })
              })
          })
      })
    } catch(error) {
      return
    }
  }

  repayTxn(password){

    let userFinalizedValueMap = {};

    // Preserve the repayment amount exactly at 18 decimals.
    let weiValueString = ethers.utils.parseUnits(String(that.state.moneyTransactionLiveValue).trim(), 18).toString()
    let weiValue = Number(weiValueString)
    let transactionValueUSD = Number(that.state.moneyTransactionLiveValue).toFixed(2);
    let weiValueNum, adjustedWeiValueNum;
    let randomString = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  

    randomString =  randomString.substring(0,18)

    if(!that.state.isSubscribedCurrentBool){
      adjustedWeiValueNum = weiValue - (weiValue * blenderPercentCharge)
    } else {
      adjustedWeiValueNum = weiValue
    }

    that.setState({ 
      showPasswordOverlay: false,
      generalNoticeOverlay: false,
      
      showOverlay: false,
      disableWhileTxn: true,      
      pendingTransactionLoaderOverlay: true,
      password: null,
    })

    try{
      campaign.methods.getSummary1().call()
      .then((res) => {
        let web3BalancePre = res[0]
        let finalizedTotal = Number(res[4])
        let repaidTotal = Number(res[5])
        let compoundedInterestPaidNow

        if((_compoundedBalanceWEI/0.95) <= weiValue){
          adjustedWeiValueNum = _compoundedBalanceWEI/0.95
        } else {
          adjustedWeiValueNum = weiValue 
        }

        if(Number(_compoundedBalanceWEI)/0.95 >= Number(weiValueString)){
          compoundedInterestPaidNow = Number(weiValueString)*0.95
        } else {
          compoundedInterestPaidNow = Number(_compoundedBalanceWEI)
        }

        campaign.methods.getSummary2(publicKey).call()
          .then((res) => {
            currentUserLoanTotal = Number(res[0])
            userLiquidValuePre = Number(res[1])
            userFinalizedRequestLoanSum = Number(res[2])
            approverCheck = res[3]
            reclaimableValue = Number(res[4])
            compoundInterestReceived = Number(res[5])

            authenticatedPut('api1169ba1e', '', { 
              headers: { Authorization: `Bearer ${cognitoID}` },
              body: { 
                category: 'db',
                tableName: 'users', 
                primaryKey: currentUser, 
                requestOperation: 'get',
              }
            }).then((response) => {
                authenticatedPut('api1169ba1e', '', { 
                  headers: { Authorization: `Bearer ${cognitoID}` },
                  body: { 
                    category: 'db',
                    tableName: 'privateBlenderKeys', 
                    primaryKey: 'proxyKeys', 
                    requestOperation: 'get',
                  }
                }).then((proxyKey) => {
                  client.getSecretValue({SecretId: secretName}, function(err, data) {
                    if (err) {
                        if (err.code === 'DecryptionFailureException'){
                            return
                        } else if (err.code === 'InternalServiceErrorException'){
                            return 
                        } else if (err.code === 'InvalidParameterException'){
                            return
                        } else if (err.code === 'InvalidRequestException'){
                            return
                        } else if (err.code === 'ResourceNotFoundException'){
                            return
                        }
                    } else {
                      let encryptSecret, decodedBinarySecret;
                      if ('SecretString' in data) {
                          encryptSecret = JSON.parse(data.SecretString);
                          encryptSecret = encryptSecret.blenderProxyPrivateKey
                      } else {
                          let buff = new Buffer(data.SecretBinary, 'base64');
                          decodedBinarySecret = buff.toString('ascii');
                      }
              
                      let proxyPrivKeyHash = proxyKey.Item.privateKeyHash
                      let proxyPubKey = proxyKey.Item.publicKey
                      let bytesProxy = CryptoJS.AES.decrypt(String(proxyPrivKeyHash), encryptSecret);

                      proxyPrivKeyHash = null
                      encryptSecret = null;
                      decodedBinarySecret = null;

                      let blenderPrivateProxyKey = bytesProxy.toString(CryptoJS.enc.Utf8);
                      blenderPrivateProxyKey = String(blenderPrivateProxyKey)

                      bytesProxy = null

                      publicKey = response.Item.publicKey
                      let lastNonce = response.Item.lastNonce
                      let preHashStringArray = response.Item.proxyPreHashArray
                      let postHashStringArray = response.Item.proxyPostHashArray
                      let emailAddress = response.Item.emailAddress
                      let firstName = response.Item.firstName
                      let privateKey = response.Item.privateKey
                      let bytes = CryptoJS.AES.decrypt(String(privateKey), password)
                      let plaintextPK
                      try{
                        plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
                        finishTxn()
                      }catch(err){
                        
                        that.setState({
                          disableWhileTxn: false,
                          generalNoticeTimedOverlay: false,
                          generalNoticeOverlay: false,
                          pendingTransactionLoaderOverlay: false,
                          errorTags: 
                            <p style={{ textAlign: 'left', }}>
                              {that.state.selectedLanguage == 'spanish' ? 
                                'Contraseña no Válida'
                                  :
                                'Incorrect Password'
                              }
                            </p>,
                        })
                      }
                      function finishTxn(){

                        plaintextPK = plaintextPK.substring(64, plaintextPK.length-64)

                        privateKey = null
                        blenderPrivateProxyKey = null


                        highRateWeb3.eth.getBalance(publicKey)
                        .then((balance) => { 

                          let currentWalletBalance = Number(balance)
                          let campaignPrivate = new highRateWeb3.eth.Contract(
                            thisContract_CampaignContract.abi,
                            contractAddress
                          )
                        

                          highRateWeb3.eth.getTransactionCount(publicKey).then((nonce) => {

                            let maxValue = (Math.floor(((Number(currentWalletBalance) - (4000000 * Number(proposeGasPrice) * 1.05)) * 100)/1000000000000000000)/100)
                            if(Number(maxValue) < 0){
                              maxValue = 0
                            }


                            if(currentWalletBalance <= Number(weiValueString) + 4000000 * Number(proposeGasPrice)){


                              
                              that.setState({
                                disableWhileTxn: false,
                                pendingTransactionLoaderOverlay: false,
                                errorTags: 
                                  <p style={{ textAlign: 'left' }}>
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      `Fondos Insuficientes - El limite de tu Cartera Blender es ${spendableWalletUSD(balance, proposeGasPrice, 4000000).toFixed(2)} USD`
                                        :
                                      `Insufficient Funds - Your Blender Wallet Balance Limit is ${spendableWalletUSD(balance, proposeGasPrice, 4000000).toFixed(2)} USD`
                                    }
                                  </p>
                              })
                            } else {
                              _compoundedBalance = _weiCompoundedBalance/1000000000000000000
                              if(Number(_compoundedBalance) > 999){
                                Number.prototype.countDecimals = function () {
                                  if(Math.floor(that.valueOf()) === that.valueOf()) return 0;
                                  return that.toString().split(".")[1].length || 0; 
                                }
                                let undecimaledTransactionValue = Number(Number(_compoundedBalance).toFixed(0)) 
                                let undecimaledTransactionValueWei = String(undecimaledTransactionValue) + '000000000000000000'
                                _weiCompoundedBalance = undecimaledTransactionValueWei

                              } 





                              highRateWeb3.eth.getTransactionCount(publicKey).then((_nonce) => {
                                const nonce = Number(_nonce);
                      
                      
                                var campaign = new highRateWeb3.eth.Contract(
                                  thisContract_CampaignContract.abi,
                                  contractAddress
                                );



                                var data = campaign.methods.repayment(
                                  String(_weiCompoundedBalance), 
                                  '500'
                                ).encodeABI();


                                const tx_repayment = {  
                                  chainId: 100,
                                  gas: '2500000',
                                  gasPrice: String(proposeGasPrice),
                                  from: publicKey, 
                                  to: contractAddress,
                                  value: (Number(weiValueString)).toLocaleString('fullwide', {useGrouping: false}),
                                  data,
                                  nonce: nonce
                                }

                      
                                let mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
                                var plaintextMnemonic = mnemonicWallet.privateKey


                                highRateWeb3.eth.accounts.signTransaction(tx_repayment, plaintextMnemonic)
                                  .then((signedTx_repayment) => {

                                    highRateWeb3.eth.sendSignedTransaction(signedTx_repayment.rawTransaction).then((_tx_repayment) => {
                                      let newTxnHash = _tx_repayment.transactionHash







                                  
                                        Promise.all([
                                          campaign.methods.getSummary1().call(),
                                          campaign.methods.outstandingPrincipal().call()
                                        ])
                                          .then(([res, outstandingPrincipalCompounded]) => {

                                            web3BalancePost = Number(res[0])
                                            loanTarget = Number(res[1])
                                            minimumContribution = Number(res[2])
                                            interestRate = Number(res[3])
                                            finalRequestsSum = Number(res[4])
                                            repaymentSum = Number(res[5])
                                            totalContributed = Number(res[6])
                                            approversCount = Number(res[7])
                                            requestsCt = Number(res[8])
                                            receiptsCt = Number(res[9])
                                            approversList = res[10]
                                            manager = Number(res[11])
                                            insuranceTotal = Number(res[12])
                                            compoundedInterestPaid = Number(res[13])

                                            campaign.methods.getSummary2(publicKey).call()
                                              .then((res) => {

                                                currentUserLoanTotal = Number(res[0])
                                                userLiquidValue = Number(res[1])
                                                userFinalizedRequestLoanSum = Number(res[2])
                                                approverCheck = res[3]
                                                reclaimableValue = Number(res[4])
                                                compoundInterestReceived = Number(res[5])

                                                campaign.methods.getSummary3(publicKey).call()
                                                .then((res) => {

                                                  approverReceivedRepaymentSum = Number(res[0])

                                                    let approverReceivedPortionJSON = {}

                                                    function generateApproverReceivedPortionJSON(p){
                                                      if(p<=approversList.length-1){

                                                        let thisApproverPublicKey = approversList[p]
                                                        let _p = p


                                                        authenticatedPut('api1169ba1e', '', { 
                                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                                          body: { 
                                                            category: 'db',
                                                            tableName: 'wallet_username', 
                                                            primaryKey: thisApproverPublicKey, 
                                                            requestOperation: 'get',
                                                          }
                                                        }).then((wallet_user) => {
                                                          if(wallet_user.hasOwnProperty('Item')){

                                                            let thisApproverUsername = wallet_user.Item.username

                                                              campaign.methods.getSummary2(thisApproverPublicKey).call()
                                                                .then((res2) => {
                                                                  
                                                                  let thisUser_userFinalizedRequestLoanSum = Number(res2[2])
                                                                  userFinalizedValueMap[currentUser] = res2[4] + adjustedWeiValueNum * (res2[2]/totalContributed)

                                                                  campaign.methods.getSummary3(thisApproverPublicKey).call()
                                                                    .then((res3) => {

                                                                    let thisUser_approverReceivedRepaymentSum = Number(res3[0])
                                                                    let msgValuePostCommission = Number(weiValueString) * 0.95


                          
                                                                    let interestAdded = 0
                                                                    if(msgValuePostCommission > Number(_weiCompoundedBalance)){
                                                                      interestAdded = _weiCompoundedBalance - finalRequestsSum + repaymentSum;
                                                                    } else if(msgValuePostCommission == _weiCompoundedBalance){
                                                                        interestAdded = msgValuePostCommission - finalRequestsSum + repaymentSum;
                                                                    } else if(msgValuePostCommission < _weiCompoundedBalance){
                                                                      if(msgValuePostCommission > finalRequestsSum - repaymentSum){
                                                                        interestAdded = msgValuePostCommission - finalRequestsSum + repaymentSum;
                                                                      } 
                                                                    }

                                                                    let principalPaid = ((msgValuePostCommission - interestAdded) * (thisUser_userFinalizedRequestLoanSum - thisUser_approverReceivedRepaymentSum) / (finalRequestsSum - repaymentSum));
                                                                    let interestPaid = (interestAdded * thisUser_userFinalizedRequestLoanSum / finalRequestsSum);
                                                                    let weightedAverageReceivedPercentage = (principalPaid + interestPaid)/(msgValuePostCommission - interestAdded + interestAdded)

                                                                    approverReceivedPortionJSON[thisApproverUsername] = weightedAverageReceivedPercentage

                                                                    generateApproverReceivedPortionJSON(p+1)
                                                                  })
                                                              })

                                                            } else {
                                                              generateApproverReceivedPortionJSON(p+1)
                                                            }
                                                          })
                                                      } else {                                                                
                                                                    
                                                          let _dateCreated = new Date()
                                                          _dateCreated = String(_dateCreated).substring(0,10)
                                                        
                                                          let monthNum = _dateCreated.substr(5,2)
                                                          let yearNum = _dateCreated.substr(0,4)
                                                          let dayNum = _dateCreated.substr(8,2)
                                                          let monthString
                                                          if(monthNum == '01'){
                                                            monthString = 'Jan. '
                                                          } else if(monthNum == '02'){
                                                            monthString = 'Feb. '
                                                          } else if(monthNum == '03'){
                                                            monthString = 'Mar. '
                                                          } else if(monthNum == '04'){
                                                            monthString = 'Apr. '
                                                          } else if(monthNum == '05'){
                                                            monthString = 'May. '
                                                          } else if(monthNum == '06'){
                                                            monthString = 'Jun. '
                                                          } else if(monthNum == '07'){
                                                            monthString = 'Jul. '
                                                          } else if(monthNum == '08'){
                                                            monthString = 'Aug. '
                                                          } else if(monthNum == '09'){
                                                            monthString = 'Sep. '
                                                          } else if(monthNum == '10'){
                                                            monthString = 'Oct. '
                                                          } else if(monthNum == '11'){
                                                            monthString = 'Nov. '
                                                          } else if(monthNum == '12'){
                                                            monthString = 'Dec. '
                                                          } 
                                                          _dateCreated = monthString + dayNum + ', ' + yearNum
                                                        
                                                          var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                                          randomString1 =  randomString1.substring(0,18)
                                                        
                                                          var randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                                          randomString2 =  randomString2.substring(0,18)

                                                          authenticatedPut('api1169ba1e', '', { 
                                                            headers: { Authorization: `Bearer ${cognitoID}` },
                                                            body: { 
                                                              category: 'db',
                                                              tableName: 'pendingTransactions', 
                                                              primaryKey: newTxnHash, 
                                                              requestOperation: 'update',
                                                              updateExpression: 
                                                                `SET 
                                                                  approverReceivedPortionJSON = :approverReceivedPortionJSON,
                                                                  contractAddress = :contractAddress,
                                                                  approverCheck = :approverCheck,
                                                                  minLoan = :minLoan,
                                                                  userFinalizedValueMap = :userFinalizedValueMap,
                                                                  compoundedInterestPaidNow = :compoundedInterestPaidNow,
                                                                  application = :application,
                                                                  displayValue = :displayValue,
                                                                  currency = :currency,
                                                                  conversionRateGlobal = :conversionRateGlobal,
                                                                  lookupKey = :lookupKey,
                                                                  availableCredit = :availableCredit,
                                                                  offeredLenderCommissionUSD = :offeredLenderCommissionUSD,
                                                                  contractStructure = :contractStructure,
                                                                  settlementDate = :settlementDate,
                                                                  closureDate = :closureDate,
                                                                  outstandingPrincipalCompounded = :outstandingPrincipalCompounded
                                                                `,
                                                              expressionAttributeValues: { 
                                                                ':approverReceivedPortionJSON': approverReceivedPortionJSON,
                                                                ':contractAddress': contractAddress,
                                                                ':approverCheck': approverCheck,
                                                                ':minLoan': minimumContribution,
                                                                ':userFinalizedValueMap': userFinalizedValueMap,
                                                                ':compoundedInterestPaidNow': compoundedInterestPaidNow,
                                                                ':application': 'TBP',
                                                                ':displayValue': transactionValueUSD,
                                                                ':currency': 'USD',
                                                                ':conversionRateGlobal': 1,
                                                                ':lookupKey': _lookupKey,
                                                                ':availableCredit': Number(availableCredit)*1000000000000000000,
                                                                ':offeredLenderCommissionUSD': offeredLenderCommissionUSD,
                                                                ':contractStructure': contractStructureType,
                                                                ':settlementDate': settlementDateFormatted,
                                                                ':closureDate': closureDateFormatted,
                                                                ':outstandingPrincipalCompounded': outstandingPrincipalCompounded
                                                              }
                                                            }
                                                          }).then((res) => {

                                                              authenticatedPut('api1169ba1e', '', { 
                                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                                body: { 
                                                                  category: 'db',
                                                                  tableName: 'pendingTransactions', 
                                                                  primaryKey: newTxnHash, 
                                                                  requestOperation: 'update',
                                                                  updateExpression: 
                                                                    `SET 
                                                                      transactionType = :txnType,
                                                                      creationDate = :creationDate, 
                                                                      creationDateSecs = :creationDateSecs, 
                                                                      #st = :status, 
                                                                      currentUser = :currentUser,
                                                                      publicKey = :publicKey,
                                                                      emailType = :emailType,
                                                                      firstName = :firstName,
                                                                      emailAddress = :emailAddress,
                                                                      randomString1 = :randomString1,
                                                                      manager = :managerUsername,
                                                                      adjustedWeiValueNum = :adjustedWeiValueNum,
                                                                      web3BalancePre = :web3BalancePre,
                                                                      web3BalancePost = :web3BalancePost,
                                                                      interestRate = :interestRate,
                                                                      finalRequestsSum = :finalRequestsSum,
                                                                      repaymentSum = :repaymentSum,
                                                                      totalContributed = :totalContributed,
                                                                      approversCount = :approversCount,
                                                                      requestsCt = :requestsCt,
                                                                      receiptsCt = :receiptsCt,
                                                                      approversList = :approversList,
                                                                      userLoanTotal = :userLoanTotal,
                                                                      userLiquidValue = :userLiquidValue,
                                                                      userFinalizedRequestLoanSum = :userFinalizedRequestLoanSum,
                                                                      reclaimableValue = :reclaimableValue
                                                                    `,
                                                                  expressionAttributeNames: {"#st":"status"},
                                                                  expressionAttributeValues: { 
                                                                    ':txnType': 'payment',
                                                                    ':creationDate': new Date(),
                                                                    ':creationDateSecs': Date.now(), 
                                                                    ':currentUser': currentUser,
                                                                    ':status': 'active',
                                                                    ':managerUsername': _managerLCase,
                                                                    ':publicKey': publicKey,
                                                                    ':emailAddress': emailAddress,
                                                                    ':emailType': 'payment',
                                                                    ':randomString1': randomString1,
                                                                    ':firstName': firstName,
                                                                    ':adjustedWeiValueNum': adjustedWeiValueNum,
                                                                    ':web3BalancePre': web3BalancePre,
                                                                    ':web3BalancePost': web3BalancePost,
                                                                    ':interestRate': interestRate,
                                                                    ':finalRequestsSum': finalRequestsSum,
                                                                    ':repaymentSum': repaymentSum,
                                                                    ':totalContributed': totalContributed,
                                                                    ':approversCount': approversCount,
                                                                    ':requestsCt': requestsCt,
                                                                    ':receiptsCt': receiptsCt,
                                                                    ':approversList': approversList,
                                                                    ':userLoanTotal': currentUserLoanTotal,
                                                                    ':userLiquidValue': userLiquidValue,
                                                                    ':userFinalizedRequestLoanSum': userFinalizedRequestLoanSum,
                                                                    ':reclaimableValue': reclaimableValue
                                                                  }
                                                                }
                                                              }).then((res) => {

                                                                authenticatedPut('api1169ba1e', '', { 
                                                                  headers: { Authorization: `Bearer ${cognitoID}` },
                                                                  body: { 
                                                                      category: 'db',
                                                                      tableName: 'users', 
                                                                      primaryKey: currentUser,
                                                                      requestOperation: 'update',
                                                                      updateExpression: 
                                                                          `SET 
                                                                              lastNonce = :lastNonce
                                                                          `,
                                                                      expressionAttributeValues: { 
                                                                          ':lastNonce': nonce
                                                                      },
                                                                  }
                                                                }).then((res) => {

                                                                  authenticatedPut('api1169ba1e', '', { 
                                                                    headers: { Authorization: `Bearer ${cognitoID}` },
                                                                    body: { 
                                                                      category: 'db',
                                                                      tableName: 'general', 
                                                                      primaryKey: 'txnHash', 
                                                                      requestOperation: 'update',
                                                                      updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                                                                      expressionAttributeValues: { 
                                                                        ':txnHash': [newTxnHash]
                                                                      }
                                                                    }
                                                                  })
                                                                }).then((res) => {

                                                                  that.setState({
                                                                    successOverlay: true,
                                                                    pendingTransactionLoaderOverlay: false,
                                                                    generalNoticeOverlay: true,
                                                                    generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
                                                                      `Has pagado ${transactionValueUSD} USD a los prestadores de tu línea de crédito.`
                                                                        :
                                                                      `You've repaid ${transactionValueUSD} USD to the lender of your credit line.`
                                                                    ),
                                                                  })
                                                                
                                                                  that.reloadPage()
                                                                })

                                                              })
                                                          })
                                                        
                                                        
                                                      }
                                                    }
                                                    generateApproverReceivedPortionJSON(0)
                                                })
                                              })
                                          })
            
                                      })
                                    })
                                  })
                                
                                }
                            })
                          })
                        }

                      }
                  })
                })
          })
        })
      })
    } catch(error) {
      return
    }
  }

  createWithdrawalReqTxn(password){

    // Preserve the withdrawal amount exactly at 18 decimals.
    let weiValueString = ethers.utils.parseUnits(String(that.state.moneyTransactionLiveValue).trim(), 18).toString()
    let weiValue = Number(weiValueString)
    let transactionValueUSD = Number(that.state.moneyTransactionLiveValue).toFixed(2);
    let weiValueNum, adjustedWeiValueNum;
    let randomString = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  

    randomString =  randomString.substring(0,18)

    if(!that.state.isSubscribedCurrentBool){
      adjustedWeiValueNum = weiValue - (weiValue * blenderPercentCharge)
    } else {
      adjustedWeiValueNum = weiValue
    }
    that.setState({ 
      showPasswordOverlay: false,
      password: null,
      disableWhileTxn: true,      
      pendingTransactionLoaderOverlay: true
    })

    
    campaign.methods.getSummary1().call()
      .then((res) => {
        web3BalancePre = res[0]

        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: currentUser, 
            requestOperation: 'get',
          }
        }).then((response) => {
          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'privateBlenderKeys', 
              primaryKey: 'proxyKeys', 
              requestOperation: 'get',
            }
          }).then((proxyKey) => {
            client.getSecretValue({SecretId: secretName}, function(err, data) {
              if (err) {
                  if (err.code === 'DecryptionFailureException'){
                      return
                  } else if (err.code === 'InternalServiceErrorException'){
                      return 
                  } else if (err.code === 'InvalidParameterException'){
                      return
                  } else if (err.code === 'InvalidRequestException'){
                      return
                  } else if (err.code === 'ResourceNotFoundException'){
                      return
                  }
              } else {
                let encryptSecret, decodedBinarySecret;
                if ('SecretString' in data) {
                    encryptSecret = JSON.parse(data.SecretString);
                    encryptSecret = encryptSecret.blenderProxyPrivateKey
                } else {
                    let buff = new Buffer(data.SecretBinary, 'base64');
                    decodedBinarySecret = buff.toString('ascii');
                }
        
                let proxyPrivKeyHash = proxyKey.Item.privateKeyHash
                let proxyPubKey = proxyKey.Item.publicKey
                let bytesProxy = CryptoJS.AES.decrypt(String(proxyPrivKeyHash), encryptSecret);

                proxyPrivKeyHash = null
                encryptSecret = null;
                decodedBinarySecret = null;

                let blenderPrivateProxyKey = bytesProxy.toString(CryptoJS.enc.Utf8);
                blenderPrivateProxyKey = String(blenderPrivateProxyKey)

                bytesProxy = null

                  publicKey = response.Item.publicKey
                  let lastNonce = response.Item.lastNonce
                  let preHashStringArray = response.Item.proxyPreHashArray
                  let postHashStringArray = response.Item.proxyPostHashArray
                  let emailAddress = response.Item.emailAddress
                  let firstName = response.Item.firstName
                  let privateKey = response.Item.privateKey
                  let bytes = CryptoJS.AES.decrypt(String(privateKey), password);
                  let plaintextPK
                  try{
                    plaintextPK = bytes.toString(CryptoJS.enc.Utf8);
                    finishTxn()
                  }catch(err){
                    
                    that.setState({
                      disableWhileTxn: false,
                      generalNoticeTimedOverlay: false,
                      generalNoticeOverlay: false,
                      pendingTransactionLoaderOverlay: false,
                      errorTags: 
                        <p style={{ textAlign: 'left', }}>
                          {that.state.selectedLanguage == 'spanish' ? 
                            'Contraseña no Válida'
                              :
                            'Incorrect Password'
                          }
                        </p>,
                    })
                  }
                  function finishTxn(){
                    plaintextPK = plaintextPK.substring(64, plaintextPK.length-64)

                    // let provider = new HDWalletProvider(
                    //   plaintextPK,
                    //   "https://rpc.gnosischain.com/"
                    // );
                    
                    // let providerBlender = new HDWalletProvider(
                    //   blenderPrivateProxyKey,
                    //   "https://rpc.gnosischain.com/"
                    // );

                    privateKey = null
                    blenderPrivateProxyKey = null
                  
                    highRateWeb3.eth.getBalance(publicKey)
                    .then((balance) => { 

                      let currentWalletBalance = Number(balance)
                      let campaignPrivate = new highRateWeb3.eth.Contract(
                        thisContract_CampaignContract.abi,
                        contractAddress
                      )
                  

                      highRateWeb3.eth.getTransactionCount(publicKey).then((nonce) => {

                        if(currentWalletBalance <= (4000000 * Number(proposeGasPrice))){

                          
                          that.setState({
                            disableWhileTxn: false,
                            generalNoticeTimedOverlay: false,
                            generalNoticeOverlay: false,
                            errorTags: 
                              <p style={{ textAlign: 'left' }}>
                                {that.state.selectedLanguage == 'spanish' ? 
                                  `Fondos Insuficientes - El limite de tu Cartera Blender es ${spendableWalletUSD(balance, proposeGasPrice, 4000000).toFixed(2)} USD`
                                      :
                                  `Insufficient Funds - Your Blender Wallet Balance Limit is ${spendableWalletUSD(balance, proposeGasPrice, 4000000).toFixed(2)} USD`
                                }
                              </p>
                          })
                        } else {
                         
















                          highRateWeb3.eth.getTransactionCount(publicKey).then((_nonce) => {
                            const nonce = Number(_nonce);
                  
                            var campaign = new highRateWeb3.eth.Contract(
                              thisContract_CampaignContract.abi,
                              contractAddress
                            );

                            var data = campaign.methods.createRequest(
                              String(Date.now()), 
                              weiValueString, 
                              '500'
                            ).encodeABI();


                            const tx_createWithdrawalRequest = {  
                              chainId: 100,
                              gas: '3000000',
                              gasPrice: String(proposeGasPrice),
                              from: publicKey, 
                              to: contractAddress,
                              data,
                              nonce: nonce
                            }

                  
                            let mnemonicWallet = ethers.Wallet.fromMnemonic(plaintextPK);
                            var plaintextMnemonic = mnemonicWallet.privateKey


                            highRateWeb3.eth.accounts.signTransaction(tx_createWithdrawalRequest, plaintextMnemonic)
                              .then((signedTx_createWithdrawalRequest) => {

                                highRateWeb3.eth.sendSignedTransaction(signedTx_createWithdrawalRequest.rawTransaction).then((_tx_createWithdrawalRequest_receipt) => {
                                  let newTxnHash = _tx_createWithdrawalRequest_receipt.transactionHash
























                                

                                campaign.methods.getSummary1().call()
                                  .then((res) => {

                                    web3BalancePost = res[0]
                                    loanTarget = res[1]
                                    minimumContribution = res[2]
                                    interestRate = res[3]
                                    finalRequestsSum = res[4]
                                    repaymentSum = res[5]
                                    totalContributed =res[6]
                                    approversCount = res[7]
                                    requestsCt = res[8]
                                    receiptsCt = res[9]
                                    approversList = res[10]
                                    manager = res[11]
                                    insuranceTotal = res[12]
                                    compoundedInterestPaid = res[13] 

                                    campaign.methods.getSummary2(publicKey).call()
                                      .then((res) => {

                                        currentUserLoanTotal = Number(res[0])
                                        userLiquidValue = Number(res[1])
                                        userFinalizedRequestLoanSum = Number(res[2])
                                        approverCheck = res[3]
                                        reclaimableValue = Number(res[4])
                                        compoundInterestReceived = Number(res[5])


                                        if((finalRequestsSum - repaymentSum + weiValue) >= loanTarget){
                                          weiValue = loanTarget - (finalRequestsSum - repaymentSum);
                                        }
                                        if(weiValue <= 0){
                                          weiValue = 0
                                        }
                                        weiValueString = String(weiValue)

                                        let _dateCreated = new Date()
                                        _dateCreated = String(_dateCreated).substring(0,10)
                                      
                                        let monthNum = _dateCreated.substr(5,2)
                                        let yearNum = _dateCreated.substr(0,4)
                                        let dayNum = _dateCreated.substr(8,2)
                                        let monthString
                                        if(monthNum == '01'){
                                          monthString = 'Jan. '
                                        } else if(monthNum == '02'){
                                          monthString = 'Feb. '
                                        } else if(monthNum == '03'){
                                          monthString = 'Mar. '
                                        } else if(monthNum == '04'){
                                          monthString = 'Apr. '
                                        } else if(monthNum == '05'){
                                          monthString = 'May. '
                                        } else if(monthNum == '06'){
                                          monthString = 'Jun. '
                                        } else if(monthNum == '07'){
                                          monthString = 'Jul. '
                                        } else if(monthNum == '08'){
                                          monthString = 'Aug. '
                                        } else if(monthNum == '09'){
                                          monthString = 'Sep. '
                                        } else if(monthNum == '10'){
                                          monthString = 'Oct. '
                                        } else if(monthNum == '11'){
                                          monthString = 'Nov. '
                                        } else if(monthNum == '12'){
                                          monthString = 'Dec. '
                                        } 
                                        _dateCreated = monthString + dayNum + ', ' + yearNum
                                      
                                        var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                        randomString1 =  randomString1.substring(0,18)
                                      
                                        var randomString2 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                                        randomString2 =  randomString2.substring(0,18)


                                        approversList.forEach((item) => {
                                          campaign.methods.getSummary2(item).call()
                                            .then((res) => {
                                              authenticatedPut('api1169ba1e', '', { 
                                                headers: { Authorization: `Bearer ${cognitoID}` },
                                                body: { 
                                                  category: 'db',
                                                  tableName: 'wallet_username', 
                                                  primaryKey: item, 
                                                  requestOperation: 'get',
                                                }
                                              })
                                            })
                                        })

                                        
                                        authenticatedPut('api1169ba1e', '', {
                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                          body: {
                                            category: 'db', tableName: 'contracts',
                                            primaryKey: contractAddress, requestOperation: 'get'
                                          }
                                        }).then((contractRecord) => {
                                          if(!contractRecord.Item){
                                            throw new Error('Credit-Line Record Not Found');
                                          }
                                          let userFinalizedValueMap = {
                                            ...(contractRecord.Item.userFinalizedValueMap || {}),
                                            [publicKey]: String(res[2])
                                          };
                                          return authenticatedPut('api1169ba1e', '', { 
                                          headers: { Authorization: `Bearer ${cognitoID}` },
                                          body: { 
                                            category: 'db',
                                            tableName: 'pendingTransactions', 
                                            primaryKey: newTxnHash, 
                                            requestOperation: 'update',
                                            updateExpression: 
                                              `SET 
                                                transactionType = :txnType,
                                                creationDate = :creationDate, 
                                                creationDateSecs = :creationDateSecs, 
                                                #st = :status, 
                                                currentUser = :currentUser,
                                                publicKey = :publicKey,
                                                emailType = :emailType,
                                                firstName = :firstName,
                                                emailAddress = :emailAddress,
                                                randomString1 = :randomString1,
                                                manager = :managerUsername,
                                                adjustedWeiValueNum = :adjustedWeiValueNum,
                                                web3BalancePre = :web3BalancePre,
                                                web3BalancePost = :web3BalancePost,
                                                intRate = :interestRate,
                                                finalRequestsSum = :finalRequestsSum,
                                                repaymentSum = :repaymentSum,
                                                totalContributed = :totalContributed,
                                                approversCount = :approversCount,
                                                requestsCt = :requestsCt,
                                                receiptsCt = :receiptsCt,
                                                approversList = :approversList,
                                                userLoanTotal = :userLoanTotal,
                                                userLiquidValue = :userLiquidValue,
                                                userFinalizedRequestLoanSum = :userFinalizedRequestLoanSum,
                                                reclaimableValue = :reclaimableValue,
                                                contractAddress = :contractAddress,
                                                approverCheck = :approverCheck,
                                                minLoan = :minLoan,
                                                application = :application,
                                                displayValue = :displayValue,
                                                currency = :currency,
                                                conversionRateGlobal = :conversionRateGlobal,
                                                lookupKey = :lookupKey,
                                                availableCredit = :availableCredit,
                                                contractStructure = :contractStructure,
                                                userFinalizedValueMap = :userFinalizedValueMap
                                              `,
                                            expressionAttributeNames: {"#st":"status"},
                                            expressionAttributeValues: { 
                                              ':txnType': 'withdrawal',
                                              ':creationDate': new Date(),
                                              ':creationDateSecs': Date.now(), 
                                              ':currentUser': currentUser,
                                              ':status': 'active',
                                              ':managerUsername': _managerLCase,
                                              ':publicKey': publicKey,
                                              ':emailAddress': emailAddress,
                                              ':emailType': 'withdrawal',
                                              ':randomString1': randomString1,
                                              ':firstName': firstName,
                                              ':adjustedWeiValueNum': weiValue,
                                              ':web3BalancePre': web3BalancePre,
                                              ':web3BalancePost': web3BalancePost,
                                              ':interestRate': interestRate,
                                              ':finalRequestsSum': finalRequestsSum,
                                              ':repaymentSum': repaymentSum,
                                              ':totalContributed': totalContributed,
                                              ':approversCount': approversCount,
                                              ':requestsCt': requestsCt,
                                              ':receiptsCt': receiptsCt,
                                              ':approversList': approversList,
                                              ':userLoanTotal': currentUserLoanTotal,
                                              ':userLiquidValue': userLiquidValue,
                                              ':userFinalizedRequestLoanSum': userFinalizedRequestLoanSum,
                                              ':approverCheck': approverCheck,
                                              ':reclaimableValue': reclaimableValue,
                                              ':contractAddress': contractAddress,
                                              ':minLoan': minimumContribution,
                                              ':application': 'TBP',
                                              ':displayValue': transactionValueUSD,
                                              ':currency': 'USD',
                                              ':lookupKey': _lookupKey,
                                              ':conversionRateGlobal': 1,
                                              ':availableCredit': Number(availableCredit)*1000000000000000000,
                                            
                                              ':contractStructure': contractStructureType,
                                              ':userFinalizedValueMap': userFinalizedValueMap,
}
                                          }
                                        });
                                        }).then((res) => {

                                          authenticatedPut('api1169ba1e', '', { 
                                            headers: { Authorization: `Bearer ${cognitoID}` },
                                            body: { 
                                                category: 'db',
                                                tableName: 'users', 
                                                primaryKey: currentUser,
                                                requestOperation: 'update',
                                                updateExpression: 
                                                    `SET 
                                                        lastNonce = :lastNonce
                                                    `,
                                                expressionAttributeValues: { 
                                                    ':lastNonce': nonce
                                                },
                                            }
                                          }).then((res) => {

                                            authenticatedPut('api1169ba1e', '', { 
                                              headers: { Authorization: `Bearer ${cognitoID}` },
                                              body: { 
                                                category: 'db',
                                                tableName: 'general', 
                                                primaryKey: 'txnHash', 
                                                requestOperation: 'update',
                                                updateExpression: `SET txnHash = list_append(txnHash, :txnHash)`, 
                                                expressionAttributeValues: { 
                                                  ':txnHash': [newTxnHash]
                                                }
                                              }
                                            })
                                          }).then((res) => {

                                            that.setState({
                                              successOverlay: true,
                                              generalNoticeOverlay: true,
                                              generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
                                                `Has retirado ${transactionValueUSD} USD desde tu línea de crédito.`
                                                  :
                                                `You've withdrawn ${transactionValueUSD} USD from your credit line.`
                                              ),
                                              pendingTransactionLoaderOverlay: false
                                            })
                                            that.reloadPage()
                                          })
                                        })
                                    })


                                
                              
                            })
                          })

                        })
                      })
                    }
                  })
                })
              }
            }
          })
        })
      })
    })
  }

  makeCollateralAssistanceRequest(){
    
    var randomString1 = String(Date.now()) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    randomString1 =  randomString1.substring(0,18)
  
    let updateExpression, expressionAttributeValues;

    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
        category: 'db',
        tableName: 'verifiedRegistryFundedContracts', 
        primaryKey: contractAddress, 
        requestOperation: 'get',
      }
    }).then((response) => {
      if(response.hasOwnProperty('Item')){

        let requestApprovalStatusBool = response.Item.requestApprovedByVerifiedRegistryBool
        let requestDenialStatusBool = response.Item.requestDeniedByVerifiedRegistryBool
        let collateralGrantedBool = response.Item.collateralGrantedBool

        if(!requestDenialStatusBool && !requestApprovalStatusBool && !collateralGrantedBool){
          updateExpression = 
            `SET 
              requestedCollateralValueWei = :requestedCollateralValueWei,
              collateralGrantedBool = :collateralGrantedBool,
              txnHashOfGrantedCollateral = :txnHashOfGrantedCollateral,
              requestApprovedByVerifiedRegistryBool = :requestApprovedByVerifiedRegistryBool,
              requestDeniedByVerifiedRegistryBool = :requestDeniedByVerifiedRegistryBool,
              requestTimestamp = :requestTimestamp
            `
          expressionAttributeValues = 
            { 
              ':requestedCollateralValueWei': Number(that.state.collateralAssistanceRequestedUSD) * 1000000000000000000,
              ':collateralGrantedBool': false,
              ':txnHashOfGrantedCollateral': '',
              ':requestApprovedByVerifiedRegistryBool': false,
              ':requestDeniedByVerifiedRegistryBool': false,
              ':requestTimestamp': Date.now(),
            }

          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
                category: 'db',
                tableName: 'verifiedRegistryFundedContracts', 
                primaryKey: contractAddress,
                requestOperation: 'update',
                updateExpression: 
                  `SET 
                    requestedCollateralValueWei = :requestedCollateralValueWei,
                    collateralGrantedBool = :collateralGrantedBool,
                    txnHashOfGrantedCollateral = :txnHashOfGrantedCollateral,
                    requestApprovedByVerifiedRegistryBool = :requestApprovedByVerifiedRegistryBool,
                    requestDeniedByVerifiedRegistryBool = :requestDeniedByVerifiedRegistryBool,
                    requestTimestamp = :requestTimestamp
                  `,
                expressionAttributeValues: { 
                  ':requestedCollateralValueWei': Number(that.state.collateralAssistanceRequestedUSD) * 1000000000000000000,
                  ':collateralGrantedBool': false,
                  ':txnHashOfGrantedCollateral': '',
                  ':requestApprovedByVerifiedRegistryBool': false,
                  ':requestDeniedByVerifiedRegistryBool': false,
                  ':requestTimestamp': Date.now(),
                }
            }
          }).then((res) => {

            authenticatedPut('api1169ba1e', '', { 
              headers: { Authorization: `Bearer ${cognitoID}` },
              body: { 
                category: 'db',
                tableName: 'general', 
                primaryKey: 'requestedCollateralAssistanceContracts', 
                requestOperation: 'get',
              }
            }).then((_requestedCollateralAssistanceContracts) => {
              let existingRequestedCollateralAssistanceContracts = _requestedCollateralAssistanceContracts.Item.requestedCollateralAssistanceContracts


              if(!existingRequestedCollateralAssistanceContracts.includes(contractAddress)){


                authenticatedPut('api1169ba1e', '', { 
                  headers: { Authorization: `Bearer ${cognitoID}` },
                  body: { 
                    category: 'db',
                    tableName: 'general', 
                    primaryKey: 'requestedCollateralAssistanceContracts', 
                    requestOperation: 'update',
                    updateExpression: `SET requestedCollateralAssistanceContracts = list_append(requestedCollateralAssistanceContracts, :contractAddress)`, 
                    expressionAttributeValues: { 
                      ':contractAddress': [contractAddress]
                    }
                  }
                }).then((res) => {

                })
              }
              that.setState({
                generalNoticeOverlay: true,
                generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
                  'Pedido de Colateral Exito.  Has solicitada asistencia de colateral para tomar prestamo en este línea de crédito.\n\nTienes que esperar para respuesta de reseñar este solicitud del Lenderblock Verified Registry.'
                    :
                  'Successful Collateral Request.  You have requested Collateral Assistance for your Borrowing via this Credit-Line.\n\nPlease await review of this request from The Verified Registry Review Team.'
                ),
                collateralRequestOverlay: false,
              })
            })

          })

        } else if(requestDenialStatusBool){
          that.setState({
            generalNoticeOverlay: true,
            generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
              'Pedido de Colateral Denegada.  Se ha estado denegado recientemente su pedido de asistencia de colateral por este línea de crédito.  Por favor funda su propio colateral.'
                :
              'Denied Collateral Request.  You have recently been denied a request for Collateral Assistance via this Credit-Line. Please fund your Collateral independently.'
            ),
            collateralRequestOverlay: false,
          })

        } else {
          that.setState({
            generalNoticeOverlay: true,
            generalNoticeText: (that.state.selectedLanguage == 'spanish' ? 
              'Pedido Pendiente de Colateral.  Tienes una solicitud pendiente para asistencia de colateral por este línea de crédito, que debe se terminar por el Verified Registry antes del entregar solicitudos nuevos.'
                :
              'Pending Collateral Request.  You have a pending request for Collateral Assistance via this Credit-Line, which must first be resolved by the Verified Registry review team prior to new requests.'
            ),
            collateralRequestOverlay: false,
          })
    
        }
      
      }
    })
  }

  addWishlist(){
    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
        category: 'db',
        tableName: 'users', 
        primaryKey: currentUser, 
        requestOperation: 'get',
      }
    }).then((response) => {
      wishlist = response.Item.wishlist
      let contractIndex = wishlist.indexOf(contractAddress)
      if(contractIndex != -1){
        
        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: currentUser, 
            requestOperation: 'update',
            updateExpression: 
              "REMOVE wishlist[" + contractIndex + "]"
          }
        }).then((res) => { 
          that.setState({
            inWishlistBool: false
          })
        })
      } else { 
        
        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'users', 
            primaryKey: currentUser, 
            requestOperation: 'update',
            updateExpression: 
              `SET 
              wishlist = list_append(wishlist, :wishlist)
              `
            , 
            expressionAttributeValues: { 
              ':wishlist': [contractAddress],
            },
          }
        }).then((res) => { 
          that.setState({
            inWishlistBool: true,
            generalNoticeText: that.state.selectedLanguage == 'spanish' ? 'Línea de Crédito Guardado' : 'Credit-Line Saved',
            generalNoticeTimedOverlay: true,
          }, () => {
            setTimeout(() => {
              that.setState({
                generalNoticeText: '',
                generalNoticeTimedOverlay: false,
              })
            }, 3000)
          })         
        }) 
      }
    })
  }

  manageText(text, field){
    if(field == 'xDAI'){
      that.setState({
        ethConvertText: text,
        secondaryConvertText: null,
        primaryConvertText: null
      })
    } else if(field == that.state.primaryDisplayCurrency) {
      that.setState({
        primaryConvertText: text,
        ethConvertText: null,
        secondaryConvertText: null
      })
    } else if(field == that.state.primaryDisplayCurrency) {
      that.setState({
        secondaryConvertText: text,
        ethConvertText: null,
        primaryConvertText: null
      })
    }
  }

  swapFunction(){
    
        conversionRateGlobal = 1
      
        if(currentUser != undefined && _managerLCase != undefined){
          if(_managerLCase != currentUser.toLowerCase()){

            if(that.state.switch == '2'){
              actionType = 'contribute'
              actionButton =
                <Button 
                  style={{
                    height: 40, 
                    width: 125, 
                    paddingBottom: 9, 
                    paddingTop: 9, 
                    paddingLeft: 5, 
                    paddingRight: 5,  
                    borderRadius: 5, 
                    backgroundColor:  that.state.actionInitButtonBackgroundColor,
                    marginLeft: 20, 
                    justifyContent: 'center',
                  }}
                  disabled={that.state.disableWhileTxn}
                  onClick={() => {
                    if(that.state.freezeButtonsNoVerify){
                      that.setState({ verifyIDOverlay: true })
                    } else {
                        if(that.state.confirmActionPopUp == false){

                          
                        }
                    }
                  }}
                >
                  <p style={{ fontSize: 17, justifyContent: 'center', alignContent: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', textAlign: 'center',}}>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Prestar'
                        :
                      'Lend'
                    }
                  </p>
                </Button>    
                
              that.setState({
                switch: '1',
                activityIndicator: null,
                actionValue: null,
                actionPlaceHolder: '0 USD',
                actionButton,
                actionType   
              })
            } else {
              if(that.state.approverCheck == true){
                actionType = 'reclaim'
                actionButton = 
                  <Button 
                    style={{
                      height: 40, 
                      width: 135, 
                      paddingBottom: 9, 
                      paddingTop: 9, 
                      paddingLeft: 5, 
                      paddingRight: 5,  
                      borderRadius: 5, 
                      backgroundColor: that.state.actionInitButtonBackgroundColor,
                      marginLeft: 20, 
                      justifyContent: 'center',
                    }}
                    disabled={that.state.disableWhileTxn}
                    onClick={() => {
                      if(that.state.freezeButtonsNoVerify){
                         that.setState({ verifyIDOverlay: true })
                      } else {

                        if (reclaimableValue <= 0.1){
                          that.setState({ 
                            activityIndicator: 
                              <div style={{ justifyContent: 'center', marginLeft: 0, marginRight: 0, alignContent: 'center', marginTop: 15, marginBottom: 15 }}>
                                <p style={{ color: 'rgba(204, 12, 12, .70)', fontWeight: '400', fontSize: 20, textAlign: 'center', marginBottom: 10, marginTop: 10 }}> 
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'El valor disponible de contribuciones\ntuyas para retirar es demasiado bajo.'
                                    :
                                  'Your remaining unwithdrawn contribution\nsum is too low to reclaim'
                                }
                              </p> 
                              </div>
                            })
                        } else {
                          if(that.state.actionValue >= ((minimumContribution / 1000000000000000000 ))){
                            if(that.state.confirmActionPopUp == false){
                              that.rescind()
                            } else {
                              that.setState({ 
                                activityIndicator: 
                                  <div style={{ justifyContent: 'center', marginLeft: 0, marginRight: 0, alignContent: 'center', marginTop: 15 }}>
                                    <p style={{ fontSize: 20, fontWeight: '400', textAlign: 'center', marginBottom: 10, marginTop: 10 }}> 
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        `Max Valor de Reclamar\n (por quedarse un prestador): ${Number((_safeReclaimableValueWei ) / 1000000000000000000).toFixed(7)} USD \n(saliendo la línea de crédito): ${Number((_exitReclaimableValueWei ) / 1000000000000000000).toFixed(7)} USD \n`
                                          :
                                        `Max Reclamation Value\n (as a continued lender): ${Number((_safeReclaimableValueWei ) / 1000000000000000000).toFixed(7)} USD \n(exiting the credit line): ${Number((_exitReclaimableValueWei ) / 1000000000000000000).toFixed(7)} USD \n`
                                      }
                                    </p> 
                                  </div>
                              })
                            }
                          } else {
                            that.setState({ 
                              activityIndicator: 
                                <div style={{ justifyContent: 'center', marginLeft: 0, marginRight: 0, alignItems: 'center', marginTop: 15, marginBottom: 15 }}>
                                  <p style={{ color: 'rgba(204, 12, 12, .70)', fontWeight: '600', fontSize: 20, textAlign: 'center', marginBottom: 10, marginTop: 10, textAlignVertical: 'center', textAlign: 'center', }}> 
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      `Valor de Transacción debe\nser al menos ${((minimumContribution / 1000000000000000000 )).toFixed(2)} USD`
                                        :
                                      `Transaction Value must be\nat least ${((minimumContribution / 1000000000000000000 )).toFixed(2)} USD.`
                                    }
                                  </p> 
                                </div>
                              })
                          }
                        }
                      }
                    }}
                  >
                    <p style={{ fontSize: 17, justifyContent: 'center', alignContent: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', textAlign: 'center',}}>
                      {that.state.selectedLanguage == 'spanish' ? 
                        'Reclamar'
                          :
                        'Reclaim'
                      }
                    </p>
                  </Button>     
                that.setState({
                  switch: '2',
                  actionValue: null,
                  activityIndicator: null,
                  actionPlaceHolder: "MAX "+Math.floor(Number(_reclaimableValue)).toFixed(2)+" "+'USD' ,
                  actionButton,
                  actionType
                })
              }
            }
          } else {

            if(that.state.switch == '2'){
              actionType = 'pay'
              actionButton = 
                <Button 
                  style={{
                    height: 40, 
                    width: 135, 
                    paddingBottom: 9, 
                    paddingTop: 9, 
                    paddingLeft: 10, 
                    paddingRight: 10,  
                    borderRadius: 5, 
                    backgroundColor: that.state.actionInitButtonBackgroundColor,
                    marginLeft: 20, 
                    justifyContent: 'center',
                  }}
                  disabled={that.state.disableWhileTxn}
                  onClick={() => {
                    if(that.state._compoundedBalance >= 1){
                      if(that.state.freezeButtonsNoVerify){
                        that.setState({ verifyIDOverlay: true })
                      } else {
                        if(that.state.actionValue >= ((minimumContribution / 1000000000000000000 ))){
                          if(that.state.confirmActionPopUp == false && (Number(that.state.actionValue) >= Number(_minLoan))){
                            that.repay()
                          }
                        } else {
                          that.setState({ 
                            activityIndicator: 
                              <div style={{ justifyContent: 'center', marginLeft: 0, marginRight: 0, alignItems: 'center', marginTop: 15, marginBottom: 15 }}>
                                <p style={{ color: 'rgba(204, 12, 12, .70)', fontWeight: '600', fontSize: 20, textAlign: 'center', marginBottom: 10, marginTop: 10, textAlignVertical: 'center', textAlign: 'center', }}> 
                                  {that.state.selectedLanguage == 'spanish' ? 
                                    `Valor de Transacción debe\nser al menos ${((minimumContribution / 1000000000000000000 )).toFixed(2)} USD`
                                      :
                                    `Transaction Value must be\nat least ${((minimumContribution / 1000000000000000000 )).toFixed(2)} USD.`
                                  }
                                </p> 
                              </div>
                            })
                        }
                      }
                    } else {
                      that.setState({
                        generalNoticeOverlay: true,
                        generalNoticeText: 
                          (that.state.selectedLanguage == 'spanish' ? 
                            'No hay deudas para pagar.'
                              :
                            'No Debt To Repay'
                          )
                      })
                    }
                  }}
                >
                  <p style={{ fontSize: 17, justifyContent: 'center', alignContent: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', textAlign: 'center',}}>
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Pagar'
                        :
                      'Pay'
                    }
                  </p>
                </Button>       
              that.setState({
                switch: '1',
                actionValue: null,
                activityIndicator: null,
                actionButton,
                actionType,
                actionPlaceHolder: "MIN "+ (Math.ceil(Number(_minLoan)*1000000)/1000000).toFixed(2)+" "+'USD' ,
              })
            } else {
              actionType = 'withdraw'
              actionButton = 
                <Button 
                  style={{
                    height: 40, 
                    width: 135, 
                    paddingBottom: 9, 
                    paddingTop: 9, 
                    paddingLeft: 5, 
                    paddingRight: 5,  
                    borderRadius: 5, 
                    backgroundColor: that.state.actionInitButtonBackgroundColor,
                    marginLeft: 20, 
                    justifyContent: 'center',
                  }}
                  disabled={that.state.disableWhileTxn}
                  onClick={() => {
                    if(that.state.freezeButtonsNoVerify){
                       that.setState({ verifyIDOverlay: true })
                    } else {
                      if(that.state.actionValue >= 1){
                        if(that.state.confirmActionPopUp == false && (that.state.actionValue) < parseInt(web3BalancePost, 10) ){
                        
                          that.createWithdrawalReq()
                        }

                      } else {
                        that.setState({ 
                          activityIndicator: 
                            <div style={{ justifyContent: 'center', marginLeft: 0, marginRight: 0, alignItems: 'center', marginTop: 15, marginBottom: 15 }}>
                              <p style={{ color: 'rgba(204, 12, 12, .70)', fontWeight: '600', fontSize: 20, textAlign: 'center', marginBottom: 10, marginTop: 10, textAlignVertical: 'center', textAlign: 'center', }}> 
                                {that.state.selectedLanguage == 'spanish' ? 
                                  'Valor de Transacción debe\nser al menos 1 USD.'
                                    :
                                  'Transaction Value must be\nat least 1 USD.'
                                }
                              </p> 
                            </div>
                        })
                      }
                    }
                  }}
                >
                  <p style={{ fontSize: 17, justifyContent: 'center', alignContent: 'center', fontWeight: '600', color: 'rgba(256, 256, 256, 1)', textAlign: 'center',}}>
                    
                    {that.state.selectedLanguage == 'spanish' ? 
                      'Retirar'
                        :
                      'Withdraw'
                    }
                  </p>
                </Button>     
              that.setState({
                switch: '2',
                actionValue: null,
                activityIndicator: null,
                actionButton,
                actionType,
                actionPlaceHolder: '0.00 USD',
              })
            }
          }
        } else {
          return
        }
  }

  showPass = () => {
    if(that.state.press == false){
      that.setState({ showPass: false, press: true })
    } else {
      that.setState({ showPass: true, press: false })
    }
  }


  render(){
    
    
      const { touched } = that.state;
      const className = touched ? 'button1_touched' : 'button1';


      if(navigationHandler(that.state.navigationDestinationObject)){
          return navigationHandler(that.state.navigationDestinationObject)
      }
      const renderProps = { API, AWS, Amplify, Auth, Bar, BorrowingAccount, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, CartesianGrid, Chart, Component, Container, CryptoJS, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, Radio, React, ResponsiveContainer, Storage, ThreeDot, Tooltip, Web3, XAxis, YAxis, _approverReceivedRepaymentSum, _approversCt, _approversLoanTotal, _availableCreditReadyWithdraw, _balance, _blenderScore, _blockchainBalance, _borrowerInterestPaid, _borrowingRec, _canDeleteCreditLineBool, _compoundedBalance, _compoundedBalanceWEI, _currentUserContribution, _dateCreated, _exitReclaimableValueWei, _fico, _intRate, _joinDate, _lenders, _lendingRate, _lentTotal, _loanRate, _lookupKey, _managerLCase, _minLoan, _offeredLenderCommissionUSD_adjusted, _openValue, _payableValue, _reclaimableValue, _repayRate, _repaymentTotal, _riskCoverage, _safeReclaimableValueWei, _targetValue, _totalBorrowing, _totalContributed, _totalContributedWei, _totalLending, _totalPaid, _totalWithdrawn, _txnSectionHelpText, _userAvgRating, _userContributed, _userFinalized, _userInterestEarned, _values, _valuesONLY, _web3Balance, _weiCompoundedBalance, _withdrawalRate, accountStatsArray, actionButton, actionText, actionType, actionTypeStakingBool, approverCheck, approverReceivedRepaymentSum, approversCount, approversList, availableCredit, availableCreditRatio, availableCredit_unadjusted, awsconfig, axios, blacklisted, blenderCommissionPublicKey, blenderPercentCharge, blenderPrivateKey, blenderScore, blenderTransfersToPublicKey, borrowerInterestPaid, borrowerStatsArray, borrowingRec, buttonColorFlashIntervalDefault, buttonColorFlashIntervalSecondary, buttonText, campaign, checkValidAuthTokenIntervalPeriod_ms, className, client, closureDateFormatted, cognitoID, compoundInterestReceived, compoundedInterestPaid, contractAddress, contractBalance, contractReceipts, contractStructureType, contributeSignatureNeeded, conversionRateGlobal, corporateBackedUsernamesArray, costText, creditUtilizationPerc, currentUser, currentUserLoanTotal, dataIndexDayMap, deploymentAddress, displayValue, dob, emailAddress, ethers, fico, finalRequestsSum, firstName, forexJSON, formattedValueTooltipString, fullAddress, highRateWeb3, imaginaryInsuranceTotal, insuranceTotal, intRate, interactionHeader, interestRate, ipAddress, isCorporateBondBool, isMobile, lastName, lenderCount, lendingRate, loadingTextInterval, loadingTextIntervalCt, loanRate, loanTarget, manager, managerDisplay, managerUsername, maxDayValue, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, minDayValue, minLoan, minimumContribution, monthLengtheningEnum, navigationHandler, netDebt, noDailyDataPointsFoundBool, offeredLenderCommissionUSD, openContracts, openValue, phoneNumber, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, proposeGasPrice, publicKey, rand1, receiptsCt, reclaimableValue, region, repaidRec, repayRate, repaymentSum, requests, requestsCt, riskCoveragePercentage, routeProps, secondaryDisplayCurrency, secondaryDisplayPrice, secretName, settlementDateFormatted, squareCustomerID, streetAddress, targetValue, that, thisContract_CampaignContract, thisContract_CampaignFactoryContract, thisDeploymentAddress, tokenLifeTimeLimit, tooltipInterval, totalBorrowing, totalContributed, totalCreditMax, totalLending, totalPaid, totalValue, totalWithdrawn, touched, transactionValue, useLayoutEffect, useParams, useRef, userContributed, userFinalized, userFinalizedRequestLoanSum, userInterestEarned, userLiquidValue, userLiquidValuePre, userRiskValue, value, valueDelta, web3, web3BalancePost, web3BalancePre, wishlist, wishlistIcon, withdrawalRate };

      if (isMobile) {
        return <BorrowingAccountMobileRender {...renderProps} />;
      }

      return <BorrowingAccountDesktopRender {...renderProps} />;
    }





}


function BorrowingAccount(props){
  const {contractAddress} = useParams();

  return (<BorrowingAccountComponent contractAddress={contractAddress}/>)
}

export default BorrowingAccount;
